import { APIClient } from "./api_helper";

import * as url from "./url_helper";

import { FetchAPI } from "./APIdata/fetchAPI";
import {
  CALL_LEAD_TASK_TYPE_LIST_API,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_API,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_API,
} from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = (data) =>
  api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = (data) => api.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = (data) =>
  api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data) =>
  api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) =>
  api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
// export const postJwtLogin = data => api.create(url.POST_FAKE_JWT_LOGIN, data);
// TESTING:
export const postJwtLogin = (userData) =>
  FetchAPI(url.LOGIN_USER_DATA, "POST", userData);

// postForgetPwd
export const postJwtForgetPwd = (data) =>
  api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
//getNewPassowordRequest
export const getNewPassowordRequest = (data) =>
  FetchAPI(url.GET_NEW_PASSWORD_REQUEST, "GET", data);
//emailPasswordTokenValidationRequest
export const emailPasswordTokenValidationRequest = (data) =>
  FetchAPI(url.EMAIL_PASSWORD_TOKEN_VALIDATION_REQUEST, "GET", data);
//postChangePassword
export const postChangePassword = (data) =>
  FetchAPI(url.POST_CHANGE_PASSWORD, "POST", data);

// postSocialLogin
export const postSocialLogin = (data) => api.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => api.get(url.GET_EVENTS);

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = (event) => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = (event) => api.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = (event) =>
  api.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = (roomId) =>
  api.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = (message) => api.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = (message) =>
  api.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = (forId) =>
  api.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = (product) =>
  api.delete(url.DELETE_PRODUCT + "/" + product);

// add Products
export const addNewProduct = (product) =>
  api.create(url.ADD_NEW_PRODUCT, product);

// update Products
export const updateProduct = (product) =>
  api.update(url.UPDATE_PRODUCT + "/" + product._id, product);

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = (order) => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = (order) =>
  api.update(url.UPDATE_ORDER + "/" + order._id, order);

// delete Order
export const deleteOrder = (order) =>
  api.delete(url.DELETE_ORDER + "/" + order);

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = (customer) =>
  api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = (customer) =>
  api.update(url.UPDATE_CUSTOMER + "/" + customer._id, customer);

// delete Customers
export const deleteCustomer = (customer) =>
  api.delete(url.DELETE_CUSTOMER + "/" + customer);

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

/************************************************/
// Prototyping API Calls
// post update prototype call

export const postUpdatePrototype = (data) =>
  FetchAPI(url.POST_PROTOTYPING_API_CALL, "POST", [data]);
/************************************************/

/************************************************/
//Time Entry API Calls
// Get "TimeEntry List" Api Call
export const getTimeEntryListApiCall = () =>
  FetchAPI(url.GET_TIME_ENTRIES_LIST_API_CALL, "GET");

// POST "TimeEntry List/Open" Api Call
export const postTimeEntryListOpenApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_LIST_OPEN_API_CALL, "POST", data);

// POST "TimeEntry Start" Api Call
export const postTimeEntryStartApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_START_API_CALL, "POST", data);

// POST "TimeEntry Stop" Api Call
export const postTimeEntryStopApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_STOP_API_CALL, "POST", data);

// POST "TimeEntry Search by staff ID" Api Call
export const postTimeEntrySearchByStaffIdApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_SEARCH_BY_STAFF_ID_API_CALL, "POST", data);

// Get "TimeEntry Type List" Api Call
export const getTimeEntryTypeListApiCall = () =>
  FetchAPI(url.GET_TIME_ENTRY_TYPE_LIST_API_CALL, "GET");

// Time Entries Update Single Time Entry Api Call
export const postTimeEntriesUpdateSingleTimeEntryApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_SINGLE_ENTRY_UPDATE_API_CALL, "POST", data);

// Time Entry Search with Today's Date Api Call
export const postTimeEntrySearchWithTodaysDateApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_API_CALL, "POST", data);
//postAddNewTimeEntryNonBillableTypeApiCall
export const postAddNewTimeEntryNonBillableTypeApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL, "POST", data);
//postDeleteTimeEntryNonBillableTypeApiCall
export const postDeleteTimeEntryNonBillableTypeApiCall = (data) =>
  FetchAPI(url.DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL, "DELETE", data);
//postUpdateTimeEntryNonBillableTypeApiCall
export const postUpdateTimeEntryNonBillableTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_API_CALL, "PUT", data);
//postDeleteSelectedTimeEntriesApiCall
export const postDeleteSelectedTimeEntriesApiCall = (data) =>
  FetchAPI(url.DELETE_SELECTED_TIME_ENTRIES_API_CALL, "DELETE", data);
//timeEntryListSummaryDailyApiCall
export const timeEntryListSummaryDailyApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_LIST_SUMMARY_DAILY_API_CALL, "POST", data);
//timeEntryListSummaryDailyByActivityApiCall
export const timeEntryListSummaryDailyByActivityApiCall = (data) =>
  FetchAPI(
    url.TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_API_CALL,
    "POST",
    data
  );
//postTimeEntryCreateApiCall
export const postTimeEntryCreateApiCall = (data) =>
  FetchAPI(url.TIME_ENTRY_CREATE_API_CALL, "POST", data);
/************************************************/

// _Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = (task) => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = (task) =>
  api.update(url.UPDATE_TASK + "/" + task._id, task);

// delete Task
export const deleteTask = (task) => api.delete(url.DELETE_TASK + "/" + task);
// Tasks API Calls
// TasksCrmIt List API
export const getTasksCrmItListApiCall = () =>
  FetchAPI(url.GET_TASKS_CRMIT_LIST_API, "GET");
// TaskCrmIt Create API
export const postTaskCrmItCreateApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TASK_CRMIT_API, "POST", data);
// TaskCrmIt Read API
export const getTaskCrmItReadApiCall = (data) =>
  FetchAPI(url.GET_TASK_CRMIT_API, "GET", data);
// TaskCrmIt Update API
export const postTaskCrmItUpdateApiCall = (data) =>
  FetchAPI(url.UPDATE_TASK_CRMIT_API, "PUT", data);
// TaskCrmIt Delete API
export const postTaskCrmItDeleteApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_CRMIT_API, "DELETE", data);
// TaskCrmIt Claim API (member claims a pooled task; body { Task_Id })
export const postTaskCrmItClaimApiCall = (data) =>
  FetchAPI(url.CLAIM_TASK_CRMIT_API, "POST", data);

// Get Tasks Status List API CALL
export const getTasksStatusListApiCall = () =>
  FetchAPI(url.GET_TASKS_STATUS_LIST_CRMIT_API, "GET");

// Search Task API CALL
export const postSearchTaskListApiCall = (data) =>
  FetchAPI(url.SEARCH_TASK_LIST_API_CALL, "POST", data);
// Get Task Type List API
export const getTaskTypeListApiCall = () =>
  FetchAPI(url.GET_TASK_TYPE_LIST_API, "GET");
// Get Task Priority List API
export const getTaskPriorityListApiCall = () =>
  FetchAPI(url.GET_TASK_PRIORITY_LIST_API, "GET");
// Get Single Task Note API Call
export const getSingleTaskNoteApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_TASK_NOTE_DATA_API, "POST", data);
// Create Single Task Note API Call
export const postCreateSingleTaskNoteApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TASK_NOTE_DATA_API, "POST", data);
//postSearchSingleJobTaskListForTimerApiCall
export const postSearchSingleJobTaskListForTimerApiCall = (data) =>
  FetchAPI(url.SEARCH_TASK_LIST_API_CALL, "POST", data);

// Task Time Entry API Calls
export const postSearchTaskTimeEntryListApiCall = (data) =>
  FetchAPI(url.SEARCH_TASK_TIME_ENTRY_LIST_API, "POST", data);
export const postCreateTaskTimeEntryApiCall = (data) =>
  FetchAPI(url.CREATE_TASK_TIME_ENTRY_API, "POST", data);

//postAddNewTaskStatusApiCall
export const postAddNewTaskStatusApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TASK_STATUS_API_CALL, "POST", data);
// postUpdateTaskStatusApiCall
export const postUpdateTaskStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_TASK_STATUS_API_CALL, "PUT", data);
//postDeleteTaskStatusApiCall
export const postDeleteTaskStatusApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_STATUS_API_CALL, "DELETE", data);
//postAddNewTaskTypeApiCall
export const postAddNewTaskTypeApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TASK_TYPE_API_CALL, "POST", data);
//postUpdateTaskTypeApiCall
export const postUpdateTaskTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_TASK_TYPE_API_CALL, "PUT", data);
//postDeleteTaskTypeApiCall
export const postDeleteTaskTypeApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_TYPE_API_CALL, "DELETE", data);
//postAddNewTaskPriorityApiCall
export const postAddNewTaskPriorityApiCall = (data) =>
  FetchAPI(url.ADD_NEW_TASK_PRIORITY_API_CALL, "POST", data);
//postUpdateTaskPriorityApiCall
export const postUpdateTaskPriorityApiCall = (data) =>
  FetchAPI(url.UPDATE_TASK_PRIORITY_API_CALL, "PUT", data);
//postDeleteTaskPriorityApiCall
export const postDeleteTaskPriorityApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_PRIORITY_API_CALL, "DELETE", data);
//getTaskRecentActivityListApiCall
export const getTaskRecentActivityListApiCall = (data) =>
  FetchAPI(url.GET_TASK_RECENT_ACTIVITY_LIST_API_CALL, "GET", data);
//getTaskChangeLogListApiCall — field-level change history for a Task
export const getTaskChangeLogListApiCall = (data) =>
  FetchAPI(url.GET_TASK_CHANGE_LOG_LIST_API_CALL, "GET", data);
//getActivityLogListApiCall — generic change log for any catalogued entity
export const getActivityLogListApiCall = ({ ObjectTable, id }) =>
  FetchAPI(`${url.ACTIVITY_LOG_LIST_API_CALL}/${ObjectTable}`, "GET", { id });
//getMasterSystemDataStructureCatalogApiCall — Change Tracking admin screen
export const getMasterSystemDataStructureCatalogApiCall = () =>
  FetchAPI(url.MASTER_SYSTEM_DATA_STRUCTURE_CATALOG_API_CALL, "GET");
//putMasterSystemDataStructureFieldUpdateApiCall — toggle per-field tracking
export const putMasterSystemDataStructureFieldUpdateApiCall = (data) =>
  FetchAPI(url.MASTER_SYSTEM_DATA_STRUCTURE_FIELD_UPDATE_API_CALL, "PUT", data);
//getTaskTemplateListApiCall
export const getTaskTemplateListApiCall = () =>
  FetchAPI(url.GET_TASK_TEMPLATE_LIST_API_CALL, "GET");
//getTaskTemplateDataApiCall
export const getTaskTemplateDataApiCall = (data) =>
  FetchAPI(url.GET_TASK_TEMPLATE_DATA_API_CALL, "GET", data);
//postCreateTaskTemplateApiCall
export const postCreateTaskTemplateApiCall = (data) =>
  FetchAPI(url.CREATE_TASK_TEMPLATE_API_CALL, "POST", data);
//postUpdateTaskTemplateApiCall
export const postUpdateTaskTemplateApiCall = (data) =>
  FetchAPI(url.UPDATE_TASK_TEMPLATE_API_CALL, "PUT", data);
//postDeleteTaskTemplateApiCall
export const postDeleteTaskTemplateApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_TEMPLATE_API_CALL, "DELETE", data);
//postSearchTaskTemplateListApiCall
export const postSearchTaskTemplateListApiCall = (data) =>
  FetchAPI(url.SEARCH_TASK_TEMPLATE_LIST_API_CALL, "POST", data);
//getTaskAttachmentListApiCall
export const getTaskAttachmentListApiCall = () =>
  FetchAPI(url.GET_TASK_ATTACHMENT_LIST_API_CALL, "GET");
//postSearchTaskAttachmentListApiCall
export const postSearchTaskAttachmentListApiCall = (data) =>
  FetchAPI(url.SEARCH_TASK_ATTACHMENT_LIST_API_CALL, "POST", data);
//getTaskAttachmentDataApiCall
export const getTaskAttachmentDataApiCall = (data) =>
  FetchAPI(url.GET_TASK_ATTACHMENT_DATA_API_CALL, "GET", data);
//postDeleteTaskAttachmentApiCall
export const postDeleteTaskAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_TASK_ATTACHMENT_API_CALL, "DELETE", data);
// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = (contact) =>
  api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = (contact) =>
  api.update(url.UPDATE_CONTACT + "/" + contact._id, contact);

// delete Contact
export const deleteContact = (contact) =>
  api.delete(url.DELETE_CONTACT + "/" + contact);

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = (company) =>
  api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = (company) =>
  api.update(url.UPDATE_COMPANIES + "/" + company._id, company);

// delete Companies
export const deleteCompanies = (company) =>
  api.delete(url.DELETE_COMPANIES + "/" + company);

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = (lead) => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = (lead) =>
  api.update(url.UPDATE_LEAD + "/" + lead._id, lead);

// delete Lead
export const deleteLead = (lead) => api.delete(url.DELETE_LEAD + "/" + lead);
// API Engine Loop Call
export const apiEngineLoop = () => FetchAPI(url.API_ENGINE_LOOP);

//************************* */
//Jobs

// get Jobs
export const getJobsList = () => FetchAPI(url.GET_JOBS_DATA, "GET");
// add Job
export const addNewJob = (Job) => FetchAPI(url.ADD_JOBS_DATA, "POST", [Job]);
// delete Job

export const deleteJob = (Job) => FetchAPI(url.DELETE_JOBS_DATA, "DELETE", Job);

export const updateJob = (Job) => FetchAPI(url.UPDATE_JOBS_DATA, "PUT", [Job]);
//************************* */
// Single Job
// Create Single Job
export const createSingleJob = (Job) =>
  FetchAPI(url.CREATE_SINGLE_JOB, "POST", [Job]);

// Read Single Job
export const readSingleJob = (Job) => FetchAPI(url.READ_SINGLE_JOB, "GET", Job);

// Update Single Job
export const updateSingleJob = (Job) =>
  FetchAPI(url.UPDATE_SINGLE_JOB, "PUT", [Job]);

// Delete Single Job
export const deleteSingleJob = (Job) =>
  FetchAPI(url.DELETE_SINGLE_JOB, "DELETE", Job);
// Get PDF job sheet single page data
export const getPDFJobSheetSinglePageData = (Job) =>
  FetchAPI(url.GET_JOBS_PDF_DATA, "POST", Job);

// Get Single Job Attachment List APi CAll
export const getSingleJobAttachmentListApiCall = (Job) =>
  FetchAPI(url.GET_SINGLE_JOB_ATTACHMENT_LIST, "POST", Job);

// Get Single Job RecentActivity List APi CAll
// Change #100429 / #100430 - optional { from, to } (yyyy-mm-dd) or { all: 1 }
// alongside { id }. FetchAPI appends "/id" to the URL itself, so with a range
// the whole URL is built here and no payload is passed.
export const getSingleJobRecentActivityListApiCall = (Job) => {
  if (!Job?.from && !Job?.to && !Job?.all && !Job?.recentDays) {
    return FetchAPI(url.GET_SINGLE_JOB_RECENT_ACTIVITY_LIST, "GET", Job);
  }
  const query = new URLSearchParams();
  if (Job.all) query.set("all", "1");
  else if (Job.recentDays) query.set("recent_days", String(Job.recentDays));
  else {
    if (Job.from) query.set("from", Job.from);
    if (Job.to) query.set("to", Job.to);
  }
  return FetchAPI(
    `${url.GET_SINGLE_JOB_RECENT_ACTIVITY_LIST}/${Job.id}?${query.toString()}`,
    "GET",
    null
  );
};
//getSingleJobAttachmentURLApiCall
export const getSingleJobAttachmentURLApiCall = (Job) =>
  FetchAPI(url.GET_SINGLE_JOB_ATTACHMENT_URL, "POST", Job);
//getBillableJobItemsListApiCall
export const getBillableJobItemsListApiCall = (Job) =>
  FetchAPI(url.GET_BILLABLE_JOB_ITEMS_LIST, "POST", Job);
//getBillableJobItemDetailsApiCall
export const getBillableJobItemDetailsApiCall = (Job) =>
  FetchAPI(url.GET_BILLABLE_JOB_ITEM_DETAILS, "GET", Job);
//createBillableJobItemApiCall
export const createBillableJobItemApiCall = (Job) =>
  FetchAPI(url.CREATE_BILLABLE_JOB_ITEM, "POST", Job);
//updateBillableJobItemApiCall
export const updateBillableJobItemApiCall = (Job) =>
  FetchAPI(url.UPDATE_BILLABLE_JOB_ITEM, "PUT", Job);
//deleteBillableJobItemApiCall
export const deleteBillableJobItemApiCall = (Job) =>
  FetchAPI(url.DELETE_BILLABLE_JOB_ITEM, "DELETE", Job);

// Predicted (forecast) billable items on a job
export const getJobPredictedBillableItemsListApiCall = (data) =>
  FetchAPI(url.GET_JOB_PREDICTED_BILLABLE_ITEMS_LIST, "GET", data);
export const createJobPredictedBillableItemApiCall = (data) =>
  FetchAPI(url.CREATE_JOB_PREDICTED_BILLABLE_ITEM, "POST", data);
export const updateJobPredictedBillableItemApiCall = (data) =>
  FetchAPI(url.UPDATE_JOB_PREDICTED_BILLABLE_ITEM, "PUT", data);
// Change #100495 - [{ Id, FlagKeepPredicted }]
export const moveJobPredictedToBillableApiCall = (data) =>
  FetchAPI(url.MOVE_PREDICTED_TO_BILLABLE, "POST", data);
export const deleteJobPredictedBillableItemApiCall = (data) =>
  FetchAPI(url.DELETE_JOB_PREDICTED_BILLABLE_ITEM, "DELETE", data);
// Mark / unmark a predicted billable item as manually billed (no invoice).
// data = [{ Id, Billed }] — Billed 1 = mark, 0 = unmark.
export const predictedMarkBilledApiCall = (data) =>
  FetchAPI(url.PREDICTED_MARK_BILLED_API_CALL, "POST", data);
// Link a predicted billable item to an existing invoice line item.
// data = { JobPredictedBillableItem_Id, InvoiceItem_Id }
export const predictedLinkToInvoiceItemApiCall = (data) =>
  FetchAPI(url.PREDICTED_LINK_TO_INVOICEITEM_API_CALL, "POST", data);

//************************* */
// Single Customer Jobs List Data Api Call
export const getSingleCustomerJobsListDataApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_JOBS_LIST, "POST", data);

//************************* */
// EmailInbound API
// Get EmailInbound List
export const getEmailInboundList = () =>
  FetchAPI(url.GET_EMAILINBOUND_LIST, "GET");

// Get EmailInbound Single Email
export const getEmailInboundSingleEmail = (email) =>
  FetchAPI(url.GET_EMAILINBOUND_SINGLE, "GET", email);
// Archive EmailInbound Mass Emails
export const archiveEmailInboundMassEmails = (emails) =>
  FetchAPI(url.PUT_EMAILINBOUND_ARCHIVE, "PUT", [emails]);
// Mark EmailInbound Mass Emails as Read
export const markEmailInboundMassEmailsAsRead = (emails) =>
  FetchAPI(url.PUT_EMAILINBOUND_MARKEDREAD, "PUT", [emails]);

// Send Email Outbound API
// Get Email Outbound Account List API Call
export const getEmailOutboundAccountListApiCall = () =>
  FetchAPI(url.GET_EMAILOUTBOUND_ACCOUNT_LIST_API, "GET");
// Send Email Outbound
export const sendEmailOutbound = (email) =>
  FetchAPI(url.SEND_EMAILOUTBOUND_EMAIL, "POST", [email]);

// Email inbound staff update pi cal
export const emailInboundStaffUpdateApiCall = (data) =>
  FetchAPI(url.UPDATE_EMAILINBOUND_STAFF, "PUT", data);

// Email Get Archived Email List
export const getArchivedEmailListApiCall = () =>
  FetchAPI(url.GET_ARCHIVED_EMAIL_LIST, "GET");
// Email Inbound Unarchive Email
export const unarchiveEmailApiCall = (email) =>
  FetchAPI(url.UNARCHIVE_EMAILINBOUND_EMAIL, "PUT", [email]);
//markEmailInboundAsUnreadApiCall
export const markEmailInboundAsUnreadApiCall = (email) =>
  FetchAPI(url.MARK_EMAILINBOUND_AS_UNREAD, "PUT", [email]);
//getEmailAccountListApiCall
export const getEmailAccountListApiCall = () =>
  FetchAPI(url.GET_EMAIL_ACCOUNT_LIST_API_CALL, "GET");
//getEmailAccountDetailsApiCall
export const getEmailAccountDetailsApiCall = (data) =>
  FetchAPI(url.GET_EMAIL_ACCOUNT_DETAILS_API_CALL, "GET", data);
//createEmailAccountApiCall
export const createEmailAccountApiCall = (data) =>
  FetchAPI(url.CREATE_EMAIL_ACCOUNT_API_CALL, "POST", data);
//updateEmailAccountApiCall
export const updateEmailAccountApiCall = (data) =>
  FetchAPI(url.UPDATE_EMAIL_ACCOUNT_API_CALL, "PUT", data);
//deleteEmailAccountApiCall
export const deleteEmailAccountApiCall = (data) =>
  FetchAPI(url.DELETE_EMAIL_ACCOUNT_API_CALL, "DELETE", data);
// Change #100151
export const opportunityEmailInboundSearchApiCall = (data) =>
  FetchAPI(url.OPPORTUNITY_EMAIL_INBOUND_SEARCH_API_CALL, "POST", data);
//jobEmailInboundSearchApiCall
export const jobEmailInboundSearchApiCall = (data) =>
  FetchAPI(url.JOB_EMAIL_INBOUND_SEARCH_API_CALL, "POST", data);
//linkJobToEmailApiCall
export const linkJobToEmailApiCall = (data) =>
  FetchAPI(url.LINK_JOB_TO_EMAIL_API_CALL, "POST", data);
//emailOutboundSearchAddressBookApiCall
export const emailOutboundSearchAddressBookApiCall = (data) =>
  FetchAPI(url.EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_API_CALL, "POST", data);
//emailOutboundSearchAvailableAttachmentsApiCall
export const emailOutboundSearchAvailableAttachmentsApiCall = (data) =>
  FetchAPI(
    url.EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_API_CALL,
    "POST",
    data
  );
//emailTemplateListApiCall
export const emailTemplateListApiCall = () =>
  FetchAPI(url.EMAIL_TEMPLATE_LIST_API_CALL, "GET");
//emailTemplateSearchApiCall
export const emailTemplateSearchApiCall = (data) =>
  FetchAPI(url.EMAIL_TEMPLATE_SEARCH_API_CALL, "POST", data);
//getEmailTemplateDataApiCall
export const getEmailTemplateDataApiCall = (data) =>
  FetchAPI(url.GET_EMAIL_TEMPLATE_DATA_API_CALL, "GET", data);
//createEmailTemplateApiCall
export const createEmailTemplateApiCall = (data) =>
  FetchAPI(url.CREATE_EMAIL_TEMPLATE_API_CALL, "POST", data);
//updateEmailTemplateApiCall
export const updateEmailTemplateApiCall = (data) =>
  FetchAPI(url.UPDATE_EMAIL_TEMPLATE_API_CALL, "PUT", data);
//deleteEmailTemplateApiCall
export const deleteEmailTemplateApiCall = (data) =>
  FetchAPI(url.DELETE_EMAIL_TEMPLATE_API_CALL, "DELETE", data);
//sendEmailOutboundScheduledApiCall
export const sendEmailOutboundScheduledApiCall = (data) =>
  FetchAPI(url.SEND_EMAIL_OUTBOUND_SCHEDULED_API_CALL, "POST", data);
//emailDomainListApiCall
export const emailDomainListApiCall = () =>
  FetchAPI(url.EMAIL_DOMAIN_LIST_API_CALL, "GET");
//emailDomainDataApiCall
export const emailDomainDataApiCall = (data) =>
  FetchAPI(url.EMAIL_DOMAIN_DATA_API_CALL, "GET", data);
//createEmailDomainApiCall
export const createEmailDomainApiCall = (data) =>
  FetchAPI(url.CREATE_EMAIL_DOMAIN_API_CALL, "POST", data);
//checkEmailDomainDNSApiCall
export const checkEmailDomainDNSApiCall = (data) =>
  FetchAPI(url.CHECK_EMAIL_DOMAIN_DNS_API_CALL, "GET", data);
//deleteEmailDomainApiCall
export const deleteEmailDomainApiCall = (data) =>
  FetchAPI(url.DELETE_EMAIL_DOMAIN_API_CALL, "DELETE", data);
//emailInboundReplyAutogenerateApiCall
export const emailInboundReplyAutogenerateApiCall = (data) =>
  FetchAPI(url.EMAIL_INBOUND_REPLY_AUTOGENERATE_API_CALL, "POST", data);
//emailInboundRuleListApiCall
export const emailInboundRuleListApiCall = () =>
  FetchAPI(url.EMAIL_INBOUND_RULE_LIST_API_CALL, "GET");
//emailInboundRuleSearchApiCall
export const emailInboundRuleSearchApiCall = (data) =>
  FetchAPI(url.EMAIL_INBOUND_RULE_SEARCH_API_CALL, "POST", data);
//getEmailInboundRuleDataApiCall
export const getEmailInboundRuleDataApiCall = (data) =>
  FetchAPI(url.GET_EMAIL_INBOUND_RULE_DATA_API_CALL, "GET", data);
//createEmailInboundRuleApiCall
export const createEmailInboundRuleApiCall = (data) =>
  FetchAPI(url.CREATE_EMAIL_INBOUND_RULE_API_CALL, "POST", data);
//updateEmailInboundRuleApiCall
export const updateEmailInboundRuleApiCall = (data) =>
  FetchAPI(url.UPDATE_EMAIL_INBOUND_RULE_API_CALL, "PUT", data);
//deleteEmailInboundRuleApiCall
export const deleteEmailInboundRuleApiCall = (data) =>
  FetchAPI(url.DELETE_EMAIL_INBOUND_RULE_API_CALL, "DELETE", data);
//runEmailInboundRuleApiCall — GET /emailinboundrule/run/{id}
export const runEmailInboundRuleApiCall = (data) =>
  FetchAPI(url.RUN_EMAIL_INBOUND_RULE_API_CALL, "GET", data);
//emailInboundRuleItemFieldListApiCall
export const emailInboundRuleItemFieldListApiCall = () =>
  FetchAPI(url.EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_API_CALL, "GET");
//systemFunctionOperandListApiCall
export const systemFunctionOperandListApiCall = () =>
  FetchAPI(url.SYSTEM_FUNCTION_OPERAND_LIST_API_CALL, "GET");
//************************* */
// Invoice API Calls
// Get Invoice List
export const getInvoiceList = () => FetchAPI(url.GET_INVOICE_LIST, "GET");
// Get Invoice Status List

export const getInvoiceStatusList = () =>
  FetchAPI(url.GET_INVOICE_STATUS_List, "GET");

// Get Single Invoice PDF Data
export const getSingleInvoicePDFData = (invoice) =>
  FetchAPI(url.GET_INVOICE_SINGLE_PDF, "POST", invoice);

// Get Single Invoice data
export const getSingleInvoiceData = (invoice) =>
  FetchAPI(url.GET_SINGLE_INVOICE_DATA, "GET", invoice);

// Create Single Invoice Data
export const createSingleInvoiceData = (invoice) =>
  FetchAPI(url.CREATE_SINGLE_INVOICE_DATA, "POST", [invoice]);

// Update Single Invoice Data
export const updateSingleInvoiceData = (invoice) =>
  FetchAPI(url.UPDATE_SINGLE_INVOICE_DATA, "PUT", [invoice]);

// Search Single Customer Invoice List
export const searchSingleCustomerInvoiceList = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_API, "POST", data);

// Resend invoice email api call
export const resendInvoiceEmailApiCall = (data) =>
  FetchAPI(url.RESEND_INVOICE_EMAIL_API_CALL, "GET", data);

// Send Invoice email api call
export const sendInvoiceEmailApiCall = (data) =>
  FetchAPI(url.SEND_INVOICE_EMAIL_API_CALL, "GET", data);

// Void Invoice api call
export const voidInvoiceApiCall = (data) =>
  FetchAPI(url.VOID_INVOICE_API_CALL, "POST", data);
// Re-invoice api call
export const reinvoiceApiCall = (data) =>
  FetchAPI(url.REINVOICE_API_CALL, "POST", data);
//addNewInvoiceStatusApiCall
export const addNewInvoiceStatusApiCall = (data) =>
  FetchAPI(url.ADD_NEW_INVOICE_STATUS_API_CALL, "POST", data);
//deleteInvoiceStatusApiCall
export const deleteInvoiceStatusApiCall = (data) =>
  FetchAPI(url.DELETE_INVOICE_STATUS_API_CALL, "DELETE", data);
//updateInvoiceStatusApiCall
export const updateInvoiceStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_INVOICE_STATUS_API_CALL, "PUT", data);
//getInvoicePaymentMethodListApiCall
export const getInvoicePaymentMethodListApiCall = () =>
  FetchAPI(url.GET_INVOICE_PAYMENT_METHOD_LIST_API_CALL, "GET");
//addNewInvoicePaymentMethodApiCall
export const addNewInvoicePaymentMethodApiCall = (data) =>
  FetchAPI(url.ADD_NEW_INVOICE_PAYMENT_METHOD_API_CALL, "POST", data);
//deleteInvoicePaymentMethodApiCall
export const deleteInvoicePaymentMethodApiCall = (data) =>
  FetchAPI(url.DELETE_INVOICE_PAYMENT_METHOD_API_CALL, "DELETE", data);
//updateInvoicePaymentMethodApiCall
export const updateInvoicePaymentMethodApiCall = (data) =>
  FetchAPI(url.UPDATE_INVOICE_PAYMENT_METHOD_API_CALL, "PUT", data);
//getMasterInvoiceListApiCall
export const getMasterInvoiceListApiCall = () =>
  FetchAPI(url.GET_MASTER_INVOICE_LIST_API_CALL, "GET");
//getMasterInvoiceSingleDataApiCall
export const getMasterInvoiceSingleDataApiCall = (data) =>
  FetchAPI(url.GET_MASTER_INVOICE_SINGLE_DATA_API_CALL, "GET", data);
//getCrmItInvoiceSingleDataApiCall
export const getCrmItInvoiceSingleDataApiCall = (data) =>
  FetchAPI(url.GET_CRMIT_INVOICE_SINGLE_DATA_API_CALL, "GET", data);
//getInvoiceItemListApiCall
export const getInvoiceItemListApiCall = (data) =>
  FetchAPI(url.GET_INVOICE_ITEM_LIST_API_CALL, "GET", data);
//getMasterInvoiceListCustomerApiCall
export const getMasterInvoiceListCustomerApiCall = () =>
  FetchAPI(url.GET_MASTER_INVOICE_LIST_CUSTOMER_API_CALL, "GET");
//searchInvoiceActivityLogApiCall
export const searchInvoiceActivityLogApiCall = (data) =>
  FetchAPI(url.SEARCH_INVOICE_ACTIVITY_LOG_API_CALL, "POST", data);
//searchInvoiceItemsListApiCall
export const searchInvoiceItemsListApiCall = (data) =>
  FetchAPI(url.SEARCH_INVOICE_ITEMS_LIST_API_CALL, "POST", data);
//getJobInvoiceItemTemplateListApiCall
export const getJobInvoiceItemTemplateListApiCall = () =>
  FetchAPI(url.GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_API_CALL, "GET");
//getJobInvoiceItemTemplateDataApiCall
export const getJobInvoiceItemTemplateDataApiCall = (data) =>
  FetchAPI(url.GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_API_CALL, "GET", data);
//searchJobInvoiceItemTemplateApiCall
export const searchJobInvoiceItemTemplateApiCall = (data) =>
  FetchAPI(url.SEARCH_JOB_INVOICE_ITEM_TEMPLATE_API_CALL, "POST", data);
//createJobInvoiceItemTemplateApiCall
export const createJobInvoiceItemTemplateApiCall = (data) =>
  FetchAPI(url.CREATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL, "POST", data);
//updateJobInvoiceItemTemplateApiCall
export const updateJobInvoiceItemTemplateApiCall = (data) =>
  FetchAPI(url.UPDATE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL, "PUT", data);
//deleteJobInvoiceItemTemplateApiCall
export const deleteJobInvoiceItemTemplateApiCall = (data) =>
  FetchAPI(url.DELETE_JOB_INVOICE_ITEM_TEMPLATE_API_CALL, "DELETE", data);
//************************* */
// Get Calendar API calls
// Get Staff leave List
export const getStaffLeaveList = () =>
  FetchAPI(url.GET_STAFF_LEAVE_LIST, "GET");
// Get Staff leave type list
export const getStaffLeaveTypeList = () =>
  FetchAPI(url.GET_STAFF_LEAVE_TYPE, "GET");
//************************* */
// Get Product List API
export const getProductList = () => FetchAPI(url.GET_PRODUCT_LIST, "GET");
// get product unit types list
export const getProductUnitTypesList = () =>
  FetchAPI(url.GET_PRODUCT_UNIT_TYPE_LIST, "GET");
//addProductUnitType
export const addProductUnitType = (data) =>
  FetchAPI(url.ADD_PRODUCT_UNIT_TYPE, "POST", data);
//updateProductUnitType
export const updateProductUnitType = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_UNIT_TYPE, "PUT", data);
//deleteProductUnitType
export const deleteProductUnitType = (data) =>
  FetchAPI(url.DELETE_PRODUCT_UNIT_TYPE, "DELETE", data);
//getProductStockStorageLocationListAPI
export const getProductStockStorageLocationListAPI = () =>
  FetchAPI(url.GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_API, "GET");
//getProductStockStorageLocationDataAPI
export const getProductStockStorageLocationDataAPI = (data) =>
  FetchAPI(url.GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_API, "GET", data);
//createProductStockStorageLocationAPI
export const createProductStockStorageLocationAPI = (data) =>
  FetchAPI(url.CREATE_PRODUCT_STOCK_STORAGE_LOCATION_API, "POST", data);
//updateProductStockStorageLocationAPI
export const updateProductStockStorageLocationAPI = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_API, "PUT", data);
//deleteProductStockStorageLocationAPI
export const deleteProductStockStorageLocationAPI = (data) =>
  FetchAPI(url.DELETE_PRODUCT_STOCK_STORAGE_LOCATION_API, "DELETE", data);
//getProductStockListAPI
export const getProductStockListAPI = () =>
  FetchAPI(url.GET_PRODUCT_STOCK_LIST_API, "GET");
//searchProductStockAPI
export const searchProductStockAPI = (data) =>
  FetchAPI(url.SEARCH_PRODUCT_STOCK_API, "POST", data);
//searchProductStockTransactionAPI
export const searchProductStockTransactionAPI = (data) =>
  FetchAPI(url.SEARCH_PRODUCT_STOCK_TRANSACTION_API, "POST", data);
//getProductStockTransactionListAPI
export const getProductStockTransactionListAPI = () =>
  FetchAPI(url.GET_PRODUCT_STOCK_TRANSACTION_LIST_API, "GET");
//addProductStockTransactionAPI
export const addProductStockTransactionAPI = (data) =>
  FetchAPI(url.ADD_PRODUCT_STOCK_TRANSACTION_API, "POST", data);
//moveProductStockTransactionAPI
export const moveProductStockTransactionAPI = (data) =>
  FetchAPI(url.MOVE_PRODUCT_STOCK_TRANSACTION_API, "POST", data);
//reduceProductStockTransactionAPI
export const reduceProductStockTransactionAPI = (data) =>
  FetchAPI(url.REDUCE_PRODUCT_STOCK_TRANSACTION_API, "POST", data);
//Product Stock Transaction Reason (reduction reason picklist) CRUD
export const getProductStockTransactionReasonListAPI = () =>
  FetchAPI(url.GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_API, "GET");
export const getProductStockTransactionReasonDataAPI = (data) =>
  FetchAPI(url.GET_PRODUCT_STOCK_TRANSACTION_REASON_DATA_API, "GET", data);
export const createProductStockTransactionReasonAPI = (data) =>
  FetchAPI(url.CREATE_PRODUCT_STOCK_TRANSACTION_REASON_API, "POST", data);
export const updateProductStockTransactionReasonAPI = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_API, "PUT", data);
export const deleteProductStockTransactionReasonAPI = (data) =>
  FetchAPI(url.DELETE_PRODUCT_STOCK_TRANSACTION_REASON_API, "DELETE", data);
//getUnitMeasurementListAPI
export const getUnitMeasurementListAPI = () =>
  FetchAPI(url.GET_UNIT_MEASUREMENT_LIST_API, "GET");
//************************* */
// Single Job Notes List and Single data
// Get Single Job Notes List
export const getSingleJobNotesList = (job_id) =>
  FetchAPI(url.GET_JOBS_NOTES_DATA, "POST", [job_id]);
// Get Single Job Notes Single Data
export const getSingleJobNotesSingleData = (Job) =>
  FetchAPI(url.GET_JOBS_NOTES_SINGLE_DATA, "GET", Job);
// Add Single Job Notes
export const addSingleJobNotes = (Job) =>
  FetchAPI(url.ADD_JOBS_NOTES_DATA, "POST", [Job]);

// Get Uninvoiced Jobs List Api Call
export const getUninvoicedJobsListApiCall = () =>
  FetchAPI(url.GET_UNINVOICED_JOBS_LIST, "GET");

//************************* */
//Customer List Data

// get Customer List
export const getCustomerList = () =>
  FetchAPI(url.GET_CUSTOMERS_LIST_DATA, "GET");
// Get Customer Single Data
export const getCustomerSingleData = (Customer) =>
  FetchAPI(url.V2_GET_CUSTOMERS_DATA, "GET", Customer);
// Add Customer
export const addSingleCustomer = (Customer) =>
  FetchAPI(url.V2_ADD_NEW_CUSTOMER, "POST", Customer);
// Update Customer
export const updateSingleCustomer = (Customer) =>
  FetchAPI(url.V2_UPDATE_CUSTOMER, "PUT", Customer);
// Delete Customer
export const deleteSingleCustomer = (Customer) =>
  FetchAPI(url.V2_DELETE_CUSTOMER, "DELETE", Customer);
// Create New Single Customer API Call
export const createNewSingleCustomerApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_CUSTOMER_API, "POST", data);

//Jobs Status
// Create
export const addNewJobStatus = (JobStatus) =>
  FetchAPI(url.ADD_JOB_STATUS_DATA, "POST", JobStatus);
// Read
export const getJobsStatusList = () => FetchAPI(url.GET_JOB_STATUS_DATA, "GET");
// Update
export const updateJobStatus = (JobStatus) =>
  FetchAPI(url.UPDATE_JOB_STATUS_DATA, "PUT", JobStatus);
// Delete
export const deleteJobStatus = (JobStatus) =>
  FetchAPI(url.DELETE_JOB_STATUS_DATA, "DELETE", JobStatus);
//************************* */
// Job Time Entry List
// Get Job Time Entry List
export const getJobTimeEntryList = (job_id) =>
  FetchAPI(url.GET_JOB_TIME_ENTRY_LIST, "POST", [job_id]);

// Create Job Time Entry
export const createJobTimeEntryApiCall = (data) =>
  FetchAPI(url.CREATE_JOB_TIME_ENTRY, "POST", data);

// Job Time Entry Report
export const jobTimeEntryReportAPI = (data) =>
  FetchAPI(url.JOB_TIME_ENTRY_REPORT_API, "POST", data);

// Placement Revenue Report (StaffShift finders fees)
export const placementRevenueReportAPI = (data) =>
  FetchAPI(url.PLACEMENT_REVENUE_REPORT_API, "POST", data);

// Invoicing reports (Task 24523)
export const invoiceVolumesReportAPI = (data) =>
  FetchAPI(url.INVOICE_REPORT_VOLUMES_API, "POST", data);
export const invoiceAgedDebtorsReportAPI = (data) =>
  FetchAPI(url.INVOICE_REPORT_AGED_DEBTORS_API, "POST", data);
export const invoiceCreditNotesReportAPI = (data) =>
  FetchAPI(url.INVOICE_REPORT_CREDIT_NOTES_API, "POST", data);
export const invoiceVatReportAPI = (data) =>
  FetchAPI(url.INVOICE_REPORT_VAT_API, "POST", data);
export const invoicePaymentPerformanceReportAPI = (data) =>
  FetchAPI(url.INVOICE_REPORT_PAYMENT_PERFORMANCE_API, "POST", data);

// Billing line ordering (Task 24532). Body is an array of one object carrying
// Job_Id and the ids in their new order.
export const reorderJobInvoiceItemsApiCall = (data) =>
  FetchAPI(url.JOB_INVOICE_ITEM_REORDER_API, "POST", data);
export const reorderJobPredictedBillableItemsApiCall = (data) =>
  FetchAPI(url.JOB_PREDICTED_BILLABLE_ITEM_REORDER_API, "POST", data);

// Purchase line marked as never billable (Task 24518)
export const markPurchaseItemIgnoredApiCall = (data) =>
  FetchAPI(url.PURCHASE_ITEM_MARK_IGNORED_API, "POST", data);

// Food Pre-Order Events Report
export const foodPreOrderEventReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_API, "POST", data);
export const foodPreOrderEventFunnelReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_FUNNEL_API, "POST", data);
export const foodPreOrderEventRevenueReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_REVENUE_API, "POST", data);
export const foodPreOrderEventMenuItemsReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_MENUITEMS_API, "POST", data);
export const foodPreOrderEventDietaryReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_DIETARY_API, "POST", data);
export const foodPreOrderEventDepositsReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_DEPOSITS_API, "POST", data);
export const foodPreOrderEventUpcomingReportAPI = (data) =>
  FetchAPI(url.FOOD_PREORDER_EVENT_REPORT_UPCOMING_API, "POST", data);

// Food Table Reservation Reports
export const foodTableReservationSummaryReportAPI = (data) =>
  FetchAPI(url.FOOD_TABLE_RESERVATION_REPORT_SUMMARY_API, "POST", data);
export const foodTableReservationPatternsReportAPI = (data) =>
  FetchAPI(url.FOOD_TABLE_RESERVATION_REPORT_PATTERNS_API, "POST", data);
export const foodTableReservationDepositsReportAPI = (data) =>
  FetchAPI(url.FOOD_TABLE_RESERVATION_REPORT_DEPOSITS_API, "POST", data);
export const foodTableReservationListReportAPI = (data) =>
  FetchAPI(url.FOOD_TABLE_RESERVATION_REPORT_LIST_API, "POST", data);
// Turn-downs / standby (Task 24420) — body is an array of one filter object
export const foodTableReservationStandbyReportAPI = (data) =>
  FetchAPI(url.FOOD_TABLE_RESERVATION_STANDBY_REPORT_API, "POST", data);

//************************* */
// Job Type List
// Get Job Type List
export const getJobTypeList = () => FetchAPI(url.GET_JOB_TYPES_LIST, "GET");
//************************* */
// Job Priority List
// Get Job Priority List
export const getJobPriorityList = () =>
  FetchAPI(url.GET_JOB_PRIORITY_LIST, "GET");

// Convert Job To Invoice api call
export const convertJobToInvoiceApiCall = (data) =>
  FetchAPI(url.CONVERT_JOB_TO_INVOICE_API_CALL, "POST", data);
//getRecurringJobsListApiCall
export const getRecurringJobsListApiCall = () =>
  FetchAPI(url.GET_RECURRING_JOBS_LIST, "GET");
//createRecurringJobApiCall
export const createRecurringJobApiCall = (data) =>
  FetchAPI(url.CREATE_RECURRING_JOB_API_CALL, "POST", data);
//getRecurringJobDetailApiCall
export const getRecurringJobDetailApiCall = (data) =>
  FetchAPI(url.GET_RECURRING_JOB_DETAIL_API_CALL, "GET", data);
// updateRecurringJobApiCall
export const updateRecurringJobApiCall = (data) =>
  FetchAPI(url.UPDATE_RECURRING_JOB_API_CALL, "PUT", data);
//uploadJobFilesApiCall
export const uploadJobFilesApiCall = (data) =>
  FetchAPI(url.UPLOAD_JOB_FILES_API_CALL, "POST", data);
//searchSingleJobFilesListApiCall
export const searchSingleJobFilesListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_JOB_FILES_LIST_API_CALL, "POST", data);
//addJobTypeApiCall
export const addJobTypeApiCall = (data) =>
  FetchAPI(url.ADD_JOB_TYPE_API_CALL, "POST", data);
//deleteJobTypeApiCall
export const deleteJobTypeApiCall = (data) =>
  FetchAPI(url.DELETE_JOB_TYPE_API_CALL, "DELETE", data);
//updateJobTypeApiCall
export const updateJobTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_JOB_TYPE_API_CALL, "PUT", data);
//************************* */
// Attachment Category Type List
// Get Attachment Category Type List
export const getAttachmentCategoryTypeList = () =>
  FetchAPI(url.GET_ATTACHMENT_CATEGORY_TYPES_LIST, "GET");
//addAttachmentCategoryTypeApiCall
export const addAttachmentCategoryTypeApiCall = (data) =>
  FetchAPI(url.ADD_ATTACHMENT_CATEGORY_TYPE_API_CALL, "POST", data);
//deleteAttachmentCategoryTypeApiCall
export const deleteAttachmentCategoryTypeApiCall = (data) =>
  FetchAPI(url.DELETE_ATTACHMENT_CATEGORY_TYPE_API_CALL, "DELETE", data);
//updateAttachmentCategoryTypeApiCall
export const updateAttachmentCategoryTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_ATTACHMENT_CATEGORY_TYPE_API_CALL, "PUT", data);
//addJobPriorityApiCall
export const addJobPriorityApiCall = (data) =>
  FetchAPI(url.ADD_JOB_PRIORITY_API_CALL, "POST", data);
//deleteJobPriorityApiCall
export const deleteJobPriorityApiCall = (data) =>
  FetchAPI(url.DELETE_JOB_PRIORITY_API_CALL, "DELETE", data);
//updateJobPriorityApiCall
export const updateJobPriorityApiCall = (data) =>
  FetchAPI(url.UPDATE_JOB_PRIORITY_API_CALL, "PUT", data);
//deleteSingleJobFileApiCall
export const deleteSingleJobFileApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_JOB_FILE_API_CALL, "DELETE", data);
//updateFileAttachmentApiCall
export const updateFileAttachmentApiCall = (data) =>
  FetchAPI(url.UPDATE_FILE_ATTACHMENT_API_CALL, "PUT", data);
//getJobSearchListApiCall
export const getJobSearchListApiCall = (data) =>
  FetchAPI(url.GET_JOB_SEARCH_LIST_API_CALL, "GET", data);
//getJobsOpenListApiCall
export const getJobsOpenListApiCall = () =>
  FetchAPI(url.GET_JOBS_OPEN_LIST_API_CALL, "GET");
//getReadyToInvoiceJobsListApiCall
export const getReadyToInvoiceJobsListApiCall = () =>
  FetchAPI(url.GET_READY_TO_INVOICE_JOBS_LIST_API_CALL, "GET");
//markJobAsCompletedApiCall
export const markJobAsCompletedApiCall = (data) =>
  FetchAPI(url.MARK_JOB_AS_COMPLETED_API_CALL, "PUT", data);
//convertJobToProformaInvoiceApiCall
export const convertJobToProformaInvoiceApiCall = (data) =>
  FetchAPI(url.CONVERT_JOB_TO_PROFORMA_INVOICE_API_CALL, "POST", data);
//invoicesByJobApiCall — expects { id } so the Job_Id is appended as /{id}
export const invoicesByJobApiCall = (data) =>
  FetchAPI(url.INVOICES_BY_JOB_API_CALL, "GET", data);

//************************* */
// auth Register Login

//Register
export const registerUserAPI = (user) =>
  FetchAPI(url.REGISTER_USER_DATA, "post", user);
//Login
export const loginUser = (user) => FetchAPI(url.LOGIN_USER_DATA, "POST", user);

//Token Renew
export const tokenRenew = () => FetchAPI(url.REFRESH_TOKEN_DATA, "POST");
//loginWithTokenKeyAPI
export const loginWithTokenKeyAPI = (data, token) =>
  FetchAPI(url.LOGIN_WITH_TOKEN_KEY, "POST", data, token);
//registerGuestToEventAPI
export const registerGuestToEventAPI = (data, token) =>
  FetchAPI(url.REGISTER_GUEST_TO_EVENT, "POST", data, token);

//************************* */
// Staff CRUD

//     addNewStaff,
//     getStaffData,
//     updateStaff,
//     deleteStaff
// Create
export const addNewStaff = (staff) =>
  FetchAPI(url.ADD_STAFF_DATA, "POST", staff);
// Read
export const getStaffDataAPI = (id) => FetchAPI(url.GET_STAFF_DATA, "GET", id);
// Update
export const updateStaff = (staff) =>
  FetchAPI(url.UPDATE_STAFF_DATA, "PUT", staff);
// Delete
export const deleteStaff = (staff) =>
  FetchAPI(url.DELETE_STAFF_DATA, "DELETE", staff);
//getStaffList
export const getStaffListApi = () => FetchAPI(url.GET_STAFF_LIST, "GET");
//searchStaffIncomeListApi
export const searchStaffIncomeListApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_INCOME_LIST, "POST", data);
//getStaffLeaveTypeListApi
export const getStaffLeaveTypeListApi = () =>
  FetchAPI(url.GET_STAFF_LEAVE_TYPE_LIST, "GET");
//addStaffLeaveTypeApi
export const addStaffLeaveTypeApi = (data) =>
  FetchAPI(url.ADD_STAFF_LEAVE_TYPE, "POST", data);
//updateStaffLeaveTypeApi
export const updateStaffLeaveTypeApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_LEAVE_TYPE, "PUT", data);
//deleteStaffLeaveTypeApi
export const deleteStaffLeaveTypeApi = (data) =>
  FetchAPI(url.DELETE_STAFF_LEAVE_TYPE, "DELETE", data);
//createStaffIncomeApi
export const createStaffIncomeApi = (data) =>
  FetchAPI(url.CREATE_STAFF_INCOME, "POST", data);
//getStaffIncomeCategoryItemListApi
export const getStaffIncomeCategoryItemListApi = () =>
  FetchAPI(url.GET_STAFF_INCOME_CATEGORY_ITEM_LIST, "GET");
//getStaffIncomeCategoryItemDataApi
export const getStaffIncomeCategoryItemDataApi = (data) =>
  FetchAPI(url.GET_STAFF_INCOME_CATEGORY_ITEM_DATA, "GET", data);
//createStaffIncomeCategoryItemApi
export const createStaffIncomeCategoryItemApi = (data) =>
  FetchAPI(url.CREATE_STAFF_INCOME_CATEGORY_ITEM, "POST", data);
//updateStaffIncomeCategoryItemApi
export const updateStaffIncomeCategoryItemApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_INCOME_CATEGORY_ITEM, "PUT", data);
//deleteStaffIncomeCategoryItemApi
export const deleteStaffIncomeCategoryItemApi = (data) =>
  FetchAPI(url.DELETE_STAFF_INCOME_CATEGORY_ITEM, "DELETE", data);
//getStaffIncomeListApi
export const getStaffIncomeListApi = () =>
  FetchAPI(url.GET_STAFF_INCOME_LIST, "GET");
//getStaffIncomeDataApi
export const getStaffIncomeDataApi = (data) =>
  FetchAPI(url.GET_STAFF_INCOME_DATA, "GET", data);
//updateStaffIncomeApi
export const updateStaffIncomeApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_INCOME, "PUT", data);
//deleteStaffIncomeApi
export const deleteStaffIncomeApi = (data) =>
  FetchAPI(url.DELETE_STAFF_INCOME, "POST", data);
//getStaffLeaveListApi
export const getStaffLeaveListApi = () =>
  FetchAPI(url.GET_STAFF_LEAVE_LIST_API, "GET");
//getStaffLeaveDataApi
export const getStaffLeaveDataApi = (data) =>
  FetchAPI(url.GET_STAFF_LEAVE_DATA, "GET", data);
//updateStaffLeaveApi
export const updateStaffLeaveApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_LEAVE, "PUT", data);
//deleteStaffLeaveApi
export const deleteStaffLeaveApi = (data) =>
  FetchAPI(url.DELETE_STAFF_LEAVE, "POST", data);
//createStaffLeaveApi
export const createStaffLeaveApi = (data) =>
  FetchAPI(url.CREATE_STAFF_LEAVE, "POST", data);
//getStaffLeaveCategoryListApi - Task 24489
export const getStaffLeaveCategoryListApi = () =>
  FetchAPI(url.GET_STAFF_LEAVE_CATEGORY_LIST, "GET");
export const updateStaffLeaveCategoryApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_LEAVE_CATEGORY, "PUT", data);
//searchStaffLeaveApi
export const searchStaffLeaveApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_LEAVE, "POST", data);
//seedApprovedStaffLeaveApi
export const seedApprovedStaffLeaveApi = (data) =>
  FetchAPI(url.SEED_APPROVED_STAFF_LEAVE_API, "POST", data);
//getStaffLeaveAllowanceListApi
export const getStaffLeaveAllowanceListApi = () =>
  FetchAPI(url.GET_STAFF_LEAVE_ALLOWANCE_LIST, "GET");
//getStaffLeaveAllowanceDataApi
export const getStaffLeaveAllowanceDataApi = (data) =>
  FetchAPI(url.GET_STAFF_LEAVE_ALLOWANCE_DATA, "GET", data);
//updateStaffLeaveAllowanceApi
export const updateStaffLeaveAllowanceApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_LEAVE_ALLOWANCE, "PUT", data);
//deleteStaffLeaveAllowanceApi
export const deleteStaffLeaveAllowanceApi = (data) =>
  FetchAPI(url.DELETE_STAFF_LEAVE_ALLOWANCE, "POST", data);
//createStaffLeaveAllowanceApi
export const createStaffLeaveAllowanceApi = (data) =>
  FetchAPI(url.CREATE_STAFF_LEAVE_ALLOWANCE, "POST", data);
//searchStaffLeaveAllowanceApi
export const searchStaffLeaveAllowanceApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_LEAVE_ALLOWANCE, "POST", data);
//searchStaffApi
export const searchStaffApi = (data) =>
  FetchAPI(url.SEARCH_STAFF, "POST", data);
//searchStaffMembersApi
export const searchStaffMembersApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_MEMBER_API, "POST", data);
//createStaffAndUserApi
export const createStaffAndUserApi = (data) =>
  FetchAPI(url.CREATE_STAFF_AND_USER_API, "POST", data);
//getOrganisationDepartmentToStaffListApi
export const getOrganisationDepartmentToStaffListApi = () =>
  FetchAPI(url.GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST, "GET");
//getOrganisationDepartmentToStaffDataApi
export const getOrganisationDepartmentToStaffDataApi = (data) =>
  FetchAPI(url.GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA, "GET", data);
//createOrganisationDepartmentToStaffApi
export const createOrganisationDepartmentToStaffApi = (data) =>
  FetchAPI(url.CREATE_ORGANISATION_DEPARTMENT_TO_STAFF, "POST", data);
//searchOrganisationDepartmentToStaffApi
export const searchOrganisationDepartmentToStaffApi = (data) =>
  FetchAPI(url.SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF, "POST", data);
//updateOrganisationDepartmentToStaffApi
export const updateOrganisationDepartmentToStaffApi = (data) =>
  FetchAPI(url.UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF, "PUT", data);
//deleteOrganisationDepartmentToStaffApi
export const deleteOrganisationDepartmentToStaffApi = (data) =>
  FetchAPI(url.DELETE_ORGANISATION_DEPARTMENT_TO_STAFF, "DELETE", data);
//getOrganisationDepartmentListApi
export const getOrganisationDepartmentListApi = () =>
  FetchAPI(url.GET_ORGANISATION_DEPARTMENT_LIST, "GET");
//getOrganisationDepartmentDataApi
export const getOrganisationDepartmentDataApi = (data) =>
  FetchAPI(url.GET_ORGANISATION_DEPARTMENT_DATA, "GET", data);
//createOrganisationDepartmentApi
export const createOrganisationDepartmentApi = (data) =>
  FetchAPI(url.CREATE_ORGANISATION_DEPARTMENT, "POST", data);
//getOrganisationDepartmentHierarchyEnquiryApi
export const getOrganisationDepartmentHierarchyEnquiryApi = () =>
  FetchAPI(url.GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY, "POST");
//updateOrganisationDepartmentApi
export const updateOrganisationDepartmentApi = (data) =>
  FetchAPI(url.UPDATE_ORGANISATION_DEPARTMENT, "PUT", data);
//deleteOrganisationDepartmentApi
export const deleteOrganisationDepartmentApi = (data) =>
  FetchAPI(url.DELETE_ORGANISATION_DEPARTMENT, "DELETE", data);
//getStaffToStaffManagerListApi
export const getStaffToStaffManagerListApi = () =>
  FetchAPI(url.GET_STAFF_TO_STAFF_MANAGER_LIST, "GET");
//getStaffToStaffManagerDataApi
export const getStaffToStaffManagerDataApi = (data) =>
  FetchAPI(url.GET_STAFF_TO_STAFF_MANAGER_DATA, "GET", data);
//createStaffToStaffManagerApi
export const createStaffToStaffManagerApi = (data) =>
  FetchAPI(url.CREATE_STAFF_TO_STAFF_MANAGER, "POST", data);
//updateStaffToStaffManagerApi
export const updateStaffToStaffManagerApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_TO_STAFF_MANAGER, "PUT", data);
//deleteStaffToStaffManagerApi
export const deleteStaffToStaffManagerApi = (data) =>
  FetchAPI(url.DELETE_STAFF_TO_STAFF_MANAGER, "DELETE", data);
//getStaffRecentActivityListApi
export const getStaffRecentActivityListApi = (data) =>
  FetchAPI(url.GET_STAFF_RECENT_ACTIVITY_LIST, "GET", data);
//staffActivityLogSearchApi
export const staffActivityLogSearchApi = (data) =>
  FetchAPI(url.STAFF_ACTIVITY_LOG_SEARCH_API, "POST", data);
//searchStaffRealTimeApi
export const searchStaffRealTimeApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_REAL_TIME, "POST", data);
//getStaffSkillSetListApi
export const getStaffSkillSetListApi = () =>
  FetchAPI(url.GET_STAFF_SKILL_SET_LIST, "GET");
//getStaffSkillSetDataApi
export const getStaffSkillSetDataApi = (data) =>
  FetchAPI(url.GET_STAFF_SKILL_SET_DATA, "GET", data);
//createStaffSkillSetApi
export const createStaffSkillSetApi = (data) =>
  FetchAPI(url.CREATE_STAFF_SKILL_SET, "POST", data);
//updateStaffSkillSetApi
export const updateStaffSkillSetApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_SKILL_SET, "PUT", data);
//deleteStaffSkillSetApi
export const deleteStaffSkillSetApi = (data) =>
  FetchAPI(url.DELETE_STAFF_SKILL_SET, "DELETE", data);
//getStaffToStaffSkillSetListApi
export const getStaffToStaffSkillSetListApi = () =>
  FetchAPI(url.GET_STAFF_TO_STAFF_SKILL_SET_LIST, "GET");
//getActiveStaffToStaffSkillSetListApi
export const getActiveStaffToStaffSkillSetListApi = () =>
  FetchAPI(url.GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST, "GET");
//getExpiredStaffToStaffSkillSetListApi
export const getExpiredStaffToStaffSkillSetListApi = () =>
  FetchAPI(url.GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST, "GET");
//getStaffToStaffSkillSetDataApi
export const getStaffToStaffSkillSetDataApi = (data) =>
  FetchAPI(url.GET_STAFF_TO_STAFF_SKILL_SET_DATA, "GET", data);
//createStaffToStaffSkillSetApi
export const createStaffToStaffSkillSetApi = (data) =>
  FetchAPI(url.CREATE_STAFF_TO_STAFF_SKILL_SET, "POST", data);
//updateStaffToStaffSkillSetApi
export const updateStaffToStaffSkillSetApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_TO_STAFF_SKILL_SET, "PUT", data);
//deleteStaffToStaffSkillSetApi
export const deleteStaffToStaffSkillSetApi = (data) =>
  FetchAPI(url.DELETE_STAFF_TO_STAFF_SKILL_SET, "DELETE", data);
//searchStaffToStaffSkillSetApi
export const searchStaffToStaffSkillSetApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_TO_STAFF_SKILL_SET, "POST", data);
//searchStaffAvailabilityApi
export const searchStaffAvailabilityApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_AVAILABILITY, "POST", data);
//createStaffAvailabilityApiCall
export const createStaffAvailabilityApiCall = (data) =>
  FetchAPI(url.CREATE_STAFF_AVAILABILITY, "POST", data);
// Returns every row for the company - the endpoint takes no filter - so callers
// narrow it to one person themselves.
export const listStaffAvailabilityApiCall = () =>
  FetchAPI(url.LIST_STAFF_AVAILABILITY, "GET", null);
// Customer staff preferences (Task 24563)
export const searchCustomerPreferredStaffApiCall = (data) =>
  FetchAPI(url.SEARCH_CUSTOMER_PREFERRED_STAFF, "POST", data);
export const createCustomerPreferredStaffApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_PREFERRED_STAFF, "POST", data);
export const deleteCustomerPreferredStaffApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_PREFERRED_STAFF, "DELETE", data);
export const deleteStaffAvailabilityApiCall = (data) =>
  FetchAPI(url.DELETE_STAFF_AVAILABILITY, "DELETE", data);
// Change #100559 - edit a blocked-out window in place.
export const updateStaffAvailabilityApiCall = (data) =>
  FetchAPI(url.UPDATE_STAFF_AVAILABILITY, "PUT", data);
//getDiallerLookupApiCall
export const getDiallerLookupApiCall = (data) =>
  FetchAPI(url.SEARCH_DIALLER_LOOKUP_API, "GET", data);
//searchStaffGPSLocationHistoryApi
export const searchStaffGPSLocationHistoryApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_GPS_LOCATION_HISTORY, "POST", data);
// getStaffWorkingScheduleRecordListApi,
export const getStaffWorkingScheduleRecordListApi = () =>
  FetchAPI(url.GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_API, "GET");
//   getStaffWorkingScheduleRecordDataApi,
export const getStaffWorkingScheduleRecordDataApi = (data) =>
  FetchAPI(url.GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_API, "GET", data);
//   createStaffWorkingScheduleRecordApi,
export const createStaffWorkingScheduleRecordApi = (data) =>
  FetchAPI(url.CREATE_STAFF_WORKING_SCHEDULE_RECORD_API, "POST", data);
//   updateStaffWorkingScheduleRecordApi,
export const updateStaffWorkingScheduleRecordApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_WORKING_SCHEDULE_RECORD_API, "PUT", data);
//   deleteStaffWorkingScheduleRecordApi,
export const deleteStaffWorkingScheduleRecordApi = (data) =>
  FetchAPI(url.DELETE_STAFF_WORKING_SCHEDULE_RECORD_API, "DELETE", data);
//   getStaffWorkingScheduleRecordAdjustmentListApi,
export const getStaffWorkingScheduleRecordAdjustmentListApi = () =>
  FetchAPI(url.GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_API, "GET");
//   getStaffWorkingScheduleRecordAdjustmentDataApi,
export const getStaffWorkingScheduleRecordAdjustmentDataApi = (data) =>
  FetchAPI(
    url.GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_API,
    "GET",
    data
  );
//   createStaffWorkingScheduleRecordAdjustmentApi,
export const createStaffWorkingScheduleRecordAdjustmentApi = (data) =>
  FetchAPI(
    url.CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API,
    "POST",
    data
  );
//   updateStaffWorkingScheduleRecordAdjustmentApi,
export const updateStaffWorkingScheduleRecordAdjustmentApi = (data) =>
  FetchAPI(
    url.UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API,
    "PUT",
    data
  );
//   deleteStaffWorkingScheduleRecordAdjustmentApi,
export const deleteStaffWorkingScheduleRecordAdjustmentApi = (data) =>
  FetchAPI(
    url.DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_API,
    "DELETE",
    data
  );
//   getStaffWorkingScheduleListApi,
export const getStaffWorkingScheduleListApi = () =>
  FetchAPI(url.GET_STAFF_WORKING_SCHEDULE_LIST_API, "GET");
//   getStaffWorkingScheduleDataApi,
export const getStaffWorkingScheduleDataApi = (data) =>
  FetchAPI(url.GET_STAFF_WORKING_SCHEDULE_DATA_API, "GET", data);
//   createStaffWorkingScheduleApi,
export const createStaffWorkingScheduleApi = (data) =>
  FetchAPI(url.CREATE_STAFF_WORKING_SCHEDULE_API, "POST", data);
//   updateStaffWorkingScheduleApi,
export const updateStaffWorkingScheduleApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_WORKING_SCHEDULE_API, "PUT", data);
//   deleteStaffWorkingScheduleApi,
export const deleteStaffWorkingScheduleApi = (data) =>
  FetchAPI(url.DELETE_STAFF_WORKING_SCHEDULE_API, "DELETE", data);
//searchStaffWorkingScheduleApi
export const searchStaffWorkingScheduleApi = (data) =>
  FetchAPI(url.SEARCH_STAFF_WORKING_SCHEDULE_API, "POST", data);
//calculateStaffWorkingScheduleApi
export const calculateStaffWorkingScheduleApi = (data) =>
  FetchAPI(url.CALCULATE_STAFF_WORKING_SCHEDULE_API, "POST", data);
//************************* */
//Twilio
//postTwilioPreauth
export const postTwilioPreauthAPI = () =>
  FetchAPI(url.POST_TWILIO_PREAUTH, "GET");
//************************* */
// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = (invoice) =>
  api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = (invoice) =>
  api.update(url.UPDATE_INVOICE + "/" + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = (invoice) =>
  api.delete(url.DELETE_INVOICE + "/" + invoice);

// Support Tickets
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets
export const addNewTicket = (ticket) => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets
export const updateTicket = (ticket) =>
  api.update(url.UPDATE_TICKET + "/" + ticket._id, ticket);

// delete Tickets
export const deleteTicket = (ticket) =>
  api.delete(url.DELETE_TICKET + "/" + ticket);

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => api.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => api.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => api.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () =>
  api.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () =>
  api.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () =>
  api.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () =>
  api.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => api.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => api.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () =>
  api.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () =>
  api.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => api.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () =>
  api.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () =>
  api.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () =>
  api.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => api.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () =>
  api.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () =>
  api.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () =>
  api.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => api.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => api.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => api.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => api.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => api.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => api.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => api.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => api.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () =>
  api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);

// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => api.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => api.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => api.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => api.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => api.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => api.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => api.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => api.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => api.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => api.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () =>
  api.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => api.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () =>
  api.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () =>
  api.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () =>
  api.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () =>
  api.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => api.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () =>
  api.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () =>
  api.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () =>
  api.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project) =>
  api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project) =>
  api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project) =>
  api.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = (team) => api.get(url.GET_TEAMDATA, team);
export const deleteTeamData = (team) =>
  api.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team) => api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team) => api.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = (folder) => api.get(url.GET_FOLDERS, folder);
export const deleteFolder = (folder) =>
  api.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder) => api.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder) => api.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = (file) => api.get(url.GET_FILES, file);
export const deleteFile = (file) =>
  api.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file) => api.create(url.ADD_NEW_FILE, file);
export const updateFile = (file) => api.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = (todo) => api.get(url.GET_TODOS, todo);
export const deleteTodo = (todo) =>
  api.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo) => api.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo) => api.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = (project) => api.get(url.GET_PROJECTS, project);
export const addNewProject = (project) =>
  api.create(url.ADD_NEW_TODO_PROJECT, project);

//Loyalty  API Call'S
//Loyalty List API Call
export const getLoyaltyListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_LIST_API, "GET");

// Loyalty Single Customer API Call
export const getLoyaltySingleCustomerApiCall = (id) =>
  FetchAPI(url.GET_LOYALTY_SINGLE_CUSTOMER_DATA_API, "POST", id);
// Loyalty Single Customer Balance Search API Call
export const getLoyaltySingleCustomerBalanceSearchApiCall = (id) =>
  FetchAPI(url.LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_API, "POST", id);

// Loyalty Balances List API Call
export const getLoyaltyBalancesListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_BALANCES_LIST_API, "GET");

// Loyalty Vouchers List Api Call
export const getLoyaltyVouchersListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_VOUCHERS_LIST_API, "GET");

// Loyalty Dashboard Recent activity api call
export const getLoyaltyDashboardRecentActivityApiCall = () =>
  FetchAPI(url.GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_API, "GET");

// Loyalty Dashboard Report Data Search API Call
export const getLoyaltyDashboardReportDataSearchApiCall = (data) =>
  FetchAPI(url.SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_API, "POST", data);

// Business Overview Dashboard Data API Call
export const getBusinessOverviewDataApiCall = (data) =>
  FetchAPI(url.BUSINESS_OVERVIEW_DATA_API, "POST", data);

// Create Loyalty Transaction API Call
export const createLoyaltyTransactionApiCall = (data) =>
  FetchAPI(url.CREATE_LOYALTY_TRANSACTION_API, "POST", data);
// Loyalty Create Voucher Amount API Call
export const createLoyaltyVoucherAmountApiCall = (data) =>
  FetchAPI(url.CREATE_LOYALTY_VOUCHER_AMOUNT_API, "POST", data);
// Loyalty Redeem Voucher Amount API Call
export const redeemLoyaltyVoucherAmountApiCall = (data) =>
  FetchAPI(url.REDEEM_LOYALTY_VOUCHER_API, "POST", data);
// Void Voucher API Call
export const voidVoucherApiCall = (data) =>
  FetchAPI(url.VOID_LOYALTY_VOUCHER_API, "POST", data);
// Loyalty VOucher Resend API Call
export const resendLoyaltyVoucherApiCall = (data) =>
  FetchAPI(url.RESEND_LOYALTY_VOUCHER_API, "POST", data);
// Loyalty Voucher Single Customer Voucher List
export const getLoyaltySingleCustomerVoucherListApiCall = (data) =>
  FetchAPI(url.GET_LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_API, "POST", data);

// Loyalty Spinner API Calls
export const getLoyaltySpinnerListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_SPINNER_LIST_API, "GET");

export const createLoyaltySpinnerApiCall = (data) =>
  FetchAPI(url.CREATE_LOYALTY_SPINNER_API, "POST", data);

export const updateLoyaltySpinnerApiCall = (data) =>
  FetchAPI(url.UPDATE_LOYALTY_SPINNER_API, "PUT", data);

export const deleteLoyaltySpinnerApiCall = (data) =>
  FetchAPI(url.DELETE_LOYALTY_SPINNER_API, "DELETE", data);

export const getLoyaltySpinnerRenderApiCall = (id) =>
  FetchAPI(`${url.GET_LOYALTY_SPINNER_RENDER_API}/${id}`, "GET");

export const getLoyaltySpinnerDataApiCall = (id) =>
  FetchAPI(`${url.GET_LOYALTY_SPINNER_DATA_API}/${id}`, "GET");

export const executeLoyaltySpinnerApiCall = (data) =>
  FetchAPI(url.EXECUTE_LOYALTY_SPINNER_API, "POST", data);

// Task 24787 - deliberately not wired through redux: the unlock token it
// returns is a short-lived secret and has no business sitting in the store.
export const verifyLoyaltySpinnerPinApiCall = (data) =>
  FetchAPI(url.VERIFY_LOYALTY_SPINNER_PIN_API, "POST", data);

// Loyalty Portal admin CRUD API Calls
export const getLoyaltyPortalListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_PORTAL_LIST_API, "GET");

export const getLoyaltyPortalDataApiCall = (id) =>
  FetchAPI(`${url.GET_LOYALTY_PORTAL_DATA_API}/${id}`, "GET");

export const createLoyaltyPortalApiCall = (data) =>
  FetchAPI(url.CREATE_LOYALTY_PORTAL_API, "POST", data);

export const updateLoyaltyPortalApiCall = (data) =>
  FetchAPI(url.UPDATE_LOYALTY_PORTAL_API, "PUT", data);

export const deleteLoyaltyPortalApiCall = (data) =>
  FetchAPI(url.DELETE_LOYALTY_PORTAL_API, "DELETE", data);

// Loyalty Scheme list (for the portal admin dropdown)
export const getLoyaltySchemeListApiCall = () =>
  FetchAPI(url.GET_LOYALTY_SCHEME_LIST_API, "GET");

// Navigation Menu Api Calls
// Get Navigation Menu
export const getNavigationMenuApiCall = (data) =>
  FetchAPI(url.GET_NAVIGATION_MENU, "POST", data);
//getMenuNavigationListApiCall
export const getMenuNavigationListApiCall = () =>
  FetchAPI(url.GET_MENU_NAVIGATION_LIST_API, "GET");
//createSingleMenuNavigationApiCall
export const createSingleMenuNavigationApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_MENU_NAVIGATION_API, "POST", data);
//updateSingleMenuNavigationApiCall
export const updateSingleMenuNavigationApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_MENU_NAVIGATION_API, "PUT", data);
//deleteSingleMenuNavigationApiCall
export const deleteSingleMenuNavigationApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_MENU_NAVIGATION_API, "DELETE", data);
//getAvailableMenuNavigationItemsApiCall
export const getAvailableMenuNavigationItemsApiCall = () =>
  FetchAPI(url.GET_AVAILABLE_MENU_NAVIGATION_ITEMS_API, "GET");
//getSingleNavigationMenuApiCall
export const getSingleNavigationMenuApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_NAVIGATION_MENU_API, "GET", data);
//getMenuItemListApiCall
export const getMenuItemListApiCall = () =>
  FetchAPI(url.GET_MENU_ITEM_LIST_API, "GET");
//getSingleMenuItemDataApiCall
export const getSingleMenuItemDataApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_MENU_ITEM_DATA_API, "GET", data);
//createSingleMenuItemApiCall
export const createSingleMenuItemApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_MENU_ITEM_API, "POST", data);
//updateSingleMenuItemApiCall
export const updateSingleMenuItemApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_MENU_ITEM_API, "PUT", data);
//deleteSingleMenuItemApiCall
export const deleteSingleMenuItemApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_MENU_ITEM_API, "DELETE", data);
//createMasterMenuNavItemApiCall
export const createMasterMenuNavItemApiCall = (data) =>
  FetchAPI(url.CREATE_MASTER_MENU_NAV_ITEM_API, "POST", data);
// Global menus - Task 24886
export const getMasterMenuNavListApiCall = () =>
  FetchAPI(url.GET_MASTER_MENU_NAV_LIST_API, "GET");
export const getMasterMenuNavDataApiCall = (data) =>
  FetchAPI(url.GET_MASTER_MENU_NAV_DATA_API, "GET", data);
export const createMasterMenuNavApiCall = (data) =>
  FetchAPI(url.CREATE_MASTER_MENU_NAV_API, "POST", data);
export const updateMasterMenuNavApiCall = (data) =>
  FetchAPI(url.UPDATE_MASTER_MENU_NAV_API, "PUT", data);
export const deleteMasterMenuNavApiCall = (data) =>
  FetchAPI(url.DELETE_MASTER_MENU_NAV_API, "DELETE", data);
export const rolloutMasterMenuNavApiCall = (data) =>
  FetchAPI(url.ROLLOUT_MASTER_MENU_NAV_API, "POST", data);
//Bank API Call'S

//Bank List API Call
export const getBankListApiCall = () => FetchAPI(url.GET_BANK_LIST, "GET");

//SingleBank Transaction API Call
export const getSingleBankTransactionApiCall = (id) =>
  FetchAPI(url.SINGLE_BANK_TRANSACTION_LIST, "POST", id);
// All Banks Transaction List API Call

export const getAllBanksTransactionListApiCall = () =>
  FetchAPI(url.ALL_BANK_TRANSACTION_LIST, "GET");

// Bank UnAllocated Transaction List API Call
export const getBankUnAllocatedTransactionListApiCall = () =>
  FetchAPI(url.BANK_UNALLOCATED_TRANSACTION_LIST, "GET");
// Bank UnAllocated Item List API Call
export const getBankUnAllocatedItemListApiCall = (data) =>
  FetchAPI(url.BANK_UNALLOCATED_ITEM_LIST, "POST", data);
// Bank Clear Transaction and Item Recquest API Call
export const getBankClearTransactionAndItemRecquestApiCall = (data) =>
  FetchAPI(url.BANK_CLEAR_TRANSACTION_AND_ITEM_REQUEST_API, "POST", data);
// Bank UnClear Transaction and Item Recquest API Call
export const getBankUnClearTransactionAndItemRecquestApiCall = (data) =>
  FetchAPI(url.BANK_UNCLEAR_TRANSACTION_AND_ITEM_REQUEST_API, "POST", data);
// Bank Search Single Customer Transaction request API Call
export const getCustomerSearchAllTransactionsApiCall = (data) =>
  FetchAPI(
    url.BANK_SEARCH_SINGLE_CUSTOMER_ALL_TRANSACTIONS_REQUEST_API,
    "POST",
    data
  );
// Bank Search Single Supplier Transaction requst api call
export const getSupplierSearchAllTransactionsApiCall = (data) =>
  FetchAPI(
    url.BANK_SEARCH_SINGLE_SUPPLIER_ALL_TRANSACTIONS_REQUEST_API,
    "POST",
    data
  );
// Create Bank Transaction API Call
export const getCreateSingleBankTransactionApiCall = (data) =>
  FetchAPI(url.CREATE_BANK_TRANSACTION_API, "POST", data);
// Bank Single Customer Transaction PDF statement API Call
export const getBankSingleCustomerTransactionStatmentPdfApiCall = (data) =>
  FetchAPI(url.BANK_SINGLE_CUSTOMER_PDF_TRANSACTION_STATEMENT_API, "GET", data);
// Bank upload transactions file API Call
export const getBankUploadTransactionsFileApiCall = (data) =>
  FetchAPI(url.BANK_UPLOAD_TRANSACTIONS_FILE_API, "POST", data);
// Assigned Only Bank Transaction List API Call
export const getAssignedOnlyBankTransactionListApiCall = () =>
  FetchAPI(url.ASSIGNED_ONLY_BANK_TRANSACTION_LIST_API, "GET");
// Bank Assign Transaction to Customer API Call
export const getBankAssignTransactionToCustomerApiCall = (data) =>
  FetchAPI(url.BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_API, "POST", data);
// Bank Unassign transaction from customer API Call
export const getBankUnassignTransactionFromCustomerApiCall = (data) =>
  FetchAPI(url.BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_API, "POST", data);
// getCreateBankApiCall
export const getCreateBankApiCall = (data) =>
  FetchAPI(url.CREATE_BANK_API, "POST", data);
// getUpdateBankApiCall
export const getUpdateBankApiCall = (data) =>
  FetchAPI(url.UPDATE_BANK_API, "PUT", data);
//getDeleteBankApiCall
export const getDeleteBankApiCall = (id) =>
  FetchAPI(url.DELETE_BANK_API, "DELETE", id);
// syncBankTransactionsApiCall — POST /bankaccount/synctransactions/{bankAccountId}
export const syncBankTransactionsApiCall = (id) =>
  FetchAPI(`${url.SYNC_BANK_TRANSACTIONS_API}/${id}`, "POST");

//getSingleCustomerTransactionOpenItemsPdfApiCall
export const getSingleCustomerTransactionOpenItemsPdfApiCall = (data) =>
  FetchAPI(url.SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_API, "GET", data);
//getSingleCustomerTransactionAllItemsPdfApiCall
export const getSingleCustomerTransactionAllItemsPdfApiCall = (data) =>
  FetchAPI(url.SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_API, "GET", data);
//getBankAccountStatusListApiCall
export const getBankAccountStatusListApiCall = () =>
  FetchAPI(url.GET_BANK_ACCOUNT_STATUS_LIST_API, "GET");
//getBankTransactionAllocationDeleteTransactionApiCall
export const getBankTransactionAllocationDeleteTransactionApiCall = (data) =>
  FetchAPI(
    url.BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_API,
    "DELETE",
    data
  );
//getManualBankTransactionDetailsApiCall
export const getManualBankTransactionDetailsApiCall = (data) =>
  FetchAPI(url.MANUAL_BANK_TRANSACTION_DETAILS_API, "GET", data);
//getUpdateManualBankTransactionDetailsApiCall
export const getUpdateManualBankTransactionDetailsApiCall = (data) =>
  FetchAPI(url.UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_API, "PUT", data);
//getBankAccountProviderListApiCall
export const getBankAccountProviderListApiCall = () =>
  FetchAPI(url.GET_BANK_ACCOUNT_PROVIDER_LIST_API, "GET");
//getBankAccountStatusDataApiCall
export const getBankAccountStatusDataApiCall = (data) =>
  FetchAPI(url.GET_BANK_ACCOUNT_STATUS_DATA_API, "GET", data);
//createBankAccountStatusApiCall
export const createBankAccountStatusApiCall = (data) =>
  FetchAPI(url.CREATE_BANK_ACCOUNT_STATUS_API, "POST", data);
//updateBankAccountStatusApiCall
export const updateBankAccountStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_BANK_ACCOUNT_STATUS_API, "PUT", data);
//deleteBankAccountStatusApiCall
export const deleteBankAccountStatusApiCall = (data) =>
  FetchAPI(url.DELETE_BANK_ACCOUNT_STATUS_API, "DELETE", data);
//getBankAccountFeedConnectionApiCall
export const getBankAccountFeedConnectionApiCall = (data) =>
  FetchAPI(url.CREATE_BANK_ACCOUNT_FEED_CONNECTION_API, "POST", data);
//getBankAccountFeedMapAccountsApiCall
export const getBankAccountFeedMapAccountsApiCall = (data) =>
  FetchAPI(url.BANK_ACCOUNT_FEED_MAP_ACCOUNTS_API, "POST", data);
//getBankTransactionImportApiCall
export const getBankTransactionImportApiCall = (data) =>
  FetchAPI(url.BANK_TRANSACTION_IMPORT_API, "POST", data);
//getBankTransactionAllocationUnclearApiCall
export const getBankTransactionAllocationUnclearApiCall = (data) =>
  FetchAPI(url.BANK_TRANSACTION_ALLOCATION_UNCLEAR_API, "POST", data);
//getBankTransactionAllocationSplitApiCall
export const getBankTransactionAllocationSplitApiCall = (data) =>
  FetchAPI(url.BANK_TRANSACTION_ALLOCATION_SPLIT_API, "POST", data);
//getBankAccountFeedReconnectionApiCall
export const getBankAccountFeedReconnectionApiCall = (data) =>
  FetchAPI(url.BANK_ACCOUNT_FEED_RECONNECTION_API, "POST", data);
//searchClearingDocumentApiCall
export const searchClearingDocumentApiCall = (data) =>
  FetchAPI(url.SEARCH_CLEARING_DOCUMENT_API, "POST", data);
// *************************************************************
// Communication / Notification settings
export const getCommunicationListApiCall = () =>
  FetchAPI(url.GET_COMMUNICATION_LIST_API, "GET");
export const getCommunicationChannelListApiCall = () =>
  FetchAPI(url.GET_COMMUNICATION_CHANNEL_LIST_API, "GET");
export const createCommunicationChannelApiCall = (data) =>
  FetchAPI(url.CREATE_COMMUNICATION_CHANNEL_API, "POST", data);
export const updateCommunicationChannelApiCall = (data) =>
  FetchAPI(url.UPDATE_COMMUNICATION_CHANNEL_API, "PUT", data);
export const getCommunicationPlaceholderListApiCall = () =>
  FetchAPI(url.GET_COMMUNICATION_PLACEHOLDER_LIST_API, "GET");
export const getNotificationTemplateListApiCall = () =>
  FetchAPI(url.GET_NOTIFICATION_TEMPLATE_LIST_API, "GET");
// Change #100528 - query = "?Communication_Id=5" (optional)
export const listCommunicationSubscriberApi = (query) =>
  FetchAPI(url.LIST_COMMUNICATION_SUBSCRIBER_API + (query || ""), "GET");
export const createCommunicationSubscriberApi = (data) =>
  FetchAPI(url.CREATE_COMMUNICATION_SUBSCRIBER_API, "POST", data);
export const updateCommunicationSubscriberApi = (data) =>
  FetchAPI(url.UPDATE_COMMUNICATION_SUBSCRIBER_API, "PUT", data);
// data = [Id, ...]
export const deleteCommunicationSubscriberApi = (data) =>
  FetchAPI(url.DELETE_COMMUNICATION_SUBSCRIBER_API, "DELETE", data);

//SMS
//getSmsTemplates
export const getSmsTemplatesApiCall = () =>
  FetchAPI(url.GET_SMS_TEMPLATES_API, "GET");
//getSmsTemplateDetails
export const getSmsTemplateDetailsApiCall = (data) =>
  FetchAPI(url.GET_SMS_TEMPLATE_DETAILS, "GET", data);
//addSmsTemplate
export const addSmsTemplateApiCall = (data) =>
  FetchAPI(url.ADD_SMS_TEMPLATE, "POST", data);
//updateSmsTemplate
export const updateSmsTemplateApiCall = (data) =>
  FetchAPI(url.UPDATE_SMS_TEMPLATE, "PUT", data);
//deleteSmsTemplate
export const deleteSmsTemplateApiCall = (data) =>
  FetchAPI(url.DELETE_SMS_TEMPLATE, "DELETE", data);
//sendSmsOutboundApiCall
export const sendSmsOutboundApiCall = (data) =>
  FetchAPI(url.SEND_SMS_OUTBOUND_API_CALL, "POST", data);
//getSmsAddressBookApiCall
export const getSmsAddressBookApiCall = (data) =>
  FetchAPI(url.GET_SMS_ADDRESS_BOOK_API_CALL, "POST", data);
// *************************************************************

//getBankTransactionAllocationAutoClearApiCall
export const getBankTransactionAllocationAutoClearApiCall = (data) =>
  FetchAPI(url.BANK_TRANSACTION_ALLOCATION_AUTO_CLEAR_API_CALL, "POST", data);

///************************************* */
// People API Call'S

//Single Company Search People List Api CAll
export const getSingleCompanySearchPeopleListApiCall = (id) =>
  FetchAPI(url.SINGLE_COMPANY_CONTACT_PERSON_SEARCH_API, "POST", id);
//createContactPersonApiCall
export const createContactPersonApiCall = (data) =>
  FetchAPI(url.CREATE_CONTACT_PERSON_API, "POST", data);
//linkEmailToContactPersonApiCall - Task 24737. Either attaches the address to an
//existing contact (CustomerToContactPersonRelationship_Id) or creates one and links
//it to Customer_Id[]. Returns address-book-shaped rows for rebuilding the chip.
export const linkEmailToContactPersonApiCall = (data) =>
  FetchAPI(url.LINK_EMAIL_TO_CONTACT_PERSON_API, "POST", data);
// getSinglePersonContactDetailsApiCall
export const getSinglePersonContactDetailsApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_PERSON_CONTACT_DETAILS_API, "GET", id);
//deleteContactPersonApiCall
export const deleteContactPersonApiCall = (id) =>
  FetchAPI(url.DELETE_CONTACT_PERSON_API, "DELETE", id);
//updateContactPersonApiCall
export const updateContactPersonApiCall = (data) =>
  FetchAPI(url.UPDATE_CONTACT_PERSON_API, "PUT", data);
//deleteContactPersonRelationshipApiCall
export const deleteContactPersonRelationshipApiCall = (data) =>
  FetchAPI(url.DELETE_CONTACT_PERSON_RELATIONSHIP_API, "DELETE", data);
//contactPersonToEmailInboundSearchAPICall
export const contactPersonToEmailInboundSearchAPICall = (data) =>
  FetchAPI(url.CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH_API, "POST", data);
//contactPersonToEmailInboundDataAPICall
export const contactPersonToEmailInboundDataAPICall = (data) =>
  FetchAPI(url.CONTACT_PERSON_TO_EMAIL_INBOUND_DATA_API, "GET", data);
//contactPersonDataAPICall
export const contactPersonDataAPICall = (data) =>
  FetchAPI(url.CONTACT_PERSON_DATA_API, "GET", data);
//contactPersonListAPICall
export const contactPersonListAPICall = () =>
  FetchAPI(url.CONTACT_PERSON_LIST_API, "GET");
//searchPersonWithCustomerIdAPICall
export const searchPersonWithCustomerIdAPICall = (data) =>
  FetchAPI(url.SEARCH_PERSON_WITH_CUSTOMER_ID_API, "POST", data);

// Site Wide search get all data API Call
export const getSiteWideSearchAllDataApiCall = (data) =>
  FetchAPI(url.GET_SITE_WIDE_SEARCH_RESULTS, "GET", data);

// Advanced search (POST filter body). `data` must not contain a top-level `id` key.
export const advancedSearchApiCall = (data) =>
  FetchAPI(url.ADVANCED_SEARCH_RESULTS, "POST", data);

// Notification API Call'S

// Get Notification Open List Api Call
export const getNotificationOpenListApiCall = (data) =>
  FetchAPI(url.GET_NOTIFICATION_OPEN_LIST_API, "GET", data);
//systemNotificationInternalSendApiCall
export const systemNotificationInternalSendApiCall = (data) =>
  FetchAPI(url.SYSTEM_NOTIFICATION_INTERNAL_SEND_API, "POST", data);

// Shortcuts Apps API Call'S

// Get Shortcuts Apps List Api Call
export const getShortcutsAppsListApiCall = () =>
  FetchAPI(url.GET_SHORTCUT_APPS_LIST, "GET");
//getShortcutAppDataApiCall
export const getShortcutAppDataApiCall = (id) =>
  FetchAPI(url.GET_SHORTCUT_APP_DATA_API, "GET", id);
//createShortcutAppDataApiCall
export const createShortcutAppDataApiCall = (data) =>
  FetchAPI(url.CREATE_SHORTCUT_APP_DATA_API, "POST", data);
//updateShortcutAppDataApiCall
export const updateShortcutAppDataApiCall = (data) =>
  FetchAPI(url.UPDATE_SHORTCUT_APP_DATA_API, "PUT", data);
//deleteShortcutAppDataApiCall
export const deleteShortcutAppDataApiCall = (id) =>
  FetchAPI(url.DELETE_SHORTCUT_APP_DATA_API, "DELETE", id);

// Product List API Call
// Get Product List Api Call
export const getProductListApiCall = () =>
  FetchAPI(url.GET_PRODUCTS_LIST_API_CALL, "GET");
//getProductSelfServeWidgetRenderApiCall
export const getProductSelfServeWidgetRenderApiCall = (data) =>
  FetchAPI(url.GET_PRODUCT_SELF_SERVE_WIDGET_RENDER, "GET", data);
//postProductSelfServePublicBookApiCall — public, no auth required
export const postProductSelfServePublicBookApiCall = (data) =>
  FetchAPI(url.POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK, "POST", data);
//postProductSelfServeWidgetCheckAvailabilityApiCall
export const postProductSelfServeWidgetCheckAvailabilityApiCall = (data) =>
  FetchAPI(url.POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY, "POST", data);
//  getProductDetailApiCall
export const getProductDetailApiCall = (id) =>
  FetchAPI(url.GET_PRODUCT_DETAIL_API_CALL, "GET", id);
//     addProductApiCall,
export const addProductApiCall = (data) =>
  FetchAPI(url.ADD_PRODUCT_API_CALL, "POST", data);
//     updateProductApiCall
export const updateProductApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_API_CALL, "PUT", data);
//     deleteProductApiCall
export const deleteProductApiCall = (id) =>
  FetchAPI(url.DELETE_PRODUCT_API_CALL, "DELETE", id);
//searchProductsAllowedTimeTrackingApiCall
export const searchProductsAllowedTimeTrackingApiCall = (data) =>
  FetchAPI(url.SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_API_CALL, "POST", data);
//searchProductsPricingApiCall
export const searchProductsPricingApiCall = (data) =>
  FetchAPI(url.SEARCH_PRODUCTS_PRICING_API_CALL, "POST", data);
//createProductsPricingApiCall
export const createProductsPricingApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCTS_PRICING_API_CALL, "POST", data);
//updateProductsPricingApiCall
export const updateProductsPricingApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCTS_PRICING_API_CALL, "PUT", data);
//deleteProductsPricingApiCall
export const deleteProductsPricingApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCTS_PRICING_API_CALL, "DELETE", data);
//getProductsPricingDataApiCall
export const getProductsPricingDataApiCall = (data) =>
  FetchAPI(url.GET_PRODUCTS_PRICING_DATA_API_CALL, "GET", data);
//getProductsRecentActivityApiCall
export const getProductsRecentActivityApiCall = (data) =>
  FetchAPI(url.GET_PRODUCTS_RECENT_ACTIVITY_API_CALL, "GET", data);
//getProductsPricingListApiCall
export const getProductsPricingListApiCall = () =>
  FetchAPI(url.GET_PRODUCTS_PRICING_LIST_API_CALL, "GET");
// Task 24858 - the product's own dated price schedule (ProductPrice), not the
// customer bespoke price (ProductPricing) above.
//searchProductPriceApiCall
export const searchProductPriceApiCall = (data) =>
  FetchAPI(url.SEARCH_PRODUCT_PRICE_API_CALL, "POST", data);
//createProductPriceApiCall
export const createProductPriceApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCT_PRICE_API_CALL, "POST", data);
//updateProductPriceApiCall
export const updateProductPriceApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_PRICE_API_CALL, "PUT", data);
//deleteProductPriceApiCall
export const deleteProductPriceApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCT_PRICE_API_CALL, "DELETE", data);
//getFoodAllergenListApiCall
// Task 24831 - token is the 4th FetchAPI argument and becomes x-token-key.
export const getFoodAllergenListApiCall = (token) =>
  FetchAPI(url.GET_FOOD_ALLERGEN_LIST_API, "GET", undefined, token);
//getFoodAllergenDataApiCall
export const getFoodAllergenDataApiCall = (data) =>
  FetchAPI(url.GET_FOOD_ALLERGEN_DATA_API, "GET", data);
//createFoodAllergenApiCall
export const createFoodAllergenApiCall = (data) =>
  FetchAPI(url.CREATE_FOOD_ALLERGEN_API, "POST", data);
//updateFoodAllergenApiCall
export const updateFoodAllergenApiCall = (data) =>
  FetchAPI(url.UPDATE_FOOD_ALLERGEN_API, "PUT", data);
//deleteFoodAllergenApiCall
export const deleteFoodAllergenApiCall = (data) =>
  FetchAPI(url.DELETE_FOOD_ALLERGEN_API, "DELETE", data);
//getFoodDietTypeListApiCall
// Task 24831 - see getFoodAllergenListApiCall.
export const getFoodDietTypeListApiCall = (token) =>
  FetchAPI(url.GET_FOOD_DIET_TYPE_LIST_API, "GET", undefined, token);
//getFoodDietTypeDataApiCall
export const getFoodDietTypeDataApiCall = (data) =>
  FetchAPI(url.GET_FOOD_DIET_TYPE_DATA_API, "GET", data);
//createFoodDietTypeApiCall
export const createFoodDietTypeApiCall = (data) =>
  FetchAPI(url.CREATE_FOOD_DIET_TYPE_API, "POST", data);
//updateFoodDietTypeApiCall
export const updateFoodDietTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_FOOD_DIET_TYPE_API, "PUT", data);
//deleteFoodDietTypeApiCall
export const deleteFoodDietTypeApiCall = (data) =>
  FetchAPI(url.DELETE_FOOD_DIET_TYPE_API, "DELETE", data);
//getProductAttributeListApiCall
export const getProductAttributeListApiCall = () =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_LIST_API, "GET");
// getProductAttributeDataApiCall
export const getProductAttributeDataApiCall = (data) =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_DATA_API, "GET", data);
//createProductAttributeApiCall
export const createProductAttributeApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCT_ATTRIBUTE_API, "POST", data);
//updateProductAttributeApiCall
export const updateProductAttributeApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_ATTRIBUTE_API, "PUT", data);
//deleteProductAttributeApiCall
export const deleteProductAttributeApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCT_ATTRIBUTE_API, "DELETE", data);
// getProductAttributeValueListApiCall
export const getProductAttributeValueListApiCall = () =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_VALUE_LIST_API, "GET");
// getProductAttributeValueDataApiCall
export const getProductAttributeValueDataApiCall = (data) =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_VALUE_DATA_API, "GET", data);
// createProductAttributeValueApiCall
export const createProductAttributeValueApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCT_ATTRIBUTE_VALUE_API, "POST", data);
// updateProductAttributeValueApiCall
export const updateProductAttributeValueApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_ATTRIBUTE_VALUE_API, "PUT", data);
// deleteProductAttributeValueApiCall
export const deleteProductAttributeValueApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCT_ATTRIBUTE_VALUE_API, "DELETE", data);
// getProductAttributeValuePriceListApiCall
export const getProductAttributeValuePriceListApiCall = () =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_API, "GET");
// getProductAttributeValuePriceDataApiCall
export const getProductAttributeValuePriceDataApiCall = (data) =>
  FetchAPI(url.GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_API, "GET", data);
// createProductAttributeValuePriceApiCall
export const createProductAttributeValuePriceApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API, "POST", data);
// updateProductAttributeValuePriceApiCall
export const updateProductAttributeValuePriceApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API, "PUT", data);
// deleteProductAttributeValuePriceApiCall
export const deleteProductAttributeValuePriceApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_API, "DELETE", data);

// Get Contract List API Call
export const getContractListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_LIST_API, "GET");

// Create contract api call
export const createContractApiCall = (data) =>
  FetchAPI(url.CREATE_CONTRACT_API, "POST", data);

// Get Contract Status List API Call
export const getContractStatusListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_STATUS_LIST_API, "GET");

// Get Contract Single Contract Data API Call
export const getContractSingleContractDataApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_CONTRACT_API, "GET", id);

// Update Single Contract API Call
export const updateSingleContractApiCall = (data) =>
  FetchAPI(url.UPDATE_CONTRACT_API, "PUT", data);

// Update Contract with Items Api Call
export const updateContractWithItemsApiCall = (data) =>
  FetchAPI(url.UPDATE_CONTRACT_WITH_ITEMS_API, "PUT", data);

// Preview Contract Update Api Call (dry-run, returns ChangeSummary + invoices)
export const previewContractUpdateApiCall = (data) =>
  FetchAPI(url.PREVIEW_CONTRACT_UPDATE_API, "POST", data);

// Preview Contract Create Api Call (dry-run, no save)
export const previewContractCreateApiCall = (data) =>
  FetchAPI(url.PREVIEW_CONTRACT_CREATE_API, "POST", data);

// Delete Contact API Call
export const deleteContractApiCall = (id) =>
  FetchAPI(url.DELETE_CONTRACTS_API, "DELETE", id);

// Search Single Customer Contract API Call
export const searchSingleCustomerContractApiCall = (data) =>
  FetchAPI(url.SINGLE_CUSTOMER_SEARCH_CONTRACTS_API, "POST", data);
// Get contract items list API Call
export const getContractItemsListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEMS_LIST_API, "GET");
// Get contract items status list API Call
export const getContractItemsStatusListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEM_STATUS_LIST_API, "GET");

// Get Contract frequency list API Call
export const getContractFrequencyListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_FREQUENCY_LIST_API, "GET");
// Search Single Customer Contract Item List API Call
export const searchSingleCustomerContractItemListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_API, "POST", data);
// Create Contract With Items API Call
export const createContractWithItemsApiCall = (data) =>
  FetchAPI(url.CREATE_CONTRACT_WITH_ITEMS_API, "POST", data);
// Search Single Customer Contract Item Summary List API Call
export const searchSingleCustomerContractItemSummaryListApiCall = (data) =>
  FetchAPI(
    url.SEARCH_SINGLE_CUSTOMER_CONTRACT_ITEMS_SUMMARY_LIST_API,
    "POST",
    data
  );
// Get Contract Item Frequency List API Call
export const getContractItemRenewalFrequencyListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEM_FREQUENCY_LIST_API, "GET");
//deleteSingleContractItemApiCall
export const deleteSingleContractItemApiCall = (id) =>
  FetchAPI(url.DELETE_SINGLE_CONTRACT_ITEM_API, "DELETE", id);
//getContractItemsActiveListApiCall
export const getContractItemsActiveListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEMS_ACTIVE_LIST_API, "GET");
//getContractItemsCancelledListApiCall
export const getContractItemsCancelledListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEMS_CANCELLED_LIST_API, "GET");
//getContractItemUsageSearchListApiCall
export const getContractItemUsageSearchListApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_API, "POST", data);
//getContractItemUsageListApiCall
export const getContractItemUsageListApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEM_USAGE_LIST_API, "GET");
//getContractItemUsageSearchApiCall
export const getContractItemUsageSearchApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_USAGE_SEARCH_API, "POST", data);
//searchContractPdfApiCall
export const searchContractPdfApiCall = (data) =>
  FetchAPI(url.SEARCH_CONTRACT_PDF_API, "POST", data);
//deleteAllPreviousContractItemUsageApiCall
export const deleteAllPreviousContractItemUsageApiCall = (data) =>
  FetchAPI(url.DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_API, "DELETE", data);
//getContractItemUsageLiveBalancePdfApiCall
export const getContractItemUsageLiveBalancePdfApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_API, "GET", data);
//generateContractItemUsageApiCall
export const generateContractItemUsageApiCall = (data) =>
  FetchAPI(url.GENERATE_CONTRACT_ITEM_USAGE_API, "POST", data);
//convertContractItemUsageApiCall - Change #100435 (statement -> invoice/proforma + credit)
export const convertContractItemUsageApiCall = (data) =>
  FetchAPI(url.CONVERT_CONTRACT_ITEM_USAGE_API, "POST", data);
//getContractItemUsagePdfApiCall  (data = { id: ContractItemUsage_Id })
export const getContractItemUsagePdfApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_USAGE_PDF_API, "GET", data);
//regenerateContractItemUsagePdfApiCall  (data = { id: ContractItemUsage_Id })
export const regenerateContractItemUsagePdfApiCall = (data) =>
  FetchAPI(url.REGENERATE_CONTRACT_ITEM_USAGE_PDF_API, "GET", data);
//getContractItemCreditListApiCall  (data = { id: ContractItem_Id })
export const getContractItemCreditListApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_CREDIT_LIST_API, "GET", data);
//createContractItemCreditApiCall
export const createContractItemCreditApiCall = (data) =>
  FetchAPI(url.CREATE_CONTRACT_ITEM_CREDIT_API, "POST", data);
//updateContractItemCreditApiCall
export const updateContractItemCreditApiCall = (data) =>
  FetchAPI(url.UPDATE_CONTRACT_ITEM_CREDIT_API, "PUT", data);
//deleteContractItemCreditApiCall
export const deleteContractItemCreditApiCall = (data) =>
  FetchAPI(url.DELETE_CONTRACT_ITEM_CREDIT_API, "DELETE", data);
//getContractItemPortfolioApiCall
export const getContractItemPortfolioApiCall = () =>
  FetchAPI(url.GET_CONTRACT_ITEM_PORTFOLIO_API, "GET");
//getContractItemDebitListApiCall  (data = { id: ContractItem_Id })
export const getContractItemDebitListApiCall = (data) =>
  FetchAPI(url.GET_CONTRACT_ITEM_DEBIT_LIST_API, "GET", data);
//getJobListByContractItemApiCall  (data = { id: ContractItem_Id })
export const getJobListByContractItemApiCall = (data) =>
  FetchAPI(url.GET_JOB_LIST_BY_CONTRACT_ITEM_API, "GET", data);
// Purchase List Get API Call
export const getPurchaseListApiCall = () =>
  FetchAPI(url.GET_PURCHASE_LIST_API, "GET");

// Get Single Purchase Data API Call
export const getSinglePurchaseDataApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_PURCHASE_DATA_API, "GET", id);
// Create Single Purchase API Call
export const createSinglePurchaseApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_PURCHASE_API, "POST", data);
// Update Single Purchase API Call
export const updateSinglePurchaseApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_PURCHASE_API, "PUT", data);
// Get Purchase Status List API Call
export const getPurchaseStatusListApiCall = () =>
  FetchAPI(url.GET_PURCHASE_STATUS_LIST_API, "GET");
// Search Single Supplier Purchase List
export const searchSingleSupplierPurchaseListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_API_CALL, "POST", data);
// Get Purchase Category List API Call
export const getPurchaseItemCategoryListApiCall = () =>
  FetchAPI(url.GET_PURCHASE_ITEM_CATEGORY_LIST_API, "GET");
// Get purchahse Items by job Id API Call
export const searchPurchaseItemByJobIdApiCall = (id) =>
  FetchAPI(url.GET_PURCHASE_ITEM_LIST_BY_JOB_ID_API, "POST", id);
// Convert a purchase item into a billable item API Call
export const convertPurchaseItemToBillableApiCall = (data) =>
  FetchAPI(url.CONVERT_PURCHASE_ITEM_TO_BILLABLE_API, "POST", data);
// Unlink a purchase item from its billable item API Call
export const unlinkPurchaseItemBillableApiCall = (data) =>
  FetchAPI(url.UNLINK_PURCHASE_ITEM_BILLABLE_API, "POST", data);
// Manually mark a purchase item as billed API Call
export const markPurchaseItemBilledApiCall = (data) =>
  FetchAPI(url.MARK_PURCHASE_ITEM_BILLED_API, "POST", data);
//addNewPurchaseStatusApiCall
export const addNewPurchaseStatusApiCall = (data) =>
  FetchAPI(url.ADD_NEW_PURCHASE_STATUS_API, "POST", data);
//deletePurchaseStatusApiCall
export const deletePurchaseStatusApiCall = (data) =>
  FetchAPI(url.DELETE_PURCHASE_STATUS_API, "DELETE", data);
//updatePurchaseStatusApiCall
export const updatePurchaseStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_STATUS_API, "PUT", data);
//addNewPurchaseItemCategoryApiCall
export const addNewPurchaseItemCategoryApiCall = (data) =>
  FetchAPI(url.ADD_NEW_PURCHASE_ITEM_CATEGORY_API, "POST", data);
//deletePurchaseItemCategoryApiCall
export const deletePurchaseItemCategoryApiCall = (data) =>
  FetchAPI(url.DELETE_PURCHASE_ITEM_CATEGORY_API, "DELETE", data);
//updatePurchaseItemCategoryApiCall
export const updatePurchaseItemCategoryApiCall = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_ITEM_CATEGORY_API, "PUT", data);
//deleteSinglePurchaseApiCall
export const deleteSinglePurchaseApiCall = (id) =>
  FetchAPI(url.DELETE_SINGLE_PURCHASE_API, "POST", id);
//searchPurchaseItemListApiCall
export const searchPurchaseItemListApiCall = (data) =>
  FetchAPI(url.SEARCH_PURCHASE_ITEM_LIST_API, "POST", data);
//uploadPurchaseDraftApiCall
export const uploadPurchaseDraftApiCall = (data) =>
  FetchAPI(url.UPLOAD_PURCHASE_DRAFT_API, "POST", data);
//createFileAttachmentApiCall
export const createFileAttachmentApiCall = (data) =>
  FetchAPI(url.CREATE_FILE_ATTACHMENT_API, "POST", data);
//searchPurchaseAttachmentApiCall
export const searchPurchaseAttachmentApiCall = (data) =>
  FetchAPI(url.SEARCH_PURCHASE_ATTACHMENT_API, "POST", data);
//deleteJobAttachmentApiCall
export const deleteJobAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_JOB_ATTACHMENT_API, "DELETE", data);
//predictTransactionFinancialApiCall
export const predictTransactionFinancialApiCall = (data) =>
  FetchAPI(url.PREDICT_TRANSACTION_FINANCIAL_API, "POST", data);
// Get Supplier List API Call
export const getSupplierListApiCall = () =>
  FetchAPI(url.GET_SUPPLIER_LIST_API, "GET");

// Get Single Supplier Details API CALL
export const getSingleSupplierDetailsApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_SUPPLIER_DETAILS_API, "GET", id);
// Create Single Supplier API Call
export const createSingleSupplierApiCall = (data) =>
  FetchAPI(url.CREATE_NEW_SUPPLIER_API, "POST", data);
// Update Single Supplier API Call
export const updateSingleSupplierApiCall = (data) =>
  FetchAPI(url.UPDATE_SUPPLIER_API, "PUT", data);
// Delete Single Supplier API Call
export const deleteSingleSupplierApiCall = (id) =>
  FetchAPI(url.DELETE_SUPPLIER_API, "DELETE", id);
//getSupplierRecentActivityApiCall
export const getSupplierRecentActivityApiCall = (id) =>
  FetchAPI(url.GET_SUPPLIER_RECENT_ACTIVITY_API, "GET", id);
//searchSupplierNoteApiCall
export const searchSupplierNoteApiCall = (data) =>
  FetchAPI(url.SEARCH_SUPPLIER_NOTE_API, "POST", data);
//createSupplierNoteApiCall
export const createSupplierNoteApiCall = (data) =>
  FetchAPI(url.CREATE_SUPPLIER_NOTE_API, "POST", data);
//deleteSupplierNoteApiCall
export const deleteSupplierNoteApiCall = (data) =>
  FetchAPI(url.DELETE_SUPPLIER_NOTE_API, "DELETE", data);
//searchSupplierAttachmentApiCall
export const searchSupplierAttachmentApiCall = (data) =>
  FetchAPI(url.SEARCH_SUPPLIER_ATTACHMENT_API, "POST", data);
//deleteSupplierAttachmentApiCall
export const deleteSupplierAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_SUPPLIER_ATTACHMENT_API, "DELETE", data);
// Change #100122 - customer attachments (link rows; upload via fileattachment/create with linked_customer)
export const searchCustomerAttachmentApiCall = (data) =>
  FetchAPI(url.SEARCH_CUSTOMER_ATTACHMENT_API, "POST", data);
export const deleteCustomerAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_ATTACHMENT_API, "DELETE", data);
//searchSupplierUrlLinkApiCall
export const searchSupplierUrlLinkApiCall = (data) =>
  FetchAPI(url.SEARCH_SUPPLIER_URL_LINK_API, "POST", data);
//getSupplierUrlLinkDetailsApiCall
export const getSupplierUrlLinkDetailsApiCall = (data) =>
  FetchAPI(url.GET_SUPPLIER_URL_LINK_DETAILS_API, "GET", data);
//createSupplierUrlLinkApiCall
export const createSupplierUrlLinkApiCall = (data) =>
  FetchAPI(url.CREATE_SUPPLIER_URL_LINK_API, "POST", data);
//updateSupplierUrlLinkApiCall
export const updateSupplierUrlLinkApiCall = (data) =>
  FetchAPI(url.UPDATE_SUPPLIER_URL_LINK_API, "PUT", data);
//deleteSupplierUrlLinkApiCall
export const deleteSupplierUrlLinkApiCall = (data) =>
  FetchAPI(url.DELETE_SUPPLIER_URL_LINK_API, "DELETE", data);
//getSupplierUrlLinkStatusListApiCall
export const getSupplierUrlLinkStatusListApiCall = () =>
  FetchAPI(url.GET_SUPPLIER_URL_LINK_STATUS_LIST_API, "GET");
//getSupplierUrlLinkTypeListApiCall
export const getSupplierUrlLinkTypeListApiCall = () =>
  FetchAPI(url.GET_SUPPLIER_URL_LINK_TYPE_LIST_API, "GET");
//getSupplierBalanceHistoricalBySupplierApiCall — pass { id: Supplier_Id }
export const getSupplierBalanceHistoricalBySupplierApiCall = (id) =>
  FetchAPI(url.GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_API, "GET", id);
//getSupplierBalanceHistoricalSpecificDateApiCall — pass { id: date }
export const getSupplierBalanceHistoricalSpecificDateApiCall = (data) =>
  FetchAPI(url.GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_API, "GET", data);
//getSupplierBalanceHistoricalAvailableDatesApiCall
export const getSupplierBalanceHistoricalAvailableDatesApiCall = () =>
  FetchAPI(url.GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_API, "GET");

// Get Company To user List API Call
export const getCompanyToUserListApiCall = () =>
  FetchAPI(url.GET_COMPANY_TO_USER_LIST_API, "GET");

// Switch Company API Call
export const switchCompanyApiCall = (data) =>
  FetchAPI(url.SWITCH_COMPANY_API, "GET", data);
//getCompanyUserInvitationsApiCall
export const getCompanyUserInvitationsApiCall = () =>
  FetchAPI(url.GET_COMPANY_USER_INVITATIONS_API, "GET");
//sendEmailInvitationApiCall
export const sendEmailInvitationApiCall = (data) =>
  FetchAPI(url.SEND_EMAIL_INVITATION_API, "POST", data);
//getJoinCompanyInvitationListApiCall
export const getJoinCompanyInvitationListApiCall = () =>
  FetchAPI(url.GET_JOIN_COMPANY_INVITATION_LIST_API, "GET");
//acceptOrDeclineInvitationToJoinCompanyApiCall
export const acceptOrDeclineInvitationToJoinCompanyApiCall = (data) =>
  FetchAPI(url.ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_API, "PUT", data);
//getCompanyTeamMembersListApiCall
export const getCompanyTeamMembersListApiCall = () =>
  FetchAPI(url.GET_COMPANY_TEAM_MEMBERS_LIST_API, "GET");
//getCompanyDetailsApiCall
export const getCompanyDetailsApiCall = () =>
  FetchAPI(url.GET_COMPANY_DETAILS_API, "GET");
//updateCompanyDetailsApiCall
export const updateCompanyDetailsApiCall = (data) =>
  FetchAPI(url.UPDATE_COMPANY_DETAILS_API, "PUT", data);
//getUserAvailableMenuApiCall
export const getUserAvailableMenuApiCall = () =>
  FetchAPI(url.GET_USER_AVAILABLE_MENU_API, "GET");
//getUserAvailableDashboardApiCall
export const getUserAvailableDashboardApiCall = () =>
  FetchAPI(url.GET_USER_AVAILABLE_DASHBOARD_API, "GET");
//mapDashboardAndMenuToUserApiCall
export const mapDashboardAndMenuToUserApiCall = (data) =>
  FetchAPI(url.MAP_DASHBOARD_AND_MENU_TO_USER_API, "POST", data);
//getCompanyToUserListTeamApiCall
export const getCompanyToUserListTeamApiCall = () =>
  FetchAPI(url.GET_COMPANY_TO_USER_LIST_TEAM_API, "GET");
//updateCompanyToUserTeamApiCall
export const updateCompanyToUserTeamApiCall = (data) =>
  FetchAPI(url.UPDATE_COMPANY_TO_USER_TEAM_API, "POST", data);
//createCompanyToUserApiCall
export const createCompanyToUserApiCall = (data) =>
  FetchAPI(url.CREATE_COMPANY_TO_USER_API, "POST", data);
//deleteCompanyToUserApiCall
export const deleteCompanyToUserApiCall = (data) =>
  FetchAPI(url.DELETE_COMPANY_TO_USER_API, "DELETE", data);
//companyToUserLockUserApiCall
export const companyToUserLockUserApiCall = (data) =>
  FetchAPI(url.COMPANY_TO_USER_LOCK_USER_API, "POST", data);
//companyToUserUnlockUserApiCall
export const companyToUserUnlockUserApiCall = (data) =>
  FetchAPI(url.COMPANY_TO_USER_UNLOCK_USER_API, "POST", data);
//companyToUserResetPasswordApiCall
export const companyToUserResetPasswordApiCall = (data) =>
  FetchAPI(url.COMPANY_TO_USER_RESET_PASSWORD_API, "POST", data);
//companyToUserUpdateSubscriptionLicenceAndSecurityApiCall
export const companyToUserUpdateSubscriptionLicenceAndSecurityApiCall = (
  data
) =>
  FetchAPI(
    url.COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_API,
    "PUT",
    data
  );
//getCompanyToUserDataApiCall
export const getCompanyToUserDataApiCall = (id) =>
  FetchAPI(url.GET_COMPANY_TO_USER_DATA_API, "GET", id);
// ********* Opportunity API Call'S *********

// Search Single Customer Opportunity List API Call

export const searchSingleCustomerOpportunityListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_API, "POST", data);
// Get Single Customer Acitivities List
export const getSingleCustomerActivitiesListApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_API, "GET", data);
// Search single customer URL link list API Call
export const searchSingleCustomerURLLinkListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_API, "POST", data);
// Search Single customer external api call
export const searchSingleCustomerExternalIDsListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_API, "POST", data);
// Microsoft 365 per-customer overview (connection status + licence recon).
// Hits Microsoft Graph live, so call on demand from the Integrations tab.
export const getCustomerMicrosoft365OverviewApiCall = (customerId) =>
  FetchAPI(url.GET_CUSTOMER_MICROSOFT365_OVERVIEW_API, "GET", { id: customerId });
// Product external ids CRUD (provider list reuses the customer helper below).
export const searchSingleProductExternalIDsListApiCall = (data) =>
  FetchAPI(url.SEARCH_SINGLE_PRODUCT_EXTERNAL_IDS_LIST_API, "POST", data);
export const createSingleProductExternalIDsApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_PRODUCT_EXTERNAL_IDS_API, "POST", data);
export const updateSingleProductExternalIDsApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_PRODUCT_EXTERNAL_IDS_API, "PUT", data);
export const deleteSingleProductExternalIDsApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_PRODUCT_EXTERNAL_IDS_API, "DELETE", data);
// Master external identification providers (catalogue + per-company mapping).
export const masterExternalIdentificationProviderListApiCall = () =>
  FetchAPI(url.MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_API, "GET");
export const masterExternalIdentificationProviderCreateApiCall = (data) =>
  FetchAPI(url.MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_CREATE_API, "POST", data);
export const masterExternalIdentificationProviderUpdateApiCall = (data) =>
  FetchAPI(url.MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_UPDATE_API, "PUT", data);
export const masterExternalIdentificationProviderDeleteApiCall = (data) =>
  FetchAPI(url.MASTER_EXTERNAL_IDENTIFICATION_PROVIDER_DELETE_API, "DELETE", data);
// getSingleCustomerSiteLocationListApiCall
export const getSingleCustomerSiteLocationListApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_API, "POST", data);
// getSingleCustomerSiteLocationListApiCall
export const getSingleCustomerSiteLocationDataApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_API, "GET", data);
// addSingleCustomerSiteLocationApiCall
export const addSingleCustomerSiteLocationApiCall = (data) =>
  FetchAPI(url.ADD_SINGLE_CUSTOMER_SITE_LOCATION_API, "POST", data);
//updateSingleCustomerSiteLocationApiCall
export const updateSingleCustomerSiteLocationApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_API, "PUT", data);
//deleteSingleCustomerSiteLocationApiCall
export const deleteSingleCustomerSiteLocationApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_CUSTOMER_SITE_LOCATION_API, "DELETE", data);
//getSingleCustomerURLLinkDetailsApiCall
export const getSingleCustomerURLLinkDetailsApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_API, "GET", data);
//createSingleCustomerURLLinkApiCall
export const createSingleCustomerURLLinkApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_CUSTOMER_URL_LINK_API, "POST", data);
//updateSingleCustomerURLLinkApiCall
export const updateSingleCustomerURLLinkApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_CUSTOMER_URL_LINK_API, "PUT", data);
//deleteSingleCustomerURLLinkApiCall
export const deleteSingleCustomerURLLinkApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_CUSTOMER_URL_LINK_API, "DELETE", data);
//getCustomerURLLinkStatusListApiCall
export const getCustomerURLLinkStatusListApiCall = () =>
  FetchAPI(url.GET_CUSTOMER_URL_LINK_STATUS_LIST_API, "GET");
//getCustomerURLLinkStatusDetailsApiCall
export const getCustomerURLLinkStatusDetailsApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_URL_LINK_STATUS_DETAILS_API, "GET", data);
//createCustomerURLLinkStatusApiCall
export const createCustomerURLLinkStatusApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_URL_LINK_STATUS_API, "POST", data);
//updateCustomerURLLinkStatusApiCall
export const updateCustomerURLLinkStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_CUSTOMER_URL_LINK_STATUS_API, "PUT", data);
//deleteCustomerURLLinkStatusApiCall
export const deleteCustomerURLLinkStatusApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_URL_LINK_STATUS_API, "DELETE", data);
//getCustomerURLLinkTypeListApiCall
export const getCustomerURLLinkTypeListApiCall = () =>
  FetchAPI(url.GET_CUSTOMER_URL_LINK_TYPE_LIST_API, "GET");
//getCustomerURLLinkTypeDetailsApiCall
export const getCustomerURLLinkTypeDetailsApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_URL_LINK_TYPE_DETAILS_API, "GET", data);
//createCustomerURLLinkTypeApiCall
export const createCustomerURLLinkTypeApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_URL_LINK_TYPE_API, "POST", data);
//updateCustomerURLLinkTypeApiCall
export const updateCustomerURLLinkTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_CUSTOMER_URL_LINK_TYPE_API, "PUT", data);
//deleteCustomerURLLinkTypeApiCall
export const deleteCustomerURLLinkTypeApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_URL_LINK_TYPE_API, "DELETE", data);
//getCustomersDebitBalanceListApiCall
export const getCustomersDebitBalanceListApiCall = () =>
  FetchAPI(url.GET_CUSTOMERS_DEBIT_BALANCE_LIST_API, "GET");
//getCustomersOverdueBalanceListApiCall
export const getCustomersOverdueBalanceListApiCall = () =>
  FetchAPI(url.GET_CUSTOMERS_OVERDUE_BALANCE_LIST_API, "GET");
//getCustomersBalanceListAllApiCall
export const getCustomersBalanceListAllApiCall = () =>
  FetchAPI(url.GET_CUSTOMERS_BALANCE_LIST_ALL_API, "GET");
//clearCustomerTransactionsListApiCall
export const clearCustomerTransactionsListApiCall = (data) =>
  FetchAPI(url.CLEAR_CUSTOMER_TRANSACTIONS_LIST_API, "POST", data);
//getSingleCustomerExternalIDsDetailsApiCall
export const getSingleCustomerExternalIDsDetailsApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_API, "GET", data);
//createSingleCustomerExternalIDsApiCall
export const createSingleCustomerExternalIDsApiCall = (data) =>
  FetchAPI(url.CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API, "POST", data);
//updateSingleCustomerExternalIDsApiCall
export const updateSingleCustomerExternalIDsApiCall = (data) =>
  FetchAPI(url.UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_API, "PUT", data);
//deleteSingleCustomerExternalIDsApiCall
export const deleteSingleCustomerExternalIDsApiCall = (data) =>
  FetchAPI(url.DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_API, "DELETE", data);
//getSingleCustomerExternalIDsExternalIdentificationProviderListApiCall
export const getSingleCustomerExternalIDsExternalIdentificationProviderListApiCall =
  () =>
    FetchAPI(
      url.GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_API,
      "GET"
    );
//getSingleCustomerExternalIDsExternalIdentificationProviderDetailsApiCall
export const getSingleCustomerExternalIDsExternalIdentificationProviderDetailsApiCall =
  (data) =>
    FetchAPI(
      url.GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_API,
      "GET",
      data
    );
//createSingleCustomerExternalIDsExternalIdentificationProviderApiCall
export const createSingleCustomerExternalIDsExternalIdentificationProviderApiCall =
  (data) =>
    FetchAPI(
      url.CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API,
      "POST",
      data
    );
//updateSingleCustomerExternalIDsExternalIdentificationProviderApiCall
export const updateSingleCustomerExternalIDsExternalIdentificationProviderApiCall =
  (data) =>
    FetchAPI(
      url.UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API,
      "PUT",
      data
    );
//deleteSingleCustomerExternalIDsExternalIdentificationProviderApiCall
export const deleteSingleCustomerExternalIDsExternalIdentificationProviderApiCall =
  (data) =>
    FetchAPI(
      url.DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_API,
      "DELETE",
      data
    );
//getCustomerStatusListDataApiCall
export const getCustomerStatusListDataApiCall = () =>
  FetchAPI(url.GET_CUSTOMER_STATUS_LIST_DATA_API, "GET");
//getCustomerStatusDetailsApiCall
export const getCustomerStatusDetailsApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_STATUS_DETAILS_API, "GET", data);
//createCustomerStatusApiCall
export const createCustomerStatusApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_STATUS_API, "POST", data);
//updateCustomerStatusApiCall
export const updateCustomerStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_CUSTOMER_STATUS_API, "PUT", data);
//deleteCustomerStatusApiCall
export const deleteCustomerStatusApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_STATUS_API, "DELETE", data);
//getCustomerTypeListDataApiCall
export const getCustomerTypeListDataApiCall = () =>
  FetchAPI(url.GET_CUSTOMER_TYPE_LIST_DATA_API, "GET");
//getCustomerTypeDetailsApiCall
export const getCustomerTypeDetailsApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_TYPE_DETAILS_API, "GET", data);
//createCustomerTypeApiCall
export const createCustomerTypeApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_TYPE_API, "POST", data);
//updateCustomerTypeApiCall
export const updateCustomerTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_CUSTOMER_TYPE_API, "PUT", data);
//deleteCustomerTypeApiCall
export const deleteCustomerTypeApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_TYPE_API, "DELETE", data);
//exportContactsApiCall
export const exportContactsApiCall = (data) =>
  FetchAPI(url.EXPORT_CONTACTS_API, "POST", data);
//searchCustomerApiCall
export const searchCustomerApiCall = (data) =>
  FetchAPI(url.SEARCH_CUSTOMER_API, "POST", data);
//getCustomerBalanceHistoricalAvailableDatesApiCall
export const getCustomerBalanceHistoricalAvailableDatesApiCall = () =>
  FetchAPI(url.GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_API, "GET");
//getCustomerBalanceHistoricalSpecificDateApiCall
export const getCustomerBalanceHistoricalSpecificDateApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_API, "GET", data);
//getCustomerBalanceHistoricalByCustomerApiCall — pass { id: Customer_Id }
export const getCustomerBalanceHistoricalByCustomerApiCall = (id) =>
  FetchAPI(url.GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_API, "GET", id);
//searchCustomerNoteApiCall
export const searchCustomerNoteApiCall = (data) =>
  FetchAPI(url.SEARCH_CUSTOMER_NOTE_API, "POST", data);
//createCustomerNoteApiCall
export const createCustomerNoteApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_NOTE_API, "POST", data);
//  Create New Opportunity Item API Call
export const createNewOpportunityItemApiCall = (data) =>
  FetchAPI(url.CREATE_OPPORTUNITY_NEW_ITEM_API, "POST", data);

// Update Opportunity Item API Call
export const updateOpportunityItemApiCall = (data) =>
  FetchAPI(url.UPDATE_OPPORTUNITY_ITEM_API, "PUT", data);

// Get Opportunity List API Call
export const getOpportunityListApiCall = () =>
  FetchAPI(url.GET_ALL_OPPORTUNITIES_LIST_API, "GET");

// Get Single Opportunity Data API Call
export const getSingleOpportunityDataApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_OPPORTUNITY_ITEM_API, "GET", id);
// Delete Opportunity Item API Call
export const deleteOpportunityItemApiCall = (id) =>
  FetchAPI(url.DELETE_OPPORTUNITY_ITEM_API, "DELETE", id);

// Get Opportunity Status List API Call
export const getOpportunityStatusListApiCall = () =>
  FetchAPI(url.GET_OPPORTUNITY_STATUS_LIST_API, "GET");

// Get Opportunity Type List API Call
export const getOpportunityTypeListApiCall = () =>
  FetchAPI(url.GET_OPPORTUNITY_TYPE_LIST_API, "GET");

// Get Opportunity Priority List API Call
export const getOpportunityPriorityListApiCall = () =>
  FetchAPI(url.GET_OPPORTUNITY_PRIORITY_LIST_API, "GET");
// Get Single Opportunity Data API Call
export const getSingleOpportunityPageDataApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_OPPORTUNITY_ITEM_API, "GET", id);
// Get Opportunity Notes List API Call
export const searchOpportunityNoteListApiCall = (id) =>
  FetchAPI(url.GET_OPPORTUNITY_NOTES_LIST_API, "POST", id);
// Create Opportunity Notes API Call
export const createOpportunityNoteItemApiCall = (data) =>
  FetchAPI(url.CREATE_OPPORTUNITY_NOTES_ITEM_API, "POST", data);
// Get Single Opportunity Acitivty list API Call
export const singleOpportunityActivityListApiCall = (id) =>
  FetchAPI(url.GET_SINGLE_OPPORTUNITY_ACTIVITY_LIST_API, "GET", id);
//addNewOpportunityStatusApiCall
export const addNewOpportunityStatusApiCall = (data) =>
  FetchAPI(url.ADD_NEW_OPPORTUNITY_STATUS_API, "POST", data);
//deleteOpportunityStatusApiCall
export const deleteOpportunityStatusApiCall = (id) =>
  FetchAPI(url.DELETE_OPPORTUNITY_STATUS_API, "DELETE", id);
//updateOpportunityStatusApiCall
export const updateOpportunityStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_OPPORTUNITY_STATUS_API, "PUT", data);
//addNewOpportunityPriorityApiCall
export const addNewOpportunityPriorityApiCall = (data) =>
  FetchAPI(url.ADD_NEW_OPPORTUNITY_PRIORITY_API, "POST", data);
//deleteOpportunityPriorityApiCall
export const deleteOpportunityPriorityApiCall = (id) =>
  FetchAPI(url.DELETE_OPPORTUNITY_PRIORITY_API, "DELETE", id);
//updateOpportunityPriorityApiCall
export const updateOpportunityPriorityApiCall = (data) =>
  FetchAPI(url.UPDATE_OPPORTUNITY_PRIORITY_API, "PUT", data);
//addNewOpportunityTypeApiCall
export const addNewOpportunityTypeApiCall = (data) =>
  FetchAPI(url.ADD_NEW_OPPORTUNITY_TYPE_API, "POST", data);
//deleteOpportunityTypeApiCall
export const deleteOpportunityTypeApiCall = (id) =>
  FetchAPI(url.DELETE_OPPORTUNITY_TYPE_API, "DELETE", id);
//updateOpportunityTypeApiCall
export const updateOpportunityTypeApiCall = (data) =>
  FetchAPI(url.UPDATE_OPPORTUNITY_TYPE_API, "PUT", data);
//getOpportunityOverviewFunnelDataApiCall
export const getOpportunityOverviewFunnelDataApiCall = (data) =>
  FetchAPI(url.GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_API, "POST", data);
//postSearchOpportunityAttachmentListApiCall
export const postSearchOpportunityAttachmentListApiCall = (data) =>
  FetchAPI(url.SEARCH_OPPORTUNITY_ATTACHMENT_LIST_API, "POST", data);
//postDeleteOpportunityAttachmentApiCall
export const postDeleteOpportunityAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_OPPORTUNITY_ATTACHMENT_API, "DELETE", data);
// Search Opportunity Product (interested products) List API Call
export const searchOpportunityProductListApiCall = (data) =>
  FetchAPI(url.SEARCH_OPPORTUNITY_PRODUCT_LIST_API, "POST", data);
// Create Opportunity Product Item API Call
export const createOpportunityProductItemApiCall = (data) =>
  FetchAPI(url.CREATE_OPPORTUNITY_PRODUCT_ITEM_API, "POST", data);
// Delete Opportunity Product Item API Call
export const deleteOpportunityProductItemApiCall = (id) =>
  FetchAPI(url.DELETE_OPPORTUNITY_PRODUCT_ITEM_API, "DELETE", id);
//********************************************
// Quote Api Call's
// Get Quote List API Call
export const getQuoteListApiCall = () =>
  FetchAPI(url.GET_QUOTE_LIST_API, "GET");
// Get Single Quote Data API Call
export const getSingleQuoteDataApiCall = (id) =>
  FetchAPI(url.GET_QUOTE_DETAILS_API, "GET", id);
// Create Single Quote API Call
export const createSingleQuoteApiCall = (data) =>
  FetchAPI(url.CREATE_QUOTE_API, "POST", data);
// Update Single Quote API Call
export const updateSingleQuoteApiCall = (data) =>
  FetchAPI(url.UPDATE_QUOTE_API, "PUT", data);
// Delete Single Quote API Call
export const deleteSingleQuoteApiCall = (id) =>
  FetchAPI(url.DELETE_QUOTE_API, "DELETE", id);
// Get Quote Status List API Call
export const getQuoteStatusListApiCall = () =>
  FetchAPI(url.GET_QUOTE_STATUS_LIST_API, "GET");
// Get Quote Type List API Call
export const getQuoteTypeListApiCall = (data) =>
  FetchAPI(url.GET_QUOTE_PDF_API, "GET", data);
//addNewQuoteStatusApiCall
export const addNewQuoteStatusApiCall = (data) =>
  FetchAPI(url.ADD_NEW_QUOTE_STATUS_API, "POST", data);
//updateQuoteStatusApiCall
export const updateQuoteStatusApiCall = (data) =>
  FetchAPI(url.UPDATE_QUOTE_STATUS_API, "PUT", data);
//deleteQuoteStatusApiCall
export const deleteQuoteStatusApiCall = (id) =>
  FetchAPI(url.DELETE_QUOTE_STATUS_API, "DELETE", id);
//getSingleCustomerQuoteListApiCall
export const getSingleCustomerQuoteListApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_CUSTOMER_QUOTE_LIST_API, "POST", data);

//********************************************
// Payment Term
// Get Payment Term List API Call
export const getPaymentTermsListApi = () =>
  FetchAPI(url.GET_PAYMENT_TERM_LIST_API, "GET");
//getPaymentTermsDataApi
export const getPaymentTermsDataApi = (id) =>
  FetchAPI(url.GET_PAYMENT_TERM_DATA_API, "GET", id);
//createPaymentTermsApi
export const createPaymentTermsApi = (data) =>
  FetchAPI(url.CREATE_PAYMENT_TERM_API, "POST", data);
//updatePaymentTermsApi
export const updatePaymentTermsApi = (data) =>
  FetchAPI(url.UPDATE_PAYMENT_TERM_API, "PUT", data);
//deletePaymentTermsApi
export const deletePaymentTermsApi = (id) =>
  FetchAPI(url.DELETE_PAYMENT_TERM_API, "DELETE", id);

//********************************************
// Master Time Frame Interval
// Get Master Time Frame Interval List API Call
export const getMasterTimeFrameIntervalListApi = () =>
  FetchAPI(url.GET_MASTER_TIME_FRAME_INTERVAL_LIST_API, "GET");

//********************************************
// Invoice Items
// Get Single Job Page Invoice Items List API Call
export const getSingleJobPageInvoiceItemsListApiCall = (data) =>
  FetchAPI(url.GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_API, "POST", data);
//********************************************
// Contact Person Lookup api
// Get Contact Person Lookup List API Call
export const getContactPersonLookupListApiCall = (data) =>
  FetchAPI(url.SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_API, "GET", data);
//********************************************
// Payment Method
// Get Payment Method List API Call
export const getPaymentMethodListApiCall = () =>
  FetchAPI(url.GET_PAYMENT_METHOD_LIST_API, "GET");
//********************************************
// Profit and Loss api calls

// profit and loss api call post  request search with data range data
export const getProfitAndLossStatementDataFromDateRange = (data) =>
  FetchAPI(
    url.PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT_API,
    "POST",
    data
  );

//********************************************
//customerCardAddSuccessApiCall
//Customer Card Add Success Api Call
export const customerCardAddSuccessApiCall = (data) =>
  FetchAPI(url.CUSTOMER_CARD_ADD_SUCCESS_API, "POST", data);
//getCustomerCardsApiCall
//Get Customer Cards Api Call
export const getCustomerCardsApiCall = (data) =>
  FetchAPI(url.GET_CUSTOMER_CARDS_API, "GET", data);
//********************************************
// sendLeaveRequestApi
// Send Leave Request Api Call
export const sendLeaveRequestApi = (data) =>
  FetchAPI(url.SEND_LEAVE_REQUEST_API, "POST", data);
//********************************************
//

// Dunning
//Dunning List
export const getDunningListApi = (data) =>
  FetchAPI(url.GET_DUNNING_LIST_API, "GET", data);

// getDunningActionListApi
//Dunning Action List
export const getDunningActionListApi = () =>
  FetchAPI(url.GET_DUNNING_ACTION_LIST_API, "GET");
// createDunningEventApi
//Create Dunning Event
export const createDunningEventApi = (data) =>
  FetchAPI(url.CREATE_DUNNING_EVENT_API, "POST", data);
//searchSingleCustomerDunningEventListApi
//Search Single Customer Dunning Event List
export const searchSingleCustomerDunningEventListApi = (data) =>
  FetchAPI(url.SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_API, "POST", data);
//getDunningSingleEventApi
//Get Dunning Single Event
export const getDunningSingleEventApi = (data) =>
  FetchAPI(url.GET_DUNNING_SINGLE_EVENT_API, "GET", data);
//updateDunningEventApi
// Update Dunning Event
export const updateDunningEventApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_EVENT_API, "PUT", data);
//deleteDunningEventApi
//Delete Dunning Event
export const deleteDunningEventApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_EVENT_API, "DELETE", data);
//addNewDunningEventActionApi
//Add New Dunning Event Action
export const addNewDunningEventActionApi = (data) =>
  FetchAPI(url.ADD_NEW_DUNNING_EVENT_ACTION_API, "POST", data);
//updateDunningEventActionApi
//Update Dunning Event Action
export const updateDunningEventActionApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_EVENT_ACTION_API, "PUT", data);
//deleteDunningEventActionApi
//Delete Dunning Event Action
export const deleteDunningEventActionApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_EVENT_ACTION_API, "DELETE", data);
//getDunningLockTypeListApi
//Get Dunning Lock Type List
export const getDunningLockTypeListApi = () =>
  FetchAPI(url.GET_DUNNING_LOCK_TYPE_LIST_API, "GET");
//getDunningLockTypeDataApi
//Get Dunning Lock Type Data
export const getDunningLockTypeDataApi = (data) =>
  FetchAPI(url.GET_DUNNING_LOCK_TYPE_DATA_API, "GET", data);
//createDunningLockTypeApi
//Create Dunning Lock Type
export const createDunningLockTypeApi = (data) =>
  FetchAPI(url.CREATE_DUNNING_LOCK_TYPE_API, "POST", data);
//updateDunningLockTypeApi
//Update Dunning Lock Type
export const updateDunningLockTypeApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_LOCK_TYPE_API, "PUT", data);
//deleteDunningLockTypeApi
//Delete Dunning Lock Type
export const deleteDunningLockTypeApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_LOCK_TYPE_API, "DELETE", data);
//getDunningLockListApi
//Get Dunning Lock List
export const getDunningLockListApi = () =>
  FetchAPI(url.GET_DUNNING_LOCK_LIST_API, "GET");
//getDunningLockDataApi
//Get Dunning Lock Data
export const getDunningLockDataApi = (data) =>
  FetchAPI(url.GET_DUNNING_LOCK_DATA_API, "GET", data);
//createDunningLockApi
//Create Dunning Lock
export const createDunningLockApi = (data) =>
  FetchAPI(url.CREATE_DUNNING_LOCK_API, "POST", data);
//updateDunningLockApi
//Update Dunning Lock
export const updateDunningLockApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_LOCK_API, "PUT", data);
//deleteDunningLockApi
//Delete Dunning Lock
export const deleteDunningLockApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_LOCK_API, "DELETE", data);
//getDunningProfileListApi
//Get Dunning Profile List
export const getDunningProfileListApi = () =>
  FetchAPI(url.GET_DUNNING_PROFILE_LIST_API, "GET");
//getDunningProfileDataApi
//Get Dunning Profile Data
export const getDunningProfileDataApi = (data) =>
  FetchAPI(url.GET_DUNNING_PROFILE_DATA_API, "GET", data);
//createDunningProfileApi
//Create Dunning Profile
export const createDunningProfileApi = (data) =>
  FetchAPI(url.CREATE_DUNNING_PROFILE_API, "POST", data);
//updateDunningProfileApi
//Update Dunning Profile
export const updateDunningProfileApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_PROFILE_API, "PUT", data);
//deleteDunningProfileApi
//Delete Dunning Profile
export const deleteDunningProfileApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_PROFILE_API, "DELETE", data);
//getDunningProfileStepListApi
//Get Dunning Profile Step List (optionally filtered to one profile)
export const getDunningProfileStepListApi = (data) =>
  FetchAPI(
    url.GET_DUNNING_PROFILE_STEP_LIST_API +
      (data?.DunningProfile_Id
        ? `?DunningProfile_Id=${data.DunningProfile_Id}`
        : ""),
    "GET"
  );
//getDunningProfileStepDataApi
//Get Dunning Profile Step Data
export const getDunningProfileStepDataApi = (data) =>
  FetchAPI(url.GET_DUNNING_PROFILE_STEP_DATA_API, "GET", data);
//createDunningProfileStepApi
//Create Dunning Profile Step
export const createDunningProfileStepApi = (data) =>
  FetchAPI(url.CREATE_DUNNING_PROFILE_STEP_API, "POST", data);
//updateDunningProfileStepApi
//Update Dunning Profile Step
export const updateDunningProfileStepApi = (data) =>
  FetchAPI(url.UPDATE_DUNNING_PROFILE_STEP_API, "PUT", data);
//deleteDunningProfileStepApi
//Delete Dunning Profile Step
export const deleteDunningProfileStepApi = (data) =>
  FetchAPI(url.DELETE_DUNNING_PROFILE_STEP_API, "DELETE", data);

//verifyEmailApi
//Verify Email Api
export const verifyEmailApi = (data) =>
  FetchAPI(url.VERIFY_EMAIL_API, "GET", data);
//sendNewVerificationEmailApi
//Send New Verification Email Api
export const sendNewVerificationEmailApi = (data) =>
  FetchAPI(url.SEND_NEW_VERIFICATION_EMAIL_API, "GET", data);
//createCompanyApi
//Create Company Api
export const createCompanyApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_API, "POST", data);
//verifyUserJoinApi
//Verify User Join Api
export const verifyUserJoinApi = (data) =>
  FetchAPI(url.VERIFY_USER_JOIN_API, "POST", data);
//acceptInviteCreateNewUserAccountApi
//Accept Invite Create New User Account Api
export const acceptInviteCreateNewUserAccountApi = (data) =>
  FetchAPI(url.ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_API, "POST", data);
//authenticationRequestForEmailPasswordResetApi
//Authentication Request For Email Password Reset Api
export const authenticationRequestForEmailPasswordResetApi = (data) =>
  FetchAPI(
    url.AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_API,
    "GET",
    data
  );
//resetPasswordApi
//Reset Password Api
export const resetPasswordApi = (data) =>
  FetchAPI(url.RESET_PASSWORD_API, "POST", data);

// Manage Licenses
//getLicensesSubscriptionListApi
//Get Licenses Subscription List Api
export const getLicensesSubscriptionListApi = () =>
  FetchAPI(url.GET_LICENSES_SUBSCRIPTION_LIST_API, "GET");
//getLicensesSubscriptionProductListApi
//Get Licenses Subscription Product List Api
export const getLicensesSubscriptionProductListApi = () =>
  FetchAPI(url.GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_API, "GET");
//requestSubscriptionLicensesOrderPreviewApi
//Request Subscription Licenses Order Preview Api
export const requestSubscriptionLicensesOrderPreviewApi = (data) =>
  FetchAPI(url.REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_API, "POST", data);
//confirmSubscriptionLicensesOrderApi
//Confirm Subscription Licenses Order Api
export const confirmSubscriptionLicensesOrderApi = (data) =>
  FetchAPI(url.CONFIRM_SUBSCRIPTION_LICENSES_ORDER_API, "POST", data);
//updateSubscriptionLicensesOrderApi
//Update Subscription Licenses Order Api
export const updateSubscriptionLicensesOrderApi = (data) =>
  FetchAPI(url.UPDATE_SUBSCRIPTION_LICENSES_ORDER_API, "PUT", data);
//unassignLicenseFromUserApi
//Unassign License From User Api
export const unassignLicenseFromUserApi = (data) =>
  FetchAPI(url.UNASSIGN_LICENSE_FROM_USER_API, "POST", data);
//getSubscriptionProductListApi
//Get Subscription Product List Api
export const getSubscriptionProductListApi = () =>
  FetchAPI(url.GET_SUBSCRIPTION_PRODUCT_LIST_API, "GET");
//getUserLicenceListApi
//Get all licences (active + expired) held by one user (staff profile CRM Licence tab)
export const getUserLicenceListApi = (userId) =>
  FetchAPI(`${url.GET_USER_LICENCE_LIST_API}/${userId}`, "GET");
// Dashboard API Calls
// getDashboardDataAPI
// Get Dashboard Data API
export const getDashboardDataAPI = () =>
  FetchAPI(url.GET_DASHBOARD_DATA_API, "GET");
//getDashboardActivityListAPI
//Get Dashboard Activity List API
export const getDashboardActivityListAPI = () =>
  FetchAPI(url.GET_DASHBOARD_ACTIVITY_LIST_API, "GET");

// Custom Dashboard Builder (Task 24269). Payloads use DashboardTemplate_Id (not
// a top-level `id`), so FetchAPI does not append /{id} to the URL.
export const dashboardTemplateListAPI = () =>
  FetchAPI(url.DASHBOARD_TEMPLATE_LIST_API, "GET");
export const dashboardTemplateDataAPI = (id) =>
  FetchAPI(`${url.DASHBOARD_TEMPLATE_DATA_API}/${id}`, "GET");
export const dashboardBoxListAPI = () =>
  FetchAPI(url.DASHBOARD_BOX_LIST_API, "GET");
export const dashboardTemplateCreateAPI = (data) =>
  FetchAPI(url.DASHBOARD_TEMPLATE_CREATE_API, "POST", data);
export const dashboardTemplateSaveLayoutAPI = (data) =>
  FetchAPI(url.DASHBOARD_TEMPLATE_SAVE_LAYOUT_API, "POST", data);
export const dashboardTemplateSetDefaultAPI = (data) =>
  FetchAPI(url.DASHBOARD_TEMPLATE_SET_DEFAULT_API, "PUT", data);
export const dashboardTemplateSetScopeAPI = (data) =>
  FetchAPI(url.DASHBOARD_TEMPLATE_SET_SCOPE_API, "PUT", data);
export const dashboardTemplateSetActiveAPI = (data) =>
  FetchAPI(url.DASHBOARD_TEMPLATE_SET_ACTIVE_API, "PUT", data);
export const dashboardTemplateDeleteAPI = (id) =>
  FetchAPI(`${url.DASHBOARD_TEMPLATE_DELETE_API}/${id}`, "DELETE");

// Recently Viewed API
export const recordRecentlyViewedAPI = (data) =>
  FetchAPI(url.RECORD_RECENTLY_VIEWED_API, "POST", data);
export const getRecentlyViewedListAPI = () =>
  FetchAPI(url.GET_RECENTLY_VIEWED_LIST_API, "GET");

//Liability API Calls
//getLiabilityListApi
//Get Liability List Api
export const getLiabilityListApi = () =>
  FetchAPI(url.GET_LIABILITY_LIST_API, "GET");
//getLiabilityDetailApi
//Get Liability Detail Api
export const getLiabilityDetailApi = (data) =>
  FetchAPI(url.GET_LIABILITY_DETAIL_API, "GET", data);
//createLiabilityApi
//Create Liability Api
export const createLiabilityApi = (data) =>
  FetchAPI(url.CREATE_LIABILITY_API, "POST", data);
//updateLiabilityApi
//Update Liability Api
export const updateLiabilityApi = (data) =>
  FetchAPI(url.UPDATE_LIABILITY_API, "PUT", data);
//deleteLiabilityApi
//Delete Liability Api
export const deleteLiabilityApi = (data) =>
  FetchAPI(url.DELETE_LIABILITY_API, "DELETE", data);
//getLiabilityProviderListApi
//Get Liability Provider List Api
export const getLiabilityProviderListApi = () =>
  FetchAPI(url.GET_LIABILITY_PROVIDER_LIST_API, "GET");
//getLiabilityProviderDetailApi
//Get Liability Provider Detail Api
export const getLiabilityProviderDetailApi = (data) =>
  FetchAPI(url.GET_LIABILITY_PROVIDER_DETAIL_API, "GET", data);
//createLiabilityProviderApi
//Create Liability Provider Api
export const createLiabilityProviderApi = (data) =>
  FetchAPI(url.CREATE_LIABILITY_PROVIDER_API, "POST", data);
//updateLiabilityProviderApi
//Update Liability Provider Api
export const updateLiabilityProviderApi = (data) =>
  FetchAPI(url.UPDATE_LIABILITY_PROVIDER_API, "PUT", data);
//deleteLiabilityProviderApi
//Delete Liability Provider Api
export const deleteLiabilityProviderApi = (data) =>
  FetchAPI(url.DELETE_LIABILITY_PROVIDER_API, "DELETE", data);
//getLiabilityStatusListApi
//Get Liability Status List Api
export const getLiabilityStatusListApi = () =>
  FetchAPI(url.GET_LIABILITY_STATUS_LIST_API, "GET");
//getLiabilityStatusDetailApi
//Get Liability Status Detail Api
export const getLiabilityStatusDetailApi = (data) =>
  FetchAPI(url.GET_LIABILITY_STATUS_DETAIL_API, "GET", data);
//createLiabilityStatusApi
//Create Liability Status Api
export const createLiabilityStatusApi = (data) =>
  FetchAPI(url.CREATE_LIABILITY_STATUS_API, "POST", data);
//updateLiabilityStatusApi
//Update Liability Status Api
export const updateLiabilityStatusApi = (data) =>
  FetchAPI(url.UPDATE_LIABILITY_STATUS_API, "PUT", data);
//deleteLiabilityStatusApi
//Delete Liability Status Api
export const deleteLiabilityStatusApi = (data) =>
  FetchAPI(url.DELETE_LIABILITY_STATUS_API, "DELETE", data);
//getLiabilityItemCategoryListApi
//Get Liability Item Category List Api
export const getLiabilityItemCategoryListApi = () =>
  FetchAPI(url.GET_LIABILITY_ITEM_CATEGORY_LIST_API, "GET");
//getLiabilityItemCategoryDetailApi
//Get Liability Item Category Detail Api
export const getLiabilityItemCategoryDetailApi = (data) =>
  FetchAPI(url.GET_LIABILITY_ITEM_CATEGORY_DETAIL_API, "GET", data);
//createLiabilityItemCategoryApi
//Create Liability Item Category Api
export const createLiabilityItemCategoryApi = (data) =>
  FetchAPI(url.CREATE_LIABILITY_ITEM_CATEGORY_API, "POST", data);
//updateLiabilityItemCategoryApi
//Update Liability Item Category Api
export const updateLiabilityItemCategoryApi = (data) =>
  FetchAPI(url.UPDATE_LIABILITY_ITEM_CATEGORY_API, "PUT", data);
//deleteLiabilityItemCategoryApi
//Delete Liability Item Category Api
export const deleteLiabilityItemCategoryApi = (data) =>
  FetchAPI(url.DELETE_LIABILITY_ITEM_CATEGORY_API, "DELETE", data);

//GeneralSettings
//getVatPeriodListApi
//Get Vat Period List Api
export const getVatPeriodListApi = () =>
  FetchAPI(url.GET_VAT_PERIOD_LIST_API, "GET");
//getVatPeriodDetailsApi
//Get Vat Period Details Api
export const getVatPeriodDetailsApi = (data) =>
  FetchAPI(url.GET_VAT_PERIOD_DETAILS_API, "GET", data);
//addVatPeriodApi
//Add Vat Period Api
export const addVatPeriodApi = (data) =>
  FetchAPI(url.ADD_VAT_PERIOD_API, "POST", data);
//updateVatPeriodApi
//Update Vat Period Api
export const updateVatPeriodApi = (data) =>
  FetchAPI(url.UPDATE_VAT_PERIOD_API, "PUT", data);
//deleteVatPeriodApi
//Delete Vat Period Api
export const deleteVatPeriodApi = (data) =>
  FetchAPI(url.DELETE_VAT_PERIOD_API, "DELETE", data);
//getRenewalFrequenciesListApi
//Get Renewal Frequencies List Api
export const getRenewalFrequenciesListApi = () =>
  FetchAPI(url.GET_RENEWAL_FREQUENCIES_LIST_API, "GET");
//getRenewalFrequenciesDetailsApi
//Get Renewal Frequencies Details Api
export const getRenewalFrequenciesDetailsApi = (data) =>
  FetchAPI(url.GET_RENEWAL_FREQUENCIES_DETAILS_API, "GET", data);
//addRenewalFrequenciesApi
//Add Renewal Frequencies Api
export const addRenewalFrequenciesApi = (data) =>
  FetchAPI(url.ADD_RENEWAL_FREQUENCIES_API, "POST", data);
//updateRenewalFrequenciesApi
//Update Renewal Frequencies Api
export const updateRenewalFrequenciesApi = (data) =>
  FetchAPI(url.UPDATE_RENEWAL_FREQUENCIES_API, "PUT", data);
//deleteRenewalFrequenciesApi
//Delete Renewal Frequencies Api
export const deleteRenewalFrequenciesApi = (data) =>
  FetchAPI(url.DELETE_RENEWAL_FREQUENCIES_API, "DELETE", data);
//getUnitFrequenciesListApi
//Get Unit Frequencies List Api
export const getUnitFrequenciesListApi = () =>
  FetchAPI(url.GET_UNIT_FREQUENCIES_LIST_API, "GET");
//getUnitFrequenciesDetailsApi
//Get Unit Frequencies Details Api
export const getUnitFrequenciesDetailsApi = (data) =>
  FetchAPI(url.GET_UNIT_FREQUENCIES_DETAILS_API, "GET", data);
//addUnitFrequenciesApi
//Add Unit Frequencies Api
export const addUnitFrequenciesApi = (data) =>
  FetchAPI(url.ADD_UNIT_FREQUENCIES_API, "POST", data);
//updateUnitFrequenciesApi
//Update Unit Frequencies Api
export const updateUnitFrequenciesApi = (data) =>
  FetchAPI(url.UPDATE_UNIT_FREQUENCIES_API, "PUT", data);
//deleteUnitFrequenciesApi
//Delete Unit Frequencies Api
export const deleteUnitFrequenciesApi = (data) =>
  FetchAPI(url.DELETE_UNIT_FREQUENCIES_API, "DELETE", data);
//getMasterTimeFrameListApi
//Get Master Time Frame List Api
export const getMasterTimeFrameListApi = () =>
  FetchAPI(url.GET_MASTER_TIME_FRAME_LIST_API, "GET");
//getMasterTimeFrameDetailsApi
//Get Master Time Frame Details Api
export const getMasterTimeFrameDetailsApi = (data) =>
  FetchAPI(url.GET_MASTER_TIME_FRAME_DETAILS_API, "GET", data);
//addMasterTimeFrameApi
//Add Master Time Frame Api
export const addMasterTimeFrameApi = (data) =>
  FetchAPI(url.ADD_MASTER_TIME_FRAME_API, "POST", data);
//updateMasterTimeFrameApi
//Update Master Time Frame Api
export const updateMasterTimeFrameApi = (data) =>
  FetchAPI(url.UPDATE_MASTER_TIME_FRAME_API, "PUT", data);
//deleteMasterTimeFrameApi
//Delete Master Time Frame Api
export const deleteMasterTimeFrameApi = (data) =>
  FetchAPI(url.DELETE_MASTER_TIME_FRAME_API, "DELETE", data);
//getLocalSettingsMasterConfigListApi
//Get Local Settings Master Config List Api
export const getLocalSettingsMasterConfigListApi = () =>
  FetchAPI(url.GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_API, "GET");
//updateLocalSettingsMasterConfigToggleApi
//Update Local Settings Master Config Toggle Api
export const updateLocalSettingsMasterConfigToggleApi = (data) =>
  FetchAPI(url.UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_API, "PUT", data);
//getLocalSettingsMasterConfigUserListApi
//Get Local Settings Master Config User List Api
export const getLocalSettingsMasterConfigUserListApi = () =>
  FetchAPI(url.GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_API, "GET");
//updateLocalSettingsMasterConfigUserApi
//Update Local Settings Master Config User Api
export const updateLocalSettingsMasterConfigUserApi = (data) =>
  FetchAPI(url.UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_API, "PUT", data);
//getConfigItemsCompanyEditableListApi - company Config Items screen
export const getConfigItemsCompanyEditableListApi = () =>
  FetchAPI(url.GET_CONFIG_ITEMS_COMPANY_EDITABLE, "GET");
//Master Config Item (Super Admin CRUD)
export const getMasterConfigItemListAll = () =>
  FetchAPI(url.GET_MASTER_CONFIG_ITEM_LIST_ALL, "GET");
export const createMasterConfigItem = (data) =>
  FetchAPI(url.CREATE_MASTER_CONFIG_ITEM, "POST", data);
export const updateMasterConfigItem = (data) =>
  FetchAPI(url.UPDATE_MASTER_CONFIG_ITEM, "PUT", data);
//Vat Period Export
//getVatInvoiceList
//Get Vat Invoice List
export const getVatInvoiceList = (data) =>
  FetchAPI(url.GET_VAT_INVOICE_LIST_API, "GET", data);
//getVatInvoiceItemList
//Get Vat Invoice Item List
export const getVatInvoiceItemList = (data) =>
  FetchAPI(url.GET_VAT_INVOICE_ITEM_LIST_API, "GET", data);
//getVatPurchaseList
//Get Vat Purchase List
export const getVatPurchaseList = (data) =>
  FetchAPI(url.GET_VAT_PURCHASE_LIST_API, "GET", data);
//getVatPurchaseItemList
//Get Vat Purchase Item List
export const getVatPurchaseItemList = (data) =>
  FetchAPI(url.GET_VAT_PURCHASE_ITEM_LIST_API, "GET", data);

//Year End Period
//getYearEndPeriodListApi
//Get Year End Period List Api
export const getYearEndPeriodListApi = () =>
  FetchAPI(url.GET_YEAR_END_PERIOD_LIST_API, "GET");
//getYearEndPeriodDetailsApi
//Get Year End Period Details Api
export const getYearEndPeriodDetailsApi = (data) =>
  FetchAPI(url.GET_YEAR_END_PERIOD_DETAILS_API, "GET", data);
//updateYearEndPeriodDetailsApi
//Update Year End Period Details Api
export const updateYearEndPeriodDetailsApi = (data) =>
  FetchAPI(url.UPDATE_YEAR_END_PERIOD_DETAILS_API, "PUT", data);
//createYearEndPeriodApi
//Create Year End Period Api
export const createYearEndPeriodApi = (data) =>
  FetchAPI(url.CREATE_YEAR_END_PERIOD_API, "POST", data);
//deleteYearEndPeriodApi
//Delete Year End Period Api
export const deleteYearEndPeriodApi = (data) =>
  FetchAPI(url.DELETE_YEAR_END_PERIOD_API, "DELETE", data);
//getYearEndPeriodInvoiceListApi
//Get Year End Period Invoice List Api
export const getYearEndPeriodInvoiceListApi = (data) =>
  FetchAPI(url.GET_YEAR_END_PERIOD_INVOICE_LIST_API, "GET", data);
//getYearEndPeriodInvoiceItemsListApi
//Get Year End Period Invoice Items List Api
export const getYearEndPeriodInvoiceItemsListApi = (data) =>
  FetchAPI(url.GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_API, "GET", data);
//getYearEndPeriodPurchaseListApi
//Get Year End Period Purchase List Api
export const getYearEndPeriodPurchaseListApi = (data) =>
  FetchAPI(url.GET_YEAR_END_PERIOD_PURCHASE_LIST_API, "GET", data);
//getYearEndPeriodPurchaseItemsListApi
//Get Year End Period Purchase Items List Api
export const getYearEndPeriodPurchaseItemsListApi = (data) =>
  FetchAPI(url.GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_API, "GET", data);
//getSecurityAuthRoleListApi
//Get Security Auth Role List Api
export const getSecurityAuthRoleListApi = () =>
  FetchAPI(url.GET_SECURITY_AUTH_ROLE_LIST_API, "GET");
//getSecurityAuthRoleByIdApi
//Get Security Auth Role By Id Api
export const getSecurityAuthRoleByIdApi = (data) =>
  FetchAPI(url.GET_SECURITY_AUTH_ROLE_BY_ID_API, "GET", data);
//createSecurityAuthRoleApi
//Create Security Auth Role Api
export const createSecurityAuthRoleApi = (data) =>
  FetchAPI(url.CREATE_SECURITY_AUTH_ROLE_API, "POST", data);
//updateSecurityAuthRoleApi
//Update Security Auth Role Api
export const updateSecurityAuthRoleApi = (data) =>
  FetchAPI(url.UPDATE_SECURITY_AUTH_ROLE_API, "PUT", data);
//deleteSecurityAuthRoleApi
//Delete Security Auth Role Api
export const deleteSecurityAuthRoleApi = (data) =>
  FetchAPI(url.DELETE_SECURITY_AUTH_ROLE_API, "DELETE", data);
//getMasterSecurityAuthCapabilityListApi
//Get Master Security Auth Capability List Api
export const getMasterSecurityAuthCapabilityListApi = () =>
  FetchAPI(url.GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_API, "GET");
//getSecurityAuthRoleToUserListApi
//Get Security Auth Role To User List Api
export const getSecurityAuthRoleToUserListApi = (data) =>
  FetchAPI(url.GET_SECURITY_AUTH_ROLE_TO_USER_LIST_API, "GET", data);
//createSecurityAuthRoleToUserApi
//Create Security Auth Role To User Api
export const createSecurityAuthRoleToUserApi = (data) =>
  FetchAPI(url.CREATE_SECURITY_AUTH_ROLE_TO_USER_API, "POST", data);
//updateSecurityAuthRoleToUserApi
//Update Security Auth Role To User Api (Task 24736 - StartDate/EndDate)
export const updateSecurityAuthRoleToUserApi = (data) =>
  FetchAPI(url.UPDATE_SECURITY_AUTH_ROLE_TO_USER_API, "PUT", data);
//deleteSecurityAuthRoleToUserApi
//Delete Security Auth Role To User Api
export const deleteSecurityAuthRoleToUserApi = (data) =>
  FetchAPI(url.DELETE_SECURITY_AUTH_ROLE_TO_USER_API, "DELETE", data);
//createSecurityAuthMissingRequestApi
//Create Security Auth Missing Request Api
export const createSecurityAuthMissingRequestApi = (data) =>
  FetchAPI(url.CREATE_SECURITY_AUTH_MISSING_REQUEST_API, "POST", data);
//Master Reporting APIS
//getMasterReportingItemsApi
//Get Master Reporting Items Api
export const getMasterReportingItemsApi = () =>
  FetchAPI(url.GET_MASTER_REPORTING_ITEMS_API, "GET");
//getMasterReportingItemListApi
//Get Master Reporting Item List Api
export const getMasterReportingItemListApi = () =>
  FetchAPI(url.GET_MASTER_REPORTING_ITEM_LIST_API, "GET");
//getMasterReportingItemDataApi
//Get Master Reporting Item Data Api
export const getMasterReportingItemDataApi = (data) =>
  FetchAPI(url.GET_MASTER_REPORTING_ITEM_DATA_API, "GET", data);
//  Acquisition Channel  Api's
//getAcquisitionChannelListApi
export const getAcquisitionChannelListApi = () =>
  FetchAPI(url.GET_ACQUISITION_CHANNEL_LIST_API, "GET");
//getAcquisitionChannelDataApi
export const getAcquisitionChannelDataApi = (data) =>
  FetchAPI(url.GET_ACQUISITION_CHANNEL_DATA_API, "GET", data);
//createAcquisitionChannelApi
export const createAcquisitionChannelApi = (data) =>
  FetchAPI(url.CREATE_ACQUISITION_CHANNEL_API, "POST", data);
//updateAcquisitionChannelApi
export const updateAcquisitionChannelApi = (data) =>
  FetchAPI(url.UPDATE_ACQUISITION_CHANNEL_API, "PUT", data);
//deleteAcquisitionChannelApi
export const deleteAcquisitionChannelApi = (data) =>
  FetchAPI(url.DELETE_ACQUISITION_CHANNEL_API, "DELETE", data);
//Apointments appi calls
//appointmentListAPI
export const appointmentListAPI = () =>
  FetchAPI(url.APPOINTMENT_LIST_API, "GET");
//appointmentDataAPI
export const appointmentDataAPI = (data) =>
  FetchAPI(url.APPOINTMENT_DATA_API, "GET", data);
//appointmentCreateAPI
export const appointmentCreateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_CREATE_API, "POST", data);
//appointmentUpdateAPI
export const appointmentUpdateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_UPDATE_API, "PUT", data);
//appointmentDeleteAPI
export const appointmentDeleteAPI = (data) =>
  FetchAPI(url.APPOINTMENT_DELETE_API, "DELETE", data);
//appointmentSearchAPI
export const appointmentSearchAPI = (data) =>
  FetchAPI(url.APPOINTMENT_SEARCH_API, "POST", data);
//appointmentTypeListAPI
export const appointmentTypeListAPI = () =>
  FetchAPI(url.APPOINTMENT_TYPE_LIST_API, "GET");
//appointmentTypeDataAPI
export const appointmentTypeDataAPI = (data) =>
  FetchAPI(url.APPOINTMENT_TYPE_DATA_API, "GET", data);
//appointmentTypeCreateAPI
export const appointmentTypeCreateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_TYPE_CREATE_API, "POST", data);
//appointmentTypeUpdateAPI
export const appointmentTypeUpdateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_TYPE_UPDATE_API, "PUT", data);
//appointmentTypeDeleteAPI
export const appointmentTypeDeleteAPI = (data) =>
  FetchAPI(url.APPOINTMENT_TYPE_DELETE_API, "DELETE", data);
//appointmentStatusListAPI
export const appointmentStatusListAPI = () =>
  FetchAPI(url.APPOINTMENT_STATUS_LIST_API, "GET");
//appointmentStatusDataAPI
export const appointmentStatusDataAPI = (data) =>
  FetchAPI(url.APPOINTMENT_STATUS_DATA_API, "GET", data);
//appointmentStatusCreateAPI
export const appointmentStatusCreateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_STATUS_CREATE_API, "POST", data);
//appointmentStatusUpdateAPI
export const appointmentStatusUpdateAPI = (data) =>
  FetchAPI(url.APPOINTMENT_STATUS_UPDATE_API, "PUT", data);
//appointmentStatusDeleteAPI
export const appointmentStatusDeleteAPI = (data) =>
  FetchAPI(url.APPOINTMENT_STATUS_DELETE_API, "DELETE", data);
//appointmentSearchSpecificListAPI
export const appointmentSearchSpecificListAPI = (data) =>
  FetchAPI(url.APPOINTMENT_SEARCH_SPECIFIC_LIST_API, "POST", data);

//diarySlotSearchAPI
export const diarySlotSearchAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_SEARCH_API, "POST", data);

//diarySlotAssigneeSearchAPI
export const diarySlotAssigneeSearchAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_ASSIGNEE_SEARCH_API, "POST", data);

//diarySlotCheckAvailabilityAPI
export const diarySlotCheckAvailabilityAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_CHECK_AVAILABILITY_API, "POST", data);

//diarySlotUpdateAPI (Task 24646)
export const diarySlotUpdateAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_UPDATE_API, "PUT", data);
// Change #100483 - body is an array of slot Ids, e.g. [44].
export const diarySlotDeleteAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_DELETE_API, "DELETE", data);
// Change #100483 - body is [{ Id }]; slot goes back to Unscheduled.
export const diarySlotUnassignAllAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_UNASSIGN_ALL_API, "POST", data);
//diarySlotBookAPI
export const diarySlotBookAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_BOOK_API, "POST", data);
// Change #100537 - [{ ...booking, basket_list: [{ StartDateTime, EndDateTime, Staff_Id, AdditionalStaff_Ids }] }]
export const diarySlotBookBasketAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_BOOK_BASKET_API, "POST", data);
// Change #100699 - [{ StartDate?, EndDate?, DispatchBoard_Id? }] -> optionpick_data / optionpick_list
export const diarySlotOptionPickStatsAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_OPTION_PICK_STATS_API, "POST", data);
// Change #100705 - [{ DispatchBoard_Id?, legs: [{ Key, FromLat, FromLng, ToLat, ToLng }] }] -> travelleg_list [{ Key, Minutes, Miles, Source }]
export const diarySlotTravelLegsAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_TRAVEL_LEGS_API, "POST", data);
// Change #100537 - [{ Id, Scope: "PERSON" | "DAY" | "TASK", Staff_Id, Reason }]
export const diarySlotCancelPartAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_CANCEL_PART_API, "POST", data);
// Change #100605 - [{ Staff_Id, StartDateTime, EndDateTime, InternalPurpose, CompanySiteLocation_Id, Notes, Asset_Ids }]
export const diarySlotCreateInternalAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_CREATE_INTERNAL_API, "POST", data);
// Change #100605 - [{ Id, Asset_Ids? }]
export const diarySlotConfirmCollectionAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_CONFIRM_COLLECTION_API, "POST", data);
// Change #100537 - [{ Id, SlotStatus }]
export const diarySlotStatusAPI = (data) =>
  FetchAPI(url.DIARY_SLOT_STATUS_API, "POST", data);
//timeEntriesSummaryDailyApi
export const timeEntriesSummaryDailyApi = (data) =>
  FetchAPI(url.TIME_ENTRIES_SUMMARY_DAILY_API, "POST", data);

//foodPreOrderEventListApi
export const foodPreOrderEventListApi = () =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_LIST_API, "GET");
//foodPreOrderEventSearchApi
export const foodPreOrderEventSearchApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_SEARCH_API, "POST", data);
//foodPreOrderEventDataApi
export const foodPreOrderEventDataApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_DATA_API, "GET", data, token);
//foodPreOrderEventCreateApi
export const foodPreOrderEventCreateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_CREATE_API, "POST", data);
//foodPreOrderEventUpdateApi
export const foodPreOrderEventUpdateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_UPDATE_API, "PUT", data);
//foodPreOrderEventDeleteApi
export const foodPreOrderEventDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_DELETE_API, "DELETE", data);
//foodPreOrderEventGuestListApi
export const foodPreOrderEventGuestListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_LIST_API, "GET", data);
//foodPreOrderEventGuestSearchApi
export const foodPreOrderEventGuestSearchApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_SEARCH_API, "POST", data, token);
//foodPreOrderEventGuestDataApi
export const foodPreOrderEventGuestDataApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_DATA_API, "GET", data, token);
//foodPreOrderEventGuestInviteApi
export const foodPreOrderEventGuestInviteApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_INVITE_API, "POST", data, token);
//foodPreOrderEventGuestDeleteApi
export const foodPreOrderEventGuestDeleteApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_DELETE_API, "DELETE", data, token);
//foodMenuStatusListApi
export const foodMenuStatusListApi = () =>
  FetchAPI(url.FOOD_MENU_STATUS_LIST_API, "GET");
//foodMenuStatusDataApi
export const foodMenuStatusDataApi = (data) =>
  FetchAPI(url.FOOD_MENU_STATUS_DATA_API, "GET", data);
//foodMenuStatusCreateApi
export const foodMenuStatusCreateApi = (data) =>
  FetchAPI(url.FOOD_MENU_STATUS_CREATE_API, "POST", data);
// foodMenuStatusUpdateApi,
export const foodMenuStatusUpdateApi = (data) =>
  FetchAPI(url.FOOD_MENU_STATUS_UPDATE_API, "PUT", data);
//     foodMenuStatusDeleteApi,
export const foodMenuStatusDeleteApi = (data) =>
  FetchAPI(url.FOOD_MENU_STATUS_DELETE_API, "DELETE", data);
//     foodMenuListApi,
export const foodMenuListApi = () => FetchAPI(url.FOOD_MENU_LIST_API, "GET");
//     foodMenuDataApi,
export const foodMenuDataApi = (data) =>
  FetchAPI(url.FOOD_MENU_DATA_API, "GET", data);
//     foodMenuCreateApi,
export const foodMenuCreateApi = (data) =>
  FetchAPI(url.FOOD_MENU_CREATE_API, "POST", data);
//     foodMenuUpdateApi,
export const foodMenuUpdateApi = (data) =>
  FetchAPI(url.FOOD_MENU_UPDATE_API, "PUT", data);
//     foodMenuDeleteApi,
export const foodMenuDeleteApi = (data) =>
  FetchAPI(url.FOOD_MENU_DELETE_API, "DELETE", data);
//     foodMenuCategoryListApi,
export const foodMenuCategoryListApi = () =>
  FetchAPI(url.FOOD_MENU_CATEGORY_LIST_API, "GET");
//     foodMenuCategoryDataApi,
export const foodMenuCategoryDataApi = (data) =>
  FetchAPI(url.FOOD_MENU_CATEGORY_DATA_API, "GET", data);
//     foodMenuCategoryCreateApi,
export const foodMenuCategoryCreateApi = (data) =>
  FetchAPI(url.FOOD_MENU_CATEGORY_CREATE_API, "POST", data);
//     foodMenuCategoryUpdateApi,
export const foodMenuCategoryUpdateApi = (data) =>
  FetchAPI(url.FOOD_MENU_CATEGORY_UPDATE_API, "PUT", data);
//     foodMenuCategoryDeleteApi,
export const foodMenuCategoryDeleteApi = (data) =>
  FetchAPI(url.FOOD_MENU_CATEGORY_DELETE_API, "DELETE", data);
//     foodMenuItemListApi,
export const foodMenuItemListApi = () =>
  FetchAPI(url.FOOD_MENU_ITEM_LIST_API, "GET");
//     foodMenuItemDataApi,
export const foodMenuItemDataApi = (data) =>
  FetchAPI(url.FOOD_MENU_ITEM_DATA_API, "GET", data);
//     foodMenuItemCreateApi,
export const foodMenuItemCreateApi = (data) =>
  FetchAPI(url.FOOD_MENU_ITEM_CREATE_API, "POST", data);
//     foodMenuItemUpdateApi,
export const foodMenuItemUpdateApi = (data) =>
  FetchAPI(url.FOOD_MENU_ITEM_UPDATE_API, "PUT", data);
//     foodMenuItemDeleteApi,
export const foodMenuItemDeleteApi = (data) =>
  FetchAPI(url.FOOD_MENU_ITEM_DELETE_API, "DELETE", data);
//     foodPreOrderEventStatusListApi,
export const foodPreOrderEventStatusListApi = () =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_STATUS_LIST_API, "GET");
//     foodPreOrderEventStatusDataApi,
export const foodPreOrderEventStatusDataApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_STATUS_DATA_API, "GET", data);
//     foodPreOrderEventStatusCreateApi,
export const foodPreOrderEventStatusCreateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_STATUS_CREATE_API, "POST", data);
//     foodPreOrderEventStatusUpdateApi,
export const foodPreOrderEventStatusUpdateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_STATUS_UPDATE_API, "PUT", data);
//     foodPreOrderEventStatusDeleteApi,
export const foodPreOrderEventStatusDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_STATUS_DELETE_API, "DELETE", data);
//     foodPreOrderEventTypeListApi,
export const foodPreOrderEventTypeListApi = () =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_TYPE_LIST_API, "GET");
//     foodPreOrderEventTypeDataApi,
export const foodPreOrderEventTypeDataApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_TYPE_DATA_API, "GET", data);
//     foodPreOrderEventTypeCreateApi,
export const foodPreOrderEventTypeCreateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_TYPE_CREATE_API, "POST", data);
//     foodPreOrderEventTypeUpdateApi,
export const foodPreOrderEventTypeUpdateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_TYPE_UPDATE_API, "PUT", data);
//     foodPreOrderEventTypeDeleteApi,
export const foodPreOrderEventTypeDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_TYPE_DELETE_API, "DELETE", data);
//     foodMenuTypeListApi,
export const foodMenuTypeListApi = () =>
  FetchAPI(url.FOOD_MENU_TYPE_LIST_API, "GET");
//     foodMenuTypeDataApi,
export const foodMenuTypeDataApi = (data) =>
  FetchAPI(url.FOOD_MENU_TYPE_DATA_API, "GET", data);
//     foodMenuTypeCreateApi,
export const foodMenuTypeCreateApi = (data) =>
  FetchAPI(url.FOOD_MENU_TYPE_CREATE_API, "POST", data);
//     foodMenuTypeUpdateApi,
export const foodMenuTypeUpdateApi = (data) =>
  FetchAPI(url.FOOD_MENU_TYPE_UPDATE_API, "PUT", data);
//     foodMenuTypeDeleteApi,
export const foodMenuTypeDeleteApi = (data) =>
  FetchAPI(url.FOOD_MENU_TYPE_DELETE_API, "DELETE", data);
//     foodPreOrderSiteLocationListApi,
export const foodPreOrderSiteLocationListApi = () =>
  FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_LIST_API, "GET");
//     foodPreOrderSiteLocationDataApi,
export const foodPreOrderSiteLocationDataApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_DATA_API, "GET", data);
//     foodPreOrderSiteLocationCreateApi,
export const foodPreOrderSiteLocationCreateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_CREATE_API, "POST", data);
//     foodPreOrderSiteLocationUpdateApi,
export const foodPreOrderSiteLocationUpdateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_UPDATE_API, "PUT", data);
//     foodPreOrderSiteLocationDeleteApi,
export const foodPreOrderSiteLocationDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_DELETE_API, "DELETE", data);
//foodPreOrderEventGuestToFoodMenuItemCreateApi
export const foodPreOrderEventGuestToFoodMenuItemCreateApi = (data, token) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_API,
    "POST",
    data,
    token
  );
//foodPreOrderEventGuestAcceptApi
export const foodPreOrderEventGuestAcceptApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_ACCEPT_API, "GET", data, token);
//foodPreOrderEventGuestDeclineApi
export const foodPreOrderEventGuestDeclineApi = (data, token) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_DECLINE_API, "GET", data, token);
//foodMenuSearchApi
export const foodMenuSearchApi = (data, token) =>
  FetchAPI(url.FOOD_MENU_SEARCH_API, "POST", data, token);
//foodPreOrderEventEmailOrganiserEventReadyApi
export const foodPreOrderEventEmailOrganiserEventReadyApi = (data) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_API,
    "GET",
    data
  );
//foodPreOrderEventGuestInviteResendApi
export const foodPreOrderEventGuestInviteResendApi = (data, token) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GUEST_INVITE_RESEND_API,
    "GET",
    data,
    token
  );
// foodPreOrderEventPdfGuestListConfirmedApi,
export const foodPreOrderEventPdfGuestListConfirmedApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_API, "GET", data);
//     foodPreOrderEventPdfKitchenMealPlanApi,
export const foodPreOrderEventPdfKitchenMealPlanApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_API, "GET", data);
//     foodPreOrderEventPdfTableTentCardsApi,
export const foodPreOrderEventPdfTableTentCardsApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_PDF_TABLE_TENT_CARDS_API, "POST", data);
//foodPreOrderEventRecentActivityListApi
export const foodPreOrderEventRecentActivityListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_API, "GET", data);
//foodPreOrderEventCommunicationListApi
export const foodPreOrderEventCommunicationListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_COMMUNICATION_LIST_API, "GET", data);
//companiesHouseGovUKSearchCompaniesApi
export const companiesHouseGovUKSearchCompaniesApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_GOV_UK_SEARCH_COMPANIES_API, "GET", data);
//companiesHouseGovUKGetFilingHistoryApi
export const companiesHouseGovUKGetFilingHistoryApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_GOV_UK_GET_FILING_HISTORY_API, "GET", data);

export const companiesHouseGovUKGetOfficersApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_GOV_UK_GET_OFFICERS_API, "POST", data);

//foodPreOrderEventSmsOrganiserEventReadyApi
export const foodPreOrderEventSmsOrganiserEventReadyApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_SMS_ORGANISER_EVENT_READY_API, "GET", data);
//foodMenuItemSearchApi
export const foodMenuItemSearchApi = (data) =>
  FetchAPI(url.FOOD_MENU_ITEM_SEARCH_API, "POST", data);
//foodPreOrderEventPdfFrontOfHouseMealPlanApi
export const foodPreOrderEventPdfFrontOfHouseMealPlanApi = (data) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API,
    "GET",
    data
  );
//foodPreOrderEventGuestPaymentListApi
export const foodPreOrderEventGuestPaymentListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_LIST_API, "GET", data);
//foodPreOrderEventGuestPaymentSearchApi
export const foodPreOrderEventGuestPaymentSearchApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GUEST_PAYMENT_SEARCH_API, "POST", data);
//foodPreOrderEventGroupListApi
export const foodPreOrderEventGroupListApi = () =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_LIST_API, "GET");
//foodPreOrderEventGroupDataApi
export const foodPreOrderEventGroupDataApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_DATA_API, "GET", data);
//foodPreOrderEventGroupCreateApi
export const foodPreOrderEventGroupCreateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_CREATE_API, "POST", data);
//foodPreOrderEventGroupUpdateApi
export const foodPreOrderEventGroupUpdateApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_UPDATE_API, "PUT", data);
//foodPreOrderEventGroupDeleteApi
export const foodPreOrderEventGroupDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_DELETE_API, "DELETE", data);
//foodPreOrderEventRecentActivityListDataApi
export const foodPreOrderEventRecentActivityListDataApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_API, "GET", data);
//foodPreOrderEventGroupPdfKitchenMealPlanApi
export const foodPreOrderEventGroupPdfKitchenMealPlanApi = (data) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_API,
    "GET",
    data
  );
//foodPreOrderEventGroupPdfFrontOfHouseMealPlanApi
export const foodPreOrderEventGroupPdfFrontOfHouseMealPlanApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupPdfTableTentCardsApi
export const foodPreOrderEventGroupPdfTableTentCardsApi = (data) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_API,
    "POST",
    data
  );
//foodPreOrderEventGroupPdfGuestListConfirmedApi
export const foodPreOrderEventGroupPdfGuestListConfirmedApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupPdfTablePlanListApi
export const foodPreOrderEventGroupPdfTablePlanListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_API, "GET", data);
//foodPreOrderEventGroupCsvKitchenMealPlanApi
export const foodPreOrderEventGroupCsvKitchenMealPlanApi = (data) =>
  FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_API,
    "GET",
    data
  );
//foodPreOrderEventGroupCsvFrontOfHouseMealPlanApi
export const foodPreOrderEventGroupCsvFrontOfHouseMealPlanApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupCsvGuestListConfirmedApi
export const foodPreOrderEventGroupCsvGuestListConfirmedApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupCsvTablePlanListApi
export const foodPreOrderEventGroupCsvTablePlanListApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_API, "GET", data);
//foodPreOrderEventCsvKitchenMealPlanApi
export const foodPreOrderEventCsvKitchenMealPlanApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_API,
    "GET",
    data
  );
};
//foodPreOrderEventCsvFrontOfHouseMealPlanApi
export const foodPreOrderEventCsvFrontOfHouseMealPlanApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_API,
    "GET",
    data
  );
};
//foodPreOrderEventCsvGuestListConfirmedApi
export const foodPreOrderEventCsvGuestListConfirmedApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupCsvDrinkListByTableApi
export const foodPreOrderEventGroupCsvDrinkListByTableApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_API,
    "GET",
    data
  );
};
//foodPreOrderEventGroupPdfDrinkListByTableApi
export const foodPreOrderEventGroupPdfDrinkListByTableApi = (data) => {
  return FetchAPI(
    url.FOOD_PRE_ORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_API,
    "GET",
    data
  );
};
//foodPreOrderSiteLocationSearchApi
export const foodPreOrderSiteLocationSearchApi = (data) => {
  return FetchAPI(url.FOOD_PRE_ORDER_SITE_LOCATION_SEARCH_API, "POST", data);
};
//foodMenuCloneApi
export const foodMenuCloneApi = (data) =>
  FetchAPI(url.FOOD_MENU_CLONE_API, "POST", data);
//getMasterCompanyUsageStatsApi
export const getMasterCompanyUsageStatsApi = () =>
  FetchAPI(url.GET_MASTER_COMPANY_USAGE_STATS_API, "GET");
//getMasterCompanyUsageStatsByIdApi
export const getMasterCompanyUsageStatsByIdApi = (data) =>
  FetchAPI(url.GET_MASTER_COMPANY_USAGE_STATS_BY_ID_API, "GET", data);
//getCompanyListApi
export const getCompanyListApi = () =>
  FetchAPI(url.GET_COMPANY_LIST_API, "GET");
//getCompanyByIdApi
export const getCompanyByIdApi = (data) =>
  FetchAPI(url.GET_COMPANY_BY_ID_API, "GET", data);
//getCompanyRecentActivityListApi
export const getCompanyRecentActivityListApi = (data) =>
  FetchAPI(url.GET_COMPANY_RECENT_ACTIVITY_LIST_API, "GET", data);
//masterInvoiceSearchApi
export const masterInvoiceSearchApi = (data) =>
  FetchAPI(url.MASTER_INVOICE_SEARCH_API, "POST", data);
//masterInvoicePdfApi
export const masterInvoicePdfApi = (data) =>
  FetchAPI(url.MASTER_INVOICE_PDF_API, "GET", data);
//masterSystemErrorLogListApi
export const masterSystemErrorLogListApi = () =>
  FetchAPI(url.MASTER_SYSTEM_ERROR_LOG_LIST_API, "GET");
//masterSystemErrorLogDataApi
export const masterSystemErrorLogDataApi = (data) =>
  FetchAPI(url.MASTER_SYSTEM_ERROR_LOG_DATA_API, "GET", data);
//masterSystemErrorLogSearchApi
export const masterSystemErrorLogSearchApi = (data) =>
  FetchAPI(url.MASTER_SYSTEM_ERROR_LOG_SEARCH_API, "POST", data);
//masterUserListApi
export const masterUserListApi = () =>
  FetchAPI(url.MASTER_USER_LIST_API, "GET");
//masterRecentActivityListApi
export const masterRecentActivityListApi = (data) =>
  FetchAPI(url.MASTER_RECENT_ACTIVITY_LIST_API, "GET", data);
//**********GPS
//sendMyCurrentLocationApi
export const sendMyCurrentLocationApi = (data) =>
  FetchAPI(url.SEND_MY_CURRENT_LOCATION_API, "PUT", data);

//******************Vehicles
//listVehiclesApi
export const listVehiclesApi = () => FetchAPI(url.LIST_VEHICLES_API, "GET");
//createVehicleApi
export const createVehicleApi = (data) =>
  FetchAPI(url.CREATE_VEHICLE_API, "POST", data);
//deleteVehicleApi
export const deleteVehicleApi = (data) =>
  FetchAPI(url.DELETE_VEHICLE_API, "DELETE", data);
//updateVehicleApi
export const updateVehicleApi = (data) =>
  FetchAPI(url.UPDATE_VEHICLE_API, "PUT", data);
//getVehicleDetailsApi
export const getVehicleDetailsApi = (data) =>
  FetchAPI(url.GET_VEHICLE_DETAILS_API, "GET", data);
//listVehicleStatusApi
export const listVehicleStatusApi = () =>
  FetchAPI(url.LIST_VEHICLE_STATUS_API, "GET");
//createVehicleStatusApi
export const createVehicleStatusApi = (data) =>
  FetchAPI(url.CREATE_VEHICLE_STATUS_API, "POST", data);
//updateVehicleStatusApi
export const updateVehicleStatusApi = (data) =>
  FetchAPI(url.UPDATE_VEHICLE_STATUS_API, "PUT", data);
//deleteVehicleStatusApi
export const deleteVehicleStatusApi = (data) =>
  FetchAPI(url.DELETE_VEHICLE_STATUS_API, "DELETE", data);
//listVehicleTypeApi
export const listVehicleTypeApi = () =>
  FetchAPI(url.LIST_VEHICLE_TYPE_API, "GET");
//createVehicleTypeApi
export const createVehicleTypeApi = (data) =>
  FetchAPI(url.CREATE_VEHICLE_TYPE_API, "POST", data);
//updateVehicleTypeApi
export const updateVehicleTypeApi = (data) =>
  FetchAPI(url.UPDATE_VEHICLE_TYPE_API, "PUT", data);
//deleteVehicleTypeApi
export const deleteVehicleTypeApi = (data) =>
  FetchAPI(url.DELETE_VEHICLE_TYPE_API, "DELETE", data);
//listVehicleRecentActivityApi
export const listVehicleRecentActivityApi = (data) =>
  FetchAPI(url.LIST_VEHICLE_RECENT_ACTIVITY_API, "GET", data);
//searchVehicleApi
export const searchVehicleApi = (data) =>
  FetchAPI(url.SEARCH_VEHICLE_API, "POST", data);

//******************CompanyVehicle (fleet)
//listCompanyVehiclesApi
export const listCompanyVehiclesApi = () =>
  FetchAPI(url.LIST_COMPANY_VEHICLES_API, "GET");
//getCompanyVehicleDetailsApi
export const getCompanyVehicleDetailsApi = (data) =>
  FetchAPI(url.GET_COMPANY_VEHICLE_DETAILS_API, "GET", data);
//createCompanyVehicleApi
export const createCompanyVehicleApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_API, "POST", data);
//updateCompanyVehicleApi
export const updateCompanyVehicleApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_API, "PUT", data);
//deleteCompanyVehicleApi
export const deleteCompanyVehicleApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_API, "DELETE", data);
//searchCompanyVehicleApi
export const searchCompanyVehicleApi = (data) =>
  FetchAPI(url.SEARCH_COMPANY_VEHICLE_API, "POST", data);
//dvlaLookupCompanyVehicleApi - Change #100720. Plate goes on the URL.
export const dvlaLookupCompanyVehicleApi = (registrationPlate) =>
  FetchAPI(
    url.DVLA_LOOKUP_COMPANY_VEHICLE_API +
      "/" +
      encodeURIComponent(registrationPlate),
    "GET"
  );
//listCompanyVehicleStatusApi
export const listCompanyVehicleStatusApi = () =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_STATUS_API, "GET");
//createCompanyVehicleStatusApi
export const createCompanyVehicleStatusApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_STATUS_API, "POST", data);
//updateCompanyVehicleStatusApi
export const updateCompanyVehicleStatusApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_STATUS_API, "PUT", data);
//deleteCompanyVehicleStatusApi
export const deleteCompanyVehicleStatusApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_STATUS_API, "DELETE", data);
//listCompanyVehicleTypeApi
export const listCompanyVehicleTypeApi = () =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_TYPE_API, "GET");
//createCompanyVehicleTypeApi
export const createCompanyVehicleTypeApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_TYPE_API, "POST", data);
//updateCompanyVehicleTypeApi
export const updateCompanyVehicleTypeApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_TYPE_API, "PUT", data);
//deleteCompanyVehicleTypeApi
export const deleteCompanyVehicleTypeApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_TYPE_API, "DELETE", data);
//listCompanyVehicleCheckTypeApi
export const listCompanyVehicleCheckTypeApi = () =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_CHECK_TYPE_API, "GET");
//createCompanyVehicleCheckTypeApi
export const createCompanyVehicleCheckTypeApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_CHECK_TYPE_API, "POST", data);
//updateCompanyVehicleCheckTypeApi
export const updateCompanyVehicleCheckTypeApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_CHECK_TYPE_API, "PUT", data);
//deleteCompanyVehicleCheckTypeApi
export const deleteCompanyVehicleCheckTypeApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_CHECK_TYPE_API, "DELETE", data);
//getCompanyVehicleMapApi - Change #100680. refresh = pull GPSLive first.
// FetchAPI adds no query string to a GET, so it goes on the URL here.
export const getCompanyVehicleMapApi = (refresh) =>
  FetchAPI(url.COMPANY_VEHICLE_MAP_API + (refresh ? "?refresh=1" : ""), "GET");
//listCompanyVehicleCheckScheduleApi - Change #100679
export const listCompanyVehicleCheckScheduleApi = () =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_CHECK_SCHEDULE_API, "GET");
//createCompanyVehicleCheckScheduleApi - data = [ { Name, ...fields } ]
export const createCompanyVehicleCheckScheduleApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_CHECK_SCHEDULE_API, "POST", data);
//updateCompanyVehicleCheckScheduleApi - data = [ { Id, ...fields } ]
export const updateCompanyVehicleCheckScheduleApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_CHECK_SCHEDULE_API, "PUT", data);
//deleteCompanyVehicleCheckScheduleApi - data = [ Id ]
export const deleteCompanyVehicleCheckScheduleApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_CHECK_SCHEDULE_API, "DELETE", data);
//listCompanyVehicleCheckApi - data = { id: CompanyVehicle_Id }
export const listCompanyVehicleCheckApi = (data) =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_CHECK_API, "GET", data);
//createCompanyVehicleCheckApi
export const createCompanyVehicleCheckApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_CHECK_API, "POST", data);
//updateCompanyVehicleCheckApi
export const updateCompanyVehicleCheckApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_CHECK_API, "PUT", data);
//deleteCompanyVehicleCheckApi
export const deleteCompanyVehicleCheckApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_CHECK_API, "DELETE", data);
//listCompanyVehicleToStaffApi - data = { id: CompanyVehicle_Id }
export const listCompanyVehicleToStaffApi = (data) =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_TO_STAFF_API, "GET", data);
//createCompanyVehicleToStaffApi
export const createCompanyVehicleToStaffApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_TO_STAFF_API, "POST", data);
//updateCompanyVehicleToStaffApi
export const updateCompanyVehicleToStaffApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_TO_STAFF_API, "PUT", data);
//deleteCompanyVehicleToStaffApi
export const deleteCompanyVehicleToStaffApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_TO_STAFF_API, "DELETE", data);
//searchCompanyVehicleToStaffApi - data = [{ companyvehicletostaff_data: { Staff_Id, CompanyVehicle_Id, FlagOpen, ... } }]
export const searchCompanyVehicleToStaffApi = (data) =>
  FetchAPI(url.SEARCH_COMPANY_VEHICLE_TO_STAFF_API, "POST", data);
//checkoutCompanyVehicleApi - single flat object body
export const checkoutCompanyVehicleApi = (data) =>
  FetchAPI(url.CHECKOUT_COMPANY_VEHICLE_API, "POST", data);
//checkinCompanyVehicleApi - single flat object body
export const checkinCompanyVehicleApi = (data) =>
  FetchAPI(url.CHECKIN_COMPANY_VEHICLE_API, "PUT", data);
//listCompanyVehicleNoteApi - data = { id: CompanyVehicle_Id }
export const listCompanyVehicleNoteApi = (data) =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_NOTE_API, "GET", data);
//createCompanyVehicleNoteApi
export const createCompanyVehicleNoteApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_NOTE_API, "POST", data);
//updateCompanyVehicleNoteApi
export const updateCompanyVehicleNoteApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_NOTE_API, "PUT", data);
//deleteCompanyVehicleNoteApi
export const deleteCompanyVehicleNoteApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_NOTE_API, "DELETE", data);
//listCompanyVehicleRecentActivityApi - data = { id: CompanyVehicle_Id }
export const listCompanyVehicleRecentActivityApi = (data) =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_RECENT_ACTIVITY_API, "GET", data);
//listCompanyVehicleGpsTrackerApi - data = { id: CompanyVehicle_Id }
export const listCompanyVehicleGpsTrackerApi = (data) =>
  FetchAPI(url.LIST_COMPANY_VEHICLE_GPS_TRACKER_API, "GET", data);
//createCompanyVehicleGpsTrackerApi
export const createCompanyVehicleGpsTrackerApi = (data) =>
  FetchAPI(url.CREATE_COMPANY_VEHICLE_GPS_TRACKER_API, "POST", data);
//updateCompanyVehicleGpsTrackerApi
export const updateCompanyVehicleGpsTrackerApi = (data) =>
  FetchAPI(url.UPDATE_COMPANY_VEHICLE_GPS_TRACKER_API, "PUT", data);
//deleteCompanyVehicleGpsTrackerApi - data = [Id, ...]
export const deleteCompanyVehicleGpsTrackerApi = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_GPS_TRACKER_API, "DELETE", data);
//listGpsLiveDevicesApi - provider device picker (no args)
export const listGpsLiveDevicesApi = () =>
  FetchAPI(url.COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_API, "GET");
//refreshCompanyVehicleGpsTrackerApi - data = { id: CompanyVehicleGpsTracker_Id }
export const refreshCompanyVehicleGpsTrackerApi = (data) =>
  FetchAPI(url.REFRESH_COMPANY_VEHICLE_GPS_TRACKER_API, "POST", data);
//searchCompanyVehicleAttachmentApiCall - data = [{ companyvehicleattachment_data: { CompanyVehicle_Id } }]
export const searchCompanyVehicleAttachmentApiCall = (data) =>
  FetchAPI(url.SEARCH_COMPANY_VEHICLE_ATTACHMENT_API, "POST", data);
//deleteCompanyVehicleAttachmentApiCall - data = [Id, ...]
export const deleteCompanyVehicleAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_COMPANY_VEHICLE_ATTACHMENT_API, "DELETE", data);
//searchBankAccountAttachmentApiCall - data = [{ bankaccountattachment_data: { BankAccount_Id } }]
export const searchBankAccountAttachmentApiCall = (data) =>
  FetchAPI(url.SEARCH_BANK_ACCOUNT_ATTACHMENT_API, "POST", data);
//deleteBankAccountAttachmentApiCall - data = [Id, ...]
export const deleteBankAccountAttachmentApiCall = (data) =>
  FetchAPI(url.DELETE_BANK_ACCOUNT_ATTACHMENT_API, "DELETE", data);
//searchBankAccountStatementApiCall - data = [{ bankaccountstatement_data: { BankAccount_Id } }]
export const searchBankAccountStatementApiCall = (data) =>
  FetchAPI(url.SEARCH_BANK_ACCOUNT_STATEMENT_API, "POST", data);
//deleteBankAccountStatementApiCall - data = [Id, ...]
export const deleteBankAccountStatementApiCall = (data) =>
  FetchAPI(url.DELETE_BANK_ACCOUNT_STATEMENT_API, "DELETE", data);
//foodPreOrderEventAttachmentSearchApi - data = [{ foodpreordereventattachment_data: { FoodPreOrderEvent_Id } }]
export const foodPreOrderEventAttachmentSearchApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_ATTACHMENT_SEARCH_API, "POST", data);
//foodPreOrderEventAttachmentDeleteApi - data = [Id, ...]
export const foodPreOrderEventAttachmentDeleteApi = (data) =>
  FetchAPI(url.FOOD_PRE_ORDER_EVENT_ATTACHMENT_DELETE_API, "DELETE", data);

//******************PdfTemplate (PDF designer)
//listPdfTemplateApi
export const listPdfTemplateApi = () =>
  FetchAPI(url.LIST_PDF_TEMPLATE_API, "GET");
//getPdfTemplateDataApi - data = { id: PdfTemplate_Id }
export const getPdfTemplateDataApi = (data) =>
  FetchAPI(url.GET_PDF_TEMPLATE_DATA_API, "GET", data);
//renderPdfTemplateApi - data = { id: PdfTemplate_Id } - whole designer bundle
export const renderPdfTemplateApi = (data) =>
  FetchAPI(url.RENDER_PDF_TEMPLATE_API, "GET", data);
//savePdfTemplateApi - single object body with nested page/element/assignment lists
export const savePdfTemplateApi = (data) =>
  FetchAPI(url.SAVE_PDF_TEMPLATE_API, "POST", data);
//deletePdfTemplateApi - data = [Id, ...]
export const deletePdfTemplateApi = (data) =>
  FetchAPI(url.DELETE_PDF_TEMPLATE_API, "DELETE", data);
//duplicatePdfTemplateApi - data = { id: PdfTemplate_Id }
export const duplicatePdfTemplateApi = (data) =>
  FetchAPI(url.DUPLICATE_PDF_TEMPLATE_API, "POST", data);
//uploadSourcePdfTemplateApi - data = { PdfTemplate_Id, FileName, FileBase64 }
export const uploadSourcePdfTemplateApi = (data) =>
  FetchAPI(url.UPLOAD_SOURCE_PDF_TEMPLATE_API, "POST", data);
//uploadImagePdfTemplateApi - data = { FileName, FileBase64 } -> { StorageKey, FileUrl } (Change #100380)
export const uploadImagePdfTemplateApi = (data) =>
  FetchAPI(url.UPLOAD_IMAGE_PDF_TEMPLATE_API, "POST", data);
//previewPdfTemplateApi - data = { id: PdfTemplate_Id, context: {...} }
export const previewPdfTemplateApi = (data) =>
  FetchAPI(url.PREVIEW_PDF_TEMPLATE_API, "POST", data);
// Change #100700 - [{ PdfTemplate_Id, FileBase64, FileName, FileType, Mode: "rebuild"|"fields", PageImages }]
// -> draft pdftemplatepage_list / pdftemplateelement_list (nothing saved). signal = Cancel.
export const aiBuildPdfTemplateApi = (data, signal) =>
  FetchAPI(url.AI_BUILD_PDF_TEMPLATE_API, "POST", data, undefined, undefined, undefined, signal);
//listPdfTemplateToCommunicationApi - query = "?Communication_Id=5" (optional)
export const listPdfTemplateToCommunicationApi = (query) =>
  FetchAPI(url.LIST_PDF_TEMPLATE_TO_COMMUNICATION_API + (query || ""), "GET");
//getPdfTemplateToCommunicationDataApi - data = { id }
export const getPdfTemplateToCommunicationDataApi = (data) =>
  FetchAPI(url.GET_PDF_TEMPLATE_TO_COMMUNICATION_DATA_API, "GET", data);
//createPdfTemplateToCommunicationApi
export const createPdfTemplateToCommunicationApi = (data) =>
  FetchAPI(url.CREATE_PDF_TEMPLATE_TO_COMMUNICATION_API, "POST", data);
//updatePdfTemplateToCommunicationApi
export const updatePdfTemplateToCommunicationApi = (data) =>
  FetchAPI(url.UPDATE_PDF_TEMPLATE_TO_COMMUNICATION_API, "PUT", data);
//deletePdfTemplateToCommunicationApi - data = [Id, ...]
export const deletePdfTemplateToCommunicationApi = (data) =>
  FetchAPI(url.DELETE_PDF_TEMPLATE_TO_COMMUNICATION_API, "DELETE", data);

//******************ESign (e-signing envelopes)
//listESignApi
export const listESignApi = () => FetchAPI(url.LIST_ESIGN_API, "GET");
//getESignDataApi - data = { id: ESignEnvelope_Id } - full nested bundle
export const getESignDataApi = (data) =>
  FetchAPI(url.GET_ESIGN_DATA_API, "GET", data);
//createESignApi - single object body with nested document/recipient/field lists
export const createESignApi = (data) =>
  FetchAPI(url.CREATE_ESIGN_API, "POST", data);
//updateESignApi - draft only, single object body with Id
export const updateESignApi = (data) =>
  FetchAPI(url.UPDATE_ESIGN_API, "PUT", data);
//uploadESignDocumentApi - data = { ESignEnvelope_Id, Title, FileName, FileBase64, ... }
export const uploadESignDocumentApi = (data) =>
  FetchAPI(url.UPLOAD_ESIGN_DOCUMENT_API, "POST", data);
//sendESignApi - data = { id: ESignEnvelope_Id } - issues links + emails
export const sendESignApi = (data) =>
  FetchAPI(url.SEND_ESIGN_API, "POST", data);
//voidESignApi - data = { Id, VoidedReason }
export const voidESignApi = (data) => FetchAPI(url.VOID_ESIGN_API, "PUT", data);
//downloadESignApi - data = { id: ESignEnvelope_Id } - completed signed PDF
export const downloadESignApi = (data) =>
  FetchAPI(url.DOWNLOAD_ESIGN_API, "GET", data);
//deleteESignApi - data = [Id, ...]
export const deleteESignApi = (data) =>
  FetchAPI(url.DELETE_ESIGN_API, "DELETE", data);

//******************Form Builder (branded forms + submissions)
//listFormApi
export const listFormApi = () => FetchAPI(url.LIST_FORM_API, "GET");

// Task 24899 - the catalogue behind the builder's "Prefill from" picker.
export const listFormPrefillSourcesApi = () =>
  FetchAPI(url.PREFILL_SOURCES_FORM_API, "GET");

// Task 24907 - the booking's Communications tab.
export const reservationCommunicationsApiCall = (FoodTableReservation_Id) =>
  FetchAPI(
    `${url.RESERVATION_COMMUNICATIONS_API}/${FoodTableReservation_Id}`,
    "GET"
  );

// Change #100611 - the Resend button on a booking's payment request.
export const paymentRequestResendEmailApiCall = (PaymentRequest_Id) =>
  FetchAPI(`${url.PAYMENT_REQUEST_RESEND_EMAIL_API}/${PaymentRequest_Id}`, "POST", []);

// Change #100541 - Settings > Email > Sent Emails. adminCompanyId switches to
// the developer-only routes so Back End > Company Details shows the same screen.
export const sentEmailsSearchApiCall = (filter, adminCompanyId) =>
  FetchAPI(
    adminCompanyId
      ? `${url.SENT_EMAILS_ADMIN_SEARCH_API}/${adminCompanyId}`
      : url.SENT_EMAILS_SEARCH_API,
    "POST",
    [filter]
  );
export const sentEmailsDetailApiCall = (EmailOutbound_Id, adminCompanyId) =>
  FetchAPI(
    adminCompanyId
      ? `${url.SENT_EMAILS_ADMIN_DETAIL_API}/${adminCompanyId}/${EmailOutbound_Id}`
      : `${url.SENT_EMAILS_DETAIL_API}/${EmailOutbound_Id}`,
    "GET"
  );
// Change #100765 - send a sent email again; To is optional (omitted = the original recipients)
export const sentEmailsResendApiCall = (EmailOutbound_Id, adminCompanyId, to) =>
  FetchAPI(
    adminCompanyId
      ? `${url.SENT_EMAILS_ADMIN_RESEND_API}/${adminCompanyId}/${EmailOutbound_Id}`
      : `${url.SENT_EMAILS_RESEND_API}/${EmailOutbound_Id}`,
    "POST",
    [to && to.length ? { To: to } : {}]
  );

// Task 24903 - forms at customer level.
export const listCustomerToFormApi = (Customer_Id) =>
  FetchAPI(`${url.CUSTOMER_TO_FORM_LIST_API}/${Customer_Id}`, "GET");
export const listCustomerFormSubmissionsApi = (Customer_Id) =>
  FetchAPI(`${url.CUSTOMER_TO_FORM_SUBMISSIONS_API}/${Customer_Id}`, "GET");
export const createCustomerToFormApi = (data) =>
  FetchAPI(url.CUSTOMER_TO_FORM_CREATE_API, "POST", data);
export const updateCustomerToFormApi = (data) =>
  FetchAPI(url.CUSTOMER_TO_FORM_UPDATE_API, "PUT", data);
export const deleteCustomerToFormApi = (data) =>
  FetchAPI(url.CUSTOMER_TO_FORM_DELETE_API, "DELETE", data);

// The customer's own copy. No bearer token is needed - the assignment's
// IdExternal in the path is the credential - but FetchAPI sends one when the
// browser happens to have it, which is harmless on a soft-auth route.
export const renderFormAssignmentApi = (token) =>
  FetchAPI(`${url.ASSIGNMENT_RENDER_FORM_API}/${token}`, "GET");
export const submitFormAssignmentApi = (token, data) =>
  FetchAPI(`${url.ASSIGNMENT_SUBMIT_FORM_API}/${token}`, "POST", data);

// Task 24895 - forms assigned to a task. list takes the Task_Id in the URL, so
// it is passed as a path segment rather than a body.
export const listTaskToFormApi = (Task_Id) =>
  FetchAPI(`${url.TASK_TO_FORM_LIST_API}/${Task_Id}`, "GET");
// Change #100383 - every form on a job's tasks
export const listJobTaskToFormApi = (Job_Id) =>
  FetchAPI(`${url.TASK_TO_FORM_JOB_LIST_API}/${Job_Id}`, "GET");
export const createTaskToFormApi = (data) =>
  FetchAPI(url.TASK_TO_FORM_CREATE_API, "POST", data);
export const updateTaskToFormApi = (data) =>
  FetchAPI(url.TASK_TO_FORM_UPDATE_API, "PUT", data);
export const deleteTaskToFormApi = (data) =>
  FetchAPI(url.TASK_TO_FORM_DELETE_API, "DELETE", data);
//renderFormApi - data = { id: Form_Id } - full nested bundle for the builder
export const renderFormApi = (data) =>
  FetchAPI(url.RENDER_FORM_API, "GET", data);

// Task 24899 - the RUNNER's render. It asks for prefill tokens to be resolved
// and says which record the form is being run against. The builder keeps using
// renderFormApi above, with no context and no flag, so it always loads the raw
// tokens - resolving them there would blank the configuration on the next save.
//
// The query string is built here because FetchAPI's GET handling only ever
// appends an /{id} segment; it has no notion of query parameters.
export const renderFormForRunApi = ({ id, ...context }) => {
  const params = new URLSearchParams({ FlagResolvePrefill: "1" });
  Object.entries(context).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.set(key, String(value));
    }
  });
  return FetchAPI(`${url.RENDER_FORM_API}/${id}?${params.toString()}`, "GET");
};
//saveFormApi - single object body (Id present => update, absent => create) with nested lists
export const saveFormApi = (data) => FetchAPI(url.SAVE_FORM_API, "POST", data);
// AI FORM BUILD (Task 24609). Sent as a single object, not an array, so
// FetchAPI cannot append an id segment to the URL.
// Task 24695 - takes an optional AbortSignal so the progress modal's Stop
// button genuinely cancels the request instead of abandoning its result.
export const aiBuildFormApi = (data, signal) =>
  FetchAPI(url.AI_BUILD_FORM_API, "POST", data, undefined, undefined, undefined, signal);
// Task 24825 - the menu equivalent. aipropose reads the document and returns
// a proposal that writes nothing; aiconfirm builds what the user approved.
// Task 24834 - vehicle managers. list takes the vehicle id in the URL.
export const companyVehicleManagerListApi = (companyVehicleId) =>
  FetchAPI(`${url.COMPANY_VEHICLE_MANAGER_LIST_API}/${companyVehicleId}`, "GET");
export const companyVehicleManagerCreateApi = (data) =>
  FetchAPI(url.COMPANY_VEHICLE_MANAGER_CREATE_API, "POST", data);
export const companyVehicleManagerDeleteApi = (data) =>
  FetchAPI(url.COMPANY_VEHICLE_MANAGER_DELETE_API, "DELETE", data);

export const aiProposeFoodMenuApi = (data, signal) =>
  FetchAPI(url.AI_PROPOSE_FOODMENU_API, "POST", data, undefined, undefined, undefined, signal);
export const aiConfirmFoodMenuApi = (data, signal) =>
  FetchAPI(url.AI_CONFIRM_FOODMENU_API, "POST", data, undefined, undefined, undefined, signal);
// Task 24698 - page-by-page build. prepare counts the pages and takes the
// single wallet charge; page is then called once per page, in parallel.
export const aiBuildFormPrepareApi = (data, signal) =>
  FetchAPI(url.AI_BUILD_FORM_PREPARE_API, "POST", data, undefined, undefined, undefined, signal);
export const aiBuildFormPageApi = (data, signal) =>
  FetchAPI(url.AI_BUILD_FORM_PAGE_API, "POST", data, undefined, undefined, undefined, signal);
//publishFormApi - data = { Form_Id }
export const publishFormApi = (data) =>
  FetchAPI(url.PUBLISH_FORM_API, "PUT", data);
//unpublishFormApi - data = { Form_Id }
export const unpublishFormApi = (data) =>
  FetchAPI(url.UNPUBLISH_FORM_API, "PUT", data);
//setFormStatusApi - Task 24888 - data = { Form_Id, FormStatus_Id }
export const setFormStatusApi = (data) =>
  FetchAPI(url.SET_STATUS_FORM_API, "PUT", data);
//formStatusListApi - Task 24888
export const formStatusListApi = () =>
  FetchAPI(url.LIST_FORM_STATUS_API, "GET");
export const formStatusCreateApi = (data) =>
  FetchAPI(url.CREATE_FORM_STATUS_API, "POST", data);
export const formStatusUpdateApi = (data) =>
  FetchAPI(url.UPDATE_FORM_STATUS_API, "PUT", data);
export const formStatusDeleteApi = (id) =>
  FetchAPI(url.DELETE_FORM_STATUS_API, "DELETE", undefined, id);
//duplicateFormApi - data = { id: Form_Id } (id in the URL)
export const duplicateFormApi = (data) =>
  FetchAPI(url.DUPLICATE_FORM_API, "POST", data);
//exportFormApi - Change #100305 - data = { id: Form_Id } (id in the URL)
export const exportFormApi = (data) =>
  FetchAPI(url.EXPORT_FORM_API, "GET", data);
//importFormApi - Change #100305 - data = the export file's JSON, as-is
export const importFormApi = (data) =>
  FetchAPI(url.IMPORT_FORM_API, "POST", data);
//deleteFormApi - data = [Id, ...]
export const deleteFormApi = (data) =>
  FetchAPI(url.DELETE_FORM_API, "DELETE", data);
//listFormSubmissionsApi - data = { id: Form_Id }
export const listFormSubmissionsApi = (data) =>
  FetchAPI(url.SUBMISSIONS_FORM_API, "GET", data);
//getFormSubmissionDataApi - data = { id: FormSubmission_Id }
export const getFormSubmissionDataApi = (data) =>
  FetchAPI(url.SUBMISSION_DATA_FORM_API, "GET", data);
//submitFormInternalApi - staff fills in a form: data = { id: Form_Id, values: {...} }
// Change #100583 - optional AbortSignal, so a submit stuck on a weak signal
// can be given up and retried.
export const submitFormInternalApi = (data, signal) =>
  FetchAPI(url.SUBMIT_FORM_INTERNAL_API, "POST", data, undefined, undefined, undefined, signal);
//uploadFormInternalApi - staff uploads a File Upload field's file as it is chosen
// (Task 24847). data = { id: Form_Id, FieldKey, FileName, MimeType, FileBase64 }.
// Mirror of uploadPublicFormFileApi; id goes to the URL, the rest is the body.
export const uploadFormInternalApi = (data) =>
  FetchAPI(url.UPLOAD_FORM_INTERNAL_API, "POST", data);
//getFormEsignReadinessApi - is ESIGN_INVITATION EMAIL configured for this company?
export const getFormEsignReadinessApi = () =>
  FetchAPI(url.ESIGN_READINESS_FORM_API, "GET");

//******************** Asset
export const assetListApi = () => FetchAPI(url.ASSET_LIST_API, "GET");
export const assetDataApi = (data) => FetchAPI(url.ASSET_DATA_API, "GET", data);
export const assetCreateApi = (data) =>
  FetchAPI(url.ASSET_CREATE_API, "POST", data);
export const assetUpdateApi = (data) =>
  FetchAPI(url.ASSET_UPDATE_API, "PUT", data);
export const assetDeleteApi = (data) =>
  FetchAPI(url.ASSET_DELETE_API, "DELETE", data);
export const assetBulkAssignApi = (data) =>
  FetchAPI(url.ASSET_BULK_ASSIGN_API, "PUT", data);

//******************** Company site locations (Task 24472)
// Read-only lookup plus small CRUD - called directly rather than through a
// store slice, same as the asset assignment panel does.
export const companySiteLocationListApi = () =>
  FetchAPI(url.COMPANY_SITE_LOCATION_LIST_API, "GET");
export const companySiteLocationDataApi = (data) =>
  FetchAPI(url.COMPANY_SITE_LOCATION_DATA_API, "GET", data);
export const companySiteLocationCreateApi = (data) =>
  FetchAPI(url.COMPANY_SITE_LOCATION_CREATE_API, "POST", data);
export const companySiteLocationUpdateApi = (data) =>
  FetchAPI(url.COMPANY_SITE_LOCATION_UPDATE_API, "PUT", data);
export const companySiteLocationDeleteApi = (data) =>
  FetchAPI(url.COMPANY_SITE_LOCATION_DELETE_API, "DELETE", data);

//******************** SLAs (Tasks 24474 / 24469)
export const slaProfileListApi = () => FetchAPI(url.SLA_PROFILE_LIST_API, "GET");
export const slaProfileDataApi = (data) => FetchAPI(url.SLA_PROFILE_DATA_API, "GET", data);
export const slaProfileCreateApi = (data) => FetchAPI(url.SLA_PROFILE_CREATE_API, "POST", data);
export const slaProfileUpdateApi = (data) => FetchAPI(url.SLA_PROFILE_UPDATE_API, "PUT", data);
export const slaProfileDeleteApi = (data) => FetchAPI(url.SLA_PROFILE_DELETE_API, "DELETE", data);
export const slaMetricCreateApi = (data) => FetchAPI(url.SLA_METRIC_CREATE_API, "POST", data);
export const slaMetricUpdateApi = (data) => FetchAPI(url.SLA_METRIC_UPDATE_API, "PUT", data);
export const slaMetricDeleteApi = (data) => FetchAPI(url.SLA_METRIC_DELETE_API, "DELETE", data);
export const customerSlaListApi = (data) => FetchAPI(url.CUSTOMER_SLA_LIST_API, "GET", data);
export const customerSlaActiveApi = (data) => FetchAPI(url.CUSTOMER_SLA_ACTIVE_API, "GET", data);
export const customerSlaAssignApi = (data) => FetchAPI(url.CUSTOMER_SLA_ASSIGN_API, "POST", data);
export const customerSlaDeleteApi = (data) => FetchAPI(url.CUSTOMER_SLA_DELETE_API, "DELETE", data);

//******************** Staff contact points (Task 24467)
export const staffContactTypeListApi = () =>
  FetchAPI(url.STAFF_CONTACT_TYPE_LIST_API, "GET");
export const staffContactTypeCreateApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_TYPE_CREATE_API, "POST", data);
export const staffContactTypeUpdateApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_TYPE_UPDATE_API, "PUT", data);
export const staffContactTypeDeleteApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_TYPE_DELETE_API, "DELETE", data);
export const staffContactListApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_LIST_API, "GET", data);
export const staffContactCreateApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_CREATE_API, "POST", data);
export const staffContactUpdateApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_UPDATE_API, "PUT", data);
export const staffContactDeleteApi = (data) =>
  FetchAPI(url.STAFF_CONTACT_DELETE_API, "DELETE", data);

//******************** Staff addresses over time (Task 24860)
export const staffAddressTypeListApi = () =>
  FetchAPI(url.STAFF_ADDRESS_TYPE_LIST_API, "GET");
export const staffAddressTypeCreateApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_TYPE_CREATE_API, "POST", data);
export const staffAddressTypeUpdateApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_TYPE_UPDATE_API, "PUT", data);
export const staffAddressTypeDeleteApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_TYPE_DELETE_API, "DELETE", data);
export const staffAddressListApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_LIST_API, "GET", data);
export const staffAddressSearchApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_SEARCH_API, "POST", data);
export const staffAddressCreateApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_CREATE_API, "POST", data);
export const staffAddressUpdateApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_UPDATE_API, "PUT", data);
export const staffAddressDeleteApi = (data) =>
  FetchAPI(url.STAFF_ADDRESS_DELETE_API, "DELETE", data);

//******************** Asset notes / attachments / activity
export const assetNoteListApi = (data) =>
  FetchAPI(url.ASSET_NOTE_LIST_API, "GET", data);
export const assetNoteCreateApi = (data) =>
  FetchAPI(url.ASSET_NOTE_CREATE_API, "POST", data);
export const assetNoteUpdateApi = (data) =>
  FetchAPI(url.ASSET_NOTE_UPDATE_API, "PUT", data);
export const assetNoteDeleteApi = (data) =>
  FetchAPI(url.ASSET_NOTE_DELETE_API, "DELETE", data);
export const assetAttachmentSearchApi = (data) =>
  FetchAPI(url.ASSET_ATTACHMENT_SEARCH_API, "POST", data);
export const assetAttachmentDeleteApi = (data) =>
  FetchAPI(url.ASSET_ATTACHMENT_DELETE_API, "DELETE", data);
export const assetRecentActivityListApi = (data) =>
  FetchAPI(url.ASSET_RECENT_ACTIVITY_LIST_API, "GET", data);
export const assetDiarySlotListApi = (data) =>
  FetchAPI(url.ASSET_DIARY_SLOT_LIST_API, "GET", data);

//******************** Asset To Staff (assignment / custody log)
// listAssetToStaffApi - data = { id: Asset_Id } -> GET /assettostaff/list/{Asset_Id}
export const listAssetToStaffApi = (data) =>
  FetchAPI(url.LIST_ASSET_TO_STAFF_API, "GET", data);
export const createAssetToStaffApi = (data) =>
  FetchAPI(url.CREATE_ASSET_TO_STAFF_API, "POST", data);
export const updateAssetToStaffApi = (data) =>
  FetchAPI(url.UPDATE_ASSET_TO_STAFF_API, "PUT", data);
export const deleteAssetToStaffApi = (data) =>
  FetchAPI(url.DELETE_ASSET_TO_STAFF_API, "DELETE", data);
// searchAssetToStaffApi - data = [{ assettostaff_data: { Asset_Id, Staff_Id, FlagOpen, ... } }]
export const searchAssetToStaffApi = (data) =>
  FetchAPI(url.SEARCH_ASSET_TO_STAFF_API, "POST", data);
// checkoutAssetApi - data = { Asset_Id, Staff_Id, FlagPermanent, Notes }
export const checkoutAssetApi = (data) =>
  FetchAPI(url.CHECKOUT_ASSET_API, "POST", data);
// checkinAssetApi - data = { Asset_Id, Notes }
export const checkinAssetApi = (data) =>
  FetchAPI(url.CHECKIN_ASSET_API, "PUT", data);

//******************** Asset Movement (Change #100392 - custody chain)
// assetMovementListApi - data = { id: Asset_Id } -> GET /assetmovement/list/{Asset_Id}
export const assetMovementListApi = (data) =>
  FetchAPI(url.ASSET_MOVEMENT_LIST_API, "GET", data);
// assetMovementListByJobApi - data = { id: Job_Id } -> GET /assetmovement/list/job/{Job_Id}
export const assetMovementListByJobApi = (data) =>
  FetchAPI(url.ASSET_MOVEMENT_LIST_JOB_API, "GET", data);
// assetMovementMoveApi - data = [{ Asset_Id, HolderType: STAFF|JOB|STORAGE, Staff_Id | Job_Id |
//   CompanyStorageLocation_Id, Notes, EndNotes, FlagPermanent, ConfirmLeaveJob }]
export const assetMovementMoveApi = (data) =>
  FetchAPI(url.ASSET_MOVEMENT_MOVE_API, "POST", data);
// Change #100645 - assetMovementMineApi -> GET /assetmovement/mine (assets with the caller now)
export const assetMovementMineApi = () => FetchAPI(url.ASSET_MOVEMENT_MINE_API, "GET");
// Change #100670 - companyVehicleMineApi -> GET /companyvehicle/mine (vehicles assigned
// to the caller; FlagManager = 1 when they can also manage vehicles)
export const companyVehicleMineApi = () => FetchAPI(url.COMPANY_VEHICLE_MINE_API, "GET");
// Change #100644 - assetMovementRelocateApi - data = { Id (the open job leg), SiteLocation, Notes }
//   -> PUT /assetmovement/relocate (a different place on the same job)
export const assetMovementRelocateApi = (data) =>
  FetchAPI(url.ASSET_MOVEMENT_RELOCATE_API, "PUT", data);

//******************** Asset Group (pool of fungible assets)
export const assetGroupListApi = () => FetchAPI(url.ASSET_GROUP_LIST_API, "GET");
export const assetGroupDataApi = (data) =>
  FetchAPI(url.ASSET_GROUP_DATA_API, "GET", data);
export const assetGroupCreateApi = (data) =>
  FetchAPI(url.ASSET_GROUP_CREATE_API, "POST", data);
export const assetGroupUpdateApi = (data) =>
  FetchAPI(url.ASSET_GROUP_UPDATE_API, "PUT", data);
export const assetGroupDeleteApi = (data) =>
  FetchAPI(url.ASSET_GROUP_DELETE_API, "DELETE", data);

//******************** Dispatch Board (configurable field-service dispatch diary)
export const dispatchBoardListApi = () => FetchAPI(url.DISPATCH_BOARD_LIST_API, "GET");
export const dispatchBoardDataApi = (data) =>
  FetchAPI(url.DISPATCH_BOARD_DATA_API, "GET", data);
export const dispatchBoardCreateApi = (data) =>
  FetchAPI(url.DISPATCH_BOARD_CREATE_API, "POST", data);
export const dispatchBoardUpdateApi = (data) =>
  FetchAPI(url.DISPATCH_BOARD_UPDATE_API, "PUT", data);
export const dispatchBoardDeleteApi = (data) =>
  FetchAPI(url.DISPATCH_BOARD_DELETE_API, "DELETE", data);

//******************** Asset Type
export const assetTypeListApi = () => FetchAPI(url.ASSET_TYPE_LIST_API, "GET");
export const assetTypeDataApi = (data) =>
  FetchAPI(url.ASSET_TYPE_DATA_API, "GET", data);
export const assetTypeCreateApi = (data) =>
  FetchAPI(url.ASSET_TYPE_CREATE_API, "POST", data);
export const assetTypeUpdateApi = (data) =>
  FetchAPI(url.ASSET_TYPE_UPDATE_API, "PUT", data);
export const assetTypeDeleteApi = (data) =>
  FetchAPI(url.ASSET_TYPE_DELETE_API, "DELETE", data);

//******************** Asset Status
export const assetStatusListApi = () => FetchAPI(url.ASSET_STATUS_LIST_API, "GET");
export const assetStatusDataApi = (data) =>
  FetchAPI(url.ASSET_STATUS_DATA_API, "GET", data);
export const assetStatusCreateApi = (data) =>
  FetchAPI(url.ASSET_STATUS_CREATE_API, "POST", data);
export const assetStatusUpdateApi = (data) =>
  FetchAPI(url.ASSET_STATUS_UPDATE_API, "PUT", data);
export const assetStatusDeleteApi = (data) =>
  FetchAPI(url.ASSET_STATUS_DELETE_API, "DELETE", data);

//******************** Company Storage Location
export const companyStorageLocationListApi = () =>
  FetchAPI(url.COMPANY_STORAGE_LOCATION_LIST_API, "GET");
export const companyStorageLocationDataApi = (data) =>
  FetchAPI(url.COMPANY_STORAGE_LOCATION_DATA_API, "GET", data);
export const companyStorageLocationCreateApi = (data) =>
  FetchAPI(url.COMPANY_STORAGE_LOCATION_CREATE_API, "POST", data);
export const companyStorageLocationUpdateApi = (data) =>
  FetchAPI(url.COMPANY_STORAGE_LOCATION_UPDATE_API, "PUT", data);
export const companyStorageLocationDeleteApi = (data) =>
  FetchAPI(url.COMPANY_STORAGE_LOCATION_DELETE_API, "DELETE", data);

//**************************** Checklist
//checkListTemplateListActiveApi
export const checkListTemplateListActiveApi = () =>
  FetchAPI(url.CHECK_LIST_TEMPLATE_LIST_ACTIVE_API, "GET");
//checkListTemplateAssignToTaskApi
export const checkListTemplateAssignToTaskApi = (data) =>
  FetchAPI(url.CHECK_LIST_TEMPLATE_ASSIGN_TO_TASK_API, "POST", data);
//checkListSearchApi
export const checkListSearchApi = (data) =>
  FetchAPI(url.CHECK_LIST_SEARCH_API, "POST", data);
//checkListDataApi
export const checkListDataApi = (data) =>
  FetchAPI(url.CHECK_LIST_DATA_API, "GET", data);
//checkListUpdateApi
export const checkListUpdateApi = (data) =>
  FetchAPI(url.CHECK_LIST_UPDATE_API, "PUT", data);
//checkListPdfSheetApi
export const checkListPdfSheetApi = (data) =>
  FetchAPI(url.CHECK_LIST_PDF_SHEET_API, "GET", data);
//deleteTaskCheckListApi
export const deleteTaskCheckListApi = (data) =>
  FetchAPI(url.DELETE_TASK_CHECK_LIST_API, "DELETE", data);
//checkListMergeWithTemplateApi
export const checkListMergeWithTemplateApi = (data) =>
  FetchAPI(url.CHECK_LIST_MERGE_WITH_TEMPLATE_API, "GET", data);
//taskCheckListSearchApi
export const taskCheckListSearchApi = (data) =>
  FetchAPI(url.TASK_CHECK_LIST_SEARCH_API, "POST", data);
//taskCheckListListApi
export const taskCheckListListApi = () =>
  FetchAPI(url.TASK_CHECK_LIST_LIST_API, "GET");
//checkListPdfSheetDebugApi
export const checkListPdfSheetDebugApi = (data) =>
  FetchAPI(url.CHECK_LIST_PDF_SHEET_DEBUG_API, "GET", data);
//createCheckListTemplateApi
export const createCheckListTemplateApi = (data) =>
  FetchAPI(url.CREATE_CHECK_LIST_TEMPLATE_API, "POST", data);
//updateCheckListTemplateApi
export const updateCheckListTemplateApi = (data) =>
  FetchAPI(url.UPDATE_CHECK_LIST_TEMPLATE_API, "PUT", data);
//cloneCheckListTemplateApi
export const cloneCheckListTemplateApi = (data) =>
  FetchAPI(url.CLONE_CHECK_LIST_TEMPLATE_API, "POST", data);
//checkListTemplateDataTypeListApi
export const checkListTemplateDataTypeListApi = () =>
  FetchAPI(url.CHECK_LIST_TEMPLATE_DATATYPE_LIST_API, "GET");
//checkListTemplateSystemFieldListApi
export const checkListTemplateSystemFieldListApi = () =>
  FetchAPI(url.CHECK_LIST_TEMPLATE_SYSTEMFIELD_LIST_API, "GET");
//checkListTemplatePdfThemeListApi
export const checkListTemplatePdfThemeListApi = () =>
  FetchAPI(url.CHECK_LIST_TEMPLATE_PDFTHEME_LIST_API, "GET");
//*************************** Partners
//getPartnersListAPI
export const getPartnersListAPI = () =>
  FetchAPI(url.GET_PARTNERS_LIST_API, "GET");
// ThirdPartyIntegration
//thirdPartyXeroUrlAuthApi
export const thirdPartyXeroUrlAuthApi = () =>
  FetchAPI(url.THIRD_PARTY_XERO_URL_AUTH_API, "GET");
//thirdPartyXeroCheckStatusApi
export const thirdPartyXeroCheckStatusApi = () =>
  FetchAPI(url.THIRD_PARTY_XERO_CHECK_STATUS_API, "GET");
//thirdPartyXeroGenerateAccessTokenApi
export const thirdPartyXeroGenerateAccessTokenApi = (data) =>
  FetchAPI(url.THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_API, "POST", data);
//thirdPartyXeroAssignTenantApi
export const thirdPartyXeroAssignTenantApi = (data) =>
  FetchAPI(url.THIRD_PARTY_XERO_ASSIGN_TENANT_API, "POST", data);
//thirdPartyXeroSyncManualApi
export const thirdPartyXeroSyncManualApi = () =>
  FetchAPI(url.THIRD_PARTY_XERO_SYNC_MANUAL_API, "GET");
//thirdPartyXeroUnassignTenantApi
export const thirdPartyXeroUnassignTenantApi = () =>
  FetchAPI(url.THIRD_PARTY_XERO_UNASSIGN_TENANT_API, "GET");
//thirdPartyBrightPay* (per-company payroll employee sync)
export const thirdPartyBrightPaySaveCredentialsApi = (data) =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_API, "POST", data);
export const thirdPartyBrightPayUrlAuthApi = () =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_URL_AUTH_API, "GET");
export const thirdPartyBrightPayCheckStatusApi = () =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_API, "GET");
export const thirdPartyBrightPayGenerateAccessTokenApi = (data) =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_API, "POST", data);
export const thirdPartyBrightPayAssignEmployerApi = (data) =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_API, "POST", data);
export const thirdPartyBrightPayUnassignApi = () =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_UNASSIGN_API, "GET");
export const thirdPartyBrightPaySyncEmployeesApi = () =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_API, "GET");
export const thirdPartyBrightPayEmployeeListApi = () =>
  FetchAPI(url.THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_API, "GET");
//thirdPartyGpsLive* (per-company vehicle GPS tracking API key)
export const thirdPartyGpsLiveSaveCredentialsApi = (data) =>
  FetchAPI(url.THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_API, "POST", data);
export const thirdPartyGpsLiveCheckStatusApi = () =>
  FetchAPI(url.THIRD_PARTY_GPSLIVE_CHECK_STATUS_API, "GET");
export const thirdPartyGpsLiveTestConnectionApi = () =>
  FetchAPI(url.THIRD_PARTY_GPSLIVE_TEST_CONNECTION_API, "GET");
export const thirdPartyGpsLiveUnassignApi = () =>
  FetchAPI(url.THIRD_PARTY_GPSLIVE_UNASSIGN_API, "GET");
//thirdPartyVapi* (per-company Virtual Receptionist — MULTIPLE per company).
//create/update/delete/provision/linktwilio/toggle bodies are ARRAYS, so FetchAPI
//never appends /{id} even though the array's object carries a top-level Id.
export const thirdPartyVapiListApi = () =>
  FetchAPI(url.THIRD_PARTY_VAPI_LIST_API, "GET");
export const thirdPartyVapiDataApi = (id) =>
  FetchAPI(`${url.THIRD_PARTY_VAPI_DATA_API}/${id}`, "GET");
export const thirdPartyVapiCreateApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_CREATE_API, "POST", data);
export const thirdPartyVapiUpdateApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_UPDATE_API, "POST", data);
export const thirdPartyVapiDeleteApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_DELETE_API, "POST", data);
export const thirdPartyVapiProvisionApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_PROVISION_API, "POST", data);
export const thirdPartyVapiLinkTwilioApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_LINK_TWILIO_API, "POST", data);
export const thirdPartyVapiToggleApi = (data) =>
  FetchAPI(url.THIRD_PARTY_VAPI_TOGGLE_API, "POST", data);
//telephony* (Twilio number ordering — cross-sells the Virtual Receptionist).
//available/purchase bodies are plain objects with NO top-level `id`, so FetchAPI
//won't append /{id} to the URL.
export const callProviderListApi = () =>
  FetchAPI(url.CALL_PROVIDER_LIST_API, "GET");
export const telephoneNumberAvailableApi = (data) =>
  FetchAPI(url.TELEPHONE_NUMBER_AVAILABLE_API, "POST", data);
export const telephoneNumberPurchaseApi = (data) =>
  FetchAPI(url.TELEPHONE_NUMBER_PURCHASE_API, "POST", data);
export const telephoneNumberListApi = () =>
  FetchAPI(url.TELEPHONE_NUMBER_LIST_API, "GET");
// Change #100774
export const telephoneNumberSmsSenderApi = (data) =>
  FetchAPI(url.TELEPHONE_NUMBER_SMS_SENDER_API, "POST", data);
export const smsRepliesApi = () => FetchAPI(url.SMS_REPLIES_API, "GET");
export const smsConversationsApi = () => FetchAPI(url.SMS_CONVERSATIONS_API, "GET");
export const smsConversationApi = (number) =>
  FetchAPI(`${url.SMS_CONVERSATION_API}?number=${encodeURIComponent(number)}`, "GET");
export const smsReplyApi = (data) => FetchAPI(url.SMS_REPLY_API, "POST", data);
export const twilioRegulatoryBundleDataApi = (country = "GB", type = "mobile") =>
  FetchAPI(`${url.TWILIO_REGULATORY_BUNDLE_DATA_API}?country=${country}&type=${type}`, "GET");
export const twilioRegulatoryBundleSubmitApi = (data) =>
  FetchAPI(url.TWILIO_REGULATORY_BUNDLE_SUBMIT_API, "POST", data);
//thirdPartyGoogleUrlAuthApi
export const thirdPartyGoogleUrlAuthApi = () =>
  FetchAPI(url.THIRD_PARTY_GOOGLE_URL_AUTH_API, "GET");
//thirdPartyGoogleGenerateAccessTokenApi
export const thirdPartyGoogleGenerateAccessTokenApi = (data) =>
  FetchAPI(url.THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_API, "POST", data);
//thirdPartyHmrcUrlAuthApi
export const thirdPartyHmrcUrlAuthApi = () =>
  FetchAPI(url.THIRD_PARTY_HMRC_INTEGRATION_ACCESS, "GET");
//thirdPartyHmrcEnvironmentDataApi
export const thirdPartyHmrcEnvironmentDataApi = () =>
  FetchAPI(url.THIRD_PARTY_HMRC_ENVIRONMENT_DATA_API, "GET");
//thirdPartyHmrcEnvironmentSetApi
export const thirdPartyHmrcEnvironmentSetApi = (data) =>
  FetchAPI(url.THIRD_PARTY_HMRC_ENVIRONMENT_SET_API, "POST", data);
//thirdPartyHmrcConnectUrlApi - Task 24258: returnUrl is where the API callback sends the browser after HMRC
export const thirdPartyHmrcConnectUrlApi = (returnUrl) =>
  FetchAPI(
    `${url.THIRD_PARTY_HMRC_INTEGRATION_ACCESS}?ReturnUrl=${encodeURIComponent(returnUrl)}`,
    "GET"
  );
//thirdPartyHmrcStatusApi
export const thirdPartyHmrcStatusApi = () =>
  FetchAPI(url.THIRD_PARTY_HMRC_STATUS_API, "GET");
//thirdPartyHmrcTestApi
export const thirdPartyHmrcTestApi = () =>
  FetchAPI(url.THIRD_PARTY_HMRC_TEST_API, "POST", [{}]);
//thirdPartyHmrcDisconnectApi
export const thirdPartyHmrcDisconnectApi = () =>
  FetchAPI(url.THIRD_PARTY_HMRC_DISCONNECT_API, "POST", [{}]);
//*************************** Companies House accounts filing (Change #100691)
export const companiesHouseFilingSettingsDataApi = () =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SETTINGS_DATA_API, "GET");
export const companiesHouseFilingSettingsSaveApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SETTINGS_SAVE_API, "POST", data);
export const companiesHouseFilingSettingsCheckApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SETTINGS_CHECK_API, "POST", data);
export const companiesHouseFilingPreviewApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_PREVIEW_API, "POST", data);
export const companiesHouseFilingSubmitApi = (data) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SUBMIT_API, "POST", data);
export const companiesHouseFilingSubmissionListApi = () =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SUBMISSION_LIST_API, "GET");
export const companiesHouseFilingSubmissionDataApi = (id) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SUBMISSION_DATA_API, "GET", { id });
export const companiesHouseFilingSubmissionCheckStatusApi = (id) =>
  FetchAPI(url.COMPANIES_HOUSE_FILING_SUBMISSION_CHECKSTATUS_API, "POST", [{}], null, null, id);
//*************************** HMRC filing - MTD VAT + CT600 (Change #100747)
export const hmrcFilingSettingsDataApi = () => FetchAPI(url.HMRC_FILING_SETTINGS_DATA_API, "GET");
export const hmrcFilingSettingsSaveApi = (data) => FetchAPI(url.HMRC_FILING_SETTINGS_SAVE_API, "POST", data);
export const hmrcFilingVatObligationsApi = (data) => FetchAPI(url.HMRC_FILING_VAT_OBLIGATIONS_API, "POST", data);
export const hmrcFilingVatCalculateApi = (data) => FetchAPI(url.HMRC_FILING_VAT_CALCULATE_API, "POST", data);
export const hmrcFilingVatPreviewApi = (data) => FetchAPI(url.HMRC_FILING_VAT_PREVIEW_API, "POST", data);
export const hmrcFilingVatSubmitApi = (data) => FetchAPI(url.HMRC_FILING_VAT_SUBMIT_API, "POST", data);
export const hmrcFilingVatReturnApi = (data) => FetchAPI(url.HMRC_FILING_VAT_RETURN_API, "POST", data);
export const hmrcFilingVatLiabilitiesApi = (data) => FetchAPI(url.HMRC_FILING_VAT_LIABILITIES_API, "POST", data);
export const hmrcFilingVatPaymentsApi = (data) => FetchAPI(url.HMRC_FILING_VAT_PAYMENTS_API, "POST", data);
export const hmrcFilingCtCalculateApi = (data) => FetchAPI(url.HMRC_FILING_CT_CALCULATE_API, "POST", data);
export const hmrcFilingCtPreviewApi = (data) => FetchAPI(url.HMRC_FILING_CT_PREVIEW_API, "POST", data);
export const hmrcFilingCtSubmitApi = (data) => FetchAPI(url.HMRC_FILING_CT_SUBMIT_API, "POST", data);
export const hmrcFilingSubmissionListApi = (type) => FetchAPI(`${url.HMRC_FILING_SUBMISSION_LIST_API}?Type=${type}`, "GET");
export const hmrcFilingSubmissionDataApi = (id) => FetchAPI(url.HMRC_FILING_SUBMISSION_DATA_API, "GET", { id });
export const hmrcFilingSubmissionCheckStatusApi = (id) => FetchAPI(url.HMRC_FILING_SUBMISSION_CHECKSTATUS_API, "POST", [{}], null, null, id);
//*************************** Proforma Invoice
//getProformaInvoiceListApi
export const getProformaInvoiceListAPI = () =>
  FetchAPI(url.GET_PROFORMA_INVOICE_LIST_API, "GET");
//getProformaInvoiceDataAPI
export const getProformaInvoiceDataAPI = (data) =>
  FetchAPI(url.GET_PROFORMA_INVOICE_DATA_API, "GET", data);
//createProformaInvoiceAPI
export const createProformaInvoiceAPI = (data) =>
  FetchAPI(url.CREATE_PROFORMA_INVOICE_API, "POST", data);
//updateProformaInvoiceAPI
export const updateProformaInvoiceAPI = (data) =>
  FetchAPI(url.UPDATE_PROFORMA_INVOICE_API, "PUT", data);
//voidProformaInvoiceAPI
export const voidProformaInvoiceAPI = (data) =>
  FetchAPI(url.VOID_PROFORMA_INVOICE_API, "POST", data);
//getProformaInvoiceItemListAPI
export const getProformaInvoiceItemListAPI = () =>
  FetchAPI(url.GET_PROFORMA_INVOICE_ITEM_LIST_API, "GET");

//searchProformaInvoiceItemAPI
export const searchProformaInvoiceItemAPI = (data) =>
  FetchAPI(url.SEARCH_PROFORMA_INVOICE_ITEM_API, "POST", data);
//getProformaInvoiceStatusListAPI
export const getProformaInvoiceStatusListAPI = () =>
  FetchAPI(url.GET_PROFORMA_INVOICE_STATUS_LIST_API, "GET");
//getProformaInvoiceStatusDataAPI
export const getProformaInvoiceStatusDataAPI = (data) =>
  FetchAPI(url.GET_PROFORMA_INVOICE_STATUS_DATA_API, "GET", data);
//createProformaInvoiceStatusAPI
export const createProformaInvoiceStatusAPI = (data) =>
  FetchAPI(url.CREATE_PROFORMA_INVOICE_STATUS, "POST", data);
//updateProformaInvoiceStatusAPI
export const updateProformaInvoiceStatusAPI = (data) =>
  FetchAPI(url.UPDATE_PROFORMA_INVOICE_STATUS, "PUT", data);
//deleteProformaInvoiceStatusAPI
export const deleteProformaInvoiceStatusAPI = (data) =>
  FetchAPI(url.DELETE_PROFORMA_INVOICE_STATUS, "DELETE", data);
//getProformaInvoicePDFAPI
export const getProformaInvoicePDFAPI = (data) =>
  FetchAPI(url.GET_PROFORMA_INVOICE_PDF_API, "POST", data);
//sendAutomatedProformaInvoiceEmailAPI
export const sendAutomatedProformaInvoiceEmailAPI = (data) =>
  FetchAPI(url.SEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API, "GET", data);
//resendAutomatedProformaInvoiceEmailAPI
export const resendAutomatedProformaInvoiceEmailAPI = (data) =>
  FetchAPI(url.RESEND_AUTOMATED_PROFORMA_INVOICE_EMAIL_API, "GET", data);
//convertProformaInvoiceToInvoiceAPI
export const convertProformaInvoiceToInvoiceAPI = (data) =>
  FetchAPI(url.CONVERT_PROFORMA_INVOICE_TO_INVOICE_API, "GET", data);
//searchProformaInvoiceAPI
export const searchProformaInvoiceAPI = (data) =>
  FetchAPI(url.SEARCH_PROFORMA_INVOICE_API, "POST", data);
//getProformaInvoiceActivityLogAPI
export const getProformaInvoiceActivityLogAPI = (data) =>
  FetchAPI(url.GET_PROFORMA_INVOICE_ACTIVITY_LOG_API, "POST", data);
//companyRecentActivityListApi
export const companyRecentActivityListApi = () =>
  FetchAPI(url.COMPANY_RECENT_ACTIVITY_LIST_API, "GET");

//File Uploads
//moduleFileCsvUploadApi
export const moduleFileCsvUploadApi = (data) =>
  FetchAPI(url.MODULE_FILE_CSV_UPLOAD_API, "POST", data);
//moduleAvailableModuleFieldsApi
export const moduleAvailableModuleFieldsApi = () =>
  FetchAPI(url.MODULE_AVAILABLE_MODULE_FIELDS_API, "GET");
//fileAttachmentCreatePreauthApi
export const fileAttachmentCreatePreauthApi = (data) =>
  FetchAPI(url.FILE_ATTACHMENT_CREATE_PREAUTH_API, "POST", data);
// Reports
//getReportContractItemsByCustomer
export const getReportContractItemsByCustomer = (data) =>
  FetchAPI(url.GET_REPORT_CONTRACT_ITEMS_BY_CUSTOMER, "POST", data);

//Staff leave
//getStaffHolidayCalendarListApi
export const getStaffHolidayCalendarListApi = () =>
  FetchAPI(url.GET_STAFF_HOLIDAY_CALENDAR_LIST_API, "GET");
//getStaffHolidayCalendarDataApi
export const getStaffHolidayCalendarDataApi = (data) =>
  FetchAPI(url.GET_STAFF_HOLIDAY_CALENDAR_DATA_API, "GET", data);
//createStaffHolidayCalendarApi
export const createStaffHolidayCalendarApi = (data) =>
  FetchAPI(url.CREATE_STAFF_HOLIDAY_CALENDAR_API, "POST", data);
//updateStaffHolidayCalendarApi
export const updateStaffHolidayCalendarApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_HOLIDAY_CALENDAR_API, "PUT", data);
//deleteStaffHolidayCalendarApi
export const deleteStaffHolidayCalendarApi = (data) =>
  FetchAPI(url.DELETE_STAFF_HOLIDAY_CALENDAR_API, "DELETE", data);
//generateStaffHolidayCalendarPeriodsApi
export const generateStaffHolidayCalendarPeriodsApi = () =>
  FetchAPI(url.GENERATE_STAFF_HOLIDAY_CALENDAR_PERIODS_API, "POST");
//getStaffHolidayCalendarPeriodListApi
export const getStaffHolidayCalendarPeriodListApi = () =>
  FetchAPI(url.GET_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API, "GET");
//getStaffHolidayCalendarPeriodDataApi
export const getStaffHolidayCalendarPeriodDataApi = (data) =>
  FetchAPI(url.GET_STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_API, "GET", data);
//createStaffHolidayCalendarPeriodApi
export const createStaffHolidayCalendarPeriodApi = (data) =>
  FetchAPI(url.CREATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API, "POST", data);
//updateStaffHolidayCalendarPeriodApi
export const updateStaffHolidayCalendarPeriodApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_HOLIDAY_CALENDAR_PERIOD_API, "PUT", data);
//deleteStaffHolidayCalendarPeriodApi
export const deleteStaffHolidayCalendarPeriodApi = (data) =>
  FetchAPI(url.DELETE_STAFF_HOLIDAY_CALENDAR_PERIOD_API, "DELETE", data);
//getCalendarNonWorkingDayListApi
export const getCalendarNonWorkingDayListApi = () =>
  FetchAPI(url.GET_CALENDAR_NON_WORKING_DAY_LIST_API, "GET");
//getCalendarNonWorkingDayDataApi
export const getCalendarNonWorkingDayDataApi = (data) =>
  FetchAPI(url.GET_CALENDAR_NON_WORKING_DAY_DATA_API, "GET", data);
//createCalendarNonWorkingDayApi
export const createCalendarNonWorkingDayApi = (data) =>
  FetchAPI(url.CREATE_CALENDAR_NON_WORKING_DAY_API, "POST", data);
//updateCalendarNonWorkingDayApi
export const updateCalendarNonWorkingDayApi = (data) =>
  FetchAPI(url.UPDATE_CALENDAR_NON_WORKING_DAY_API, "PUT", data);
//deleteCalendarNonWorkingDayApi
export const deleteCalendarNonWorkingDayApi = (data) =>
  FetchAPI(url.DELETE_CALENDAR_NON_WORKING_DAY_API, "DELETE", data);
//createStaffLeaveRequestApi
export const createStaffLeaveRequestApi = (data) =>
  FetchAPI(url.CREATE_STAFF_LEAVE_REQUEST_API, "POST", data);
//getstaffToStaffHolidayCalendarPeriodListCurrentApi
export const getstaffToStaffHolidayCalendarPeriodListCurrentApi = () =>
  FetchAPI(
    url.GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API,
    "GET"
  );
//getstaffToStaffHolidayCalendarPeriodListFutureApi
export const getstaffToStaffHolidayCalendarPeriodListFutureApi = () =>
  FetchAPI(
    url.GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API,
    "GET"
  );
//getstaffToStaffHolidayCalendarPeriodListPastApi
export const getstaffToStaffHolidayCalendarPeriodListPastApi = () =>
  FetchAPI(url.GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API, "GET");
//getstaffToStaffHolidayCalendarPeriodListApi
export const getstaffToStaffHolidayCalendarPeriodListApi = () =>
  FetchAPI(url.GET_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API, "GET");
//staffLeaveDecisionApproveApi
export const staffLeaveDecisionApproveApi = (data, token) =>
  FetchAPI(url.STAFF_LEAVE_DECISION_APPROVE_API, "POST", data, token);
//staffLeaveDecisionDeclineApi
export const staffLeaveDecisionDeclineApi = (data, token) =>
  FetchAPI(url.STAFF_LEAVE_DECISION_DECLINE_API, "POST", data, token);
//staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersApi
export const staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersApi =
  () =>
    FetchAPI(
      url.STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_API,
      "GET"
    );
//staffToStaffHolidayCalendarPeriodListCurrentMyApi
export const staffToStaffHolidayCalendarPeriodListCurrentMyApi = () =>
  FetchAPI(
    url.STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_API,
    "GET"
  );

//staffLeaveDecisionDataApi
export const staffLeaveDecisionDataApi = (data, token) =>
  FetchAPI(url.STAFF_LEAVE_DECISION_DATA_API, "GET", data, token);
// Task 24675 - the staff this user manages (departments where they are
// FlagManager). Used to decide whether they may act on somebody else's leave.
export const searchMyTeamMembersApi = (data) =>
  FetchAPI(url.SEARCH_MY_TEAM_MEMBERS_API, "POST", data);

// Task 24672 - the whole decision in one call (request, requester, allowance,
// clashes). Token-authenticated: this is the emailed approval page, which has
// no logged-in user behind it.
export const staffLeaveDecisionContextApi = (data, token) =>
  FetchAPI(url.STAFF_LEAVE_DECISION_CONTEXT_API, "GET", data, token);
//staffLeaveDecisionListMyOpenApi
export const staffLeaveDecisionListMyOpenApi = () =>
  FetchAPI(url.STAFF_LEAVE_DECISION_LIST_MY_OPEN_API, "GET");
//staffLeaveDecisionListApi
export const staffLeaveDecisionListApi = () =>
  FetchAPI(url.STAFF_LEAVE_DECISION_LIST_API, "GET");
//overviewStaffToStaffHolidayCalendarPeriodListCurrentApi
export const overviewStaffToStaffHolidayCalendarPeriodListCurrentApi = () =>
  FetchAPI(
    url.OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_API,
    "GET"
  );
//overviewStaffToStaffHolidayCalendarPeriodListFutureApi
export const overviewStaffToStaffHolidayCalendarPeriodListFutureApi = () =>
  FetchAPI(
    url.OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_API,
    "GET"
  );
//overviewStaffToStaffHolidayCalendarPeriodListPastApi
export const overviewStaffToStaffHolidayCalendarPeriodListPastApi = () =>
  FetchAPI(
    url.OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_API,
    "GET"
  );
//overviewStaffToStaffHolidayCalendarPeriodListApi
export const overviewStaffToStaffHolidayCalendarPeriodListApi = () =>
  FetchAPI(url.OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_API, "GET");
//staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersApi
export const staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersApi =
  () =>
    FetchAPI(
      url.STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_API,
      "GET"
    );
//staffToStaffHolidayCalendarPeriodSearchApi
export const staffToStaffHolidayCalendarPeriodSearchApi = (data) =>
  FetchAPI(url.STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_API, "POST", data);
//getStaffLeaveRestrictionPeriodListApi
export const getStaffLeaveRestrictionPeriodListApi = () =>
  FetchAPI(url.GET_STAFF_LEAVE_RESTRICTION_PERIOD_LIST_API, "GET");
//getStaffLeaveRestrictionPeriodDataApi
export const getStaffLeaveRestrictionPeriodDataApi = (data) =>
  FetchAPI(url.GET_STAFF_LEAVE_RESTRICTION_PERIOD_DATA_API, "GET", data);
//createStaffLeaveRestrictionPeriodApi
export const createStaffLeaveRestrictionPeriodApi = (data) =>
  FetchAPI(url.CREATE_STAFF_LEAVE_RESTRICTION_PERIOD_API, "POST", data);
//updateStaffLeaveRestrictionPeriodApi
export const updateStaffLeaveRestrictionPeriodApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_LEAVE_RESTRICTION_PERIOD_API, "PUT", data);
//deleteStaffLeaveRestrictionPeriodApi
export const deleteStaffLeaveRestrictionPeriodApi = (data) =>
  FetchAPI(url.DELETE_STAFF_LEAVE_RESTRICTION_PERIOD_API, "DELETE", data);

//postFeedbackAPI
export const postFeedbackAPI = (data) =>
  FetchAPI(url.POST_FEEDBACK_API, "POST", data);

//salesOrderListApi
export const salesOrderListApi = () =>
  FetchAPI(url.SALES_ORDER_LIST_API, "GET");
//salesOrderDataApi
export const salesOrderDataApi = (data) =>
  FetchAPI(url.SALES_ORDER_DATA_API, "GET", data);
//salesOrderSearchApi
export const salesOrderSearchApi = (data) =>
  FetchAPI(url.SALES_ORDER_SEARCH_API, "POST", data);
//salesOrderCreateApi
export const salesOrderCreateApi = (data) =>
  FetchAPI(url.SALES_ORDER_CREATE_API, "POST", data);
//salesOrderUpdateApi
export const salesOrderUpdateApi = (data) =>
  FetchAPI(url.SALES_ORDER_UPDATE_API, "PUT", data);
//salesOrderVoidApi
export const salesOrderVoidApi = (data) =>
  FetchAPI(url.SALES_ORDER_VOID_API, "POST", data);
//salesOrderPdfApi
export const salesOrderPdfApi = (data) =>
  FetchAPI(url.SALES_ORDER_PDF_API, "POST", data);
//salesOrderEmailAutomatedApi
export const salesOrderEmailAutomatedApi = (data) =>
  FetchAPI(url.SALES_ORDER_EMAIL_AUTOMATED_API, "GET", data);
//salesOrderEmailResendAutomatedApi
export const salesOrderEmailResendAutomatedApi = (data) =>
  FetchAPI(url.SALES_ORDER_EMAIL_RESEND_AUTOMATED_API, "GET", data);
//salesOrderDailyBalanceApi
export const salesOrderDailyBalanceApi = (data) =>
  FetchAPI(url.SALES_ORDER_DAILY_BALANCE_API, "POST", data);
//salesOrderItemSearchApi
export const salesOrderItemSearchApi = (data) =>
  FetchAPI(url.SALES_ORDER_ITEM_SEARCH_API, "POST", data);
//salesOrderItemListApi
export const salesOrderItemListApi = () =>
  FetchAPI(url.SALES_ORDER_ITEM_LIST_API, "GET");
//salesOrderStatusListApi
export const salesOrderStatusListApi = () =>
  FetchAPI(url.SALES_ORDER_STATUS_LIST_API, "GET");
//salesOrderStatusDataApi
export const salesOrderStatusDataApi = (data) =>
  FetchAPI(url.SALES_ORDER_STATUS_DATA_API, "GET", data);
//salesOrderStatusCreateApi
export const salesOrderStatusCreateApi = (data) =>
  FetchAPI(url.SALES_ORDER_STATUS_CREATE_API, "POST", data);
//salesOrderStatusUpdateApi
export const salesOrderStatusUpdateApi = (data) =>
  FetchAPI(url.SALES_ORDER_STATUS_UPDATE_API, "PUT", data);
//salesOrderStatusDeleteApi
export const salesOrderStatusDeleteApi = (data) =>
  FetchAPI(url.SALES_ORDER_STATUS_DELETE_API, "DELETE", data);
//salesOrderActivityLogSearchApi
export const salesOrderActivityLogSearchApi = (data) =>
  FetchAPI(url.SALES_ORDER_ACTIVITY_LOG_SEARCH_API, "POST", data);
//salesOrderConvertToInvoiceApi
export const salesOrderConvertToInvoiceApi = (data) =>
  FetchAPI(url.SALES_ORDER_CONVERT_TO_INVOICE_API, "POST", data);
//productStockReservedSearchApi
export const productStockReservedSearchApi = (data) =>
  FetchAPI(url.PRODUCT_STOCK_RESERVED_SEARCH_API, "POST", data);
//productStockReservedListApi
export const productStockReservedListApi = () =>
  FetchAPI(url.PRODUCT_STOCK_RESERVED_LIST_API, "GET");
//getPurchaseOrderStatusDataAPI
export const getPurchaseOrderStatusDataAPI = (data) =>
  FetchAPI(url.GET_PURCHASE_ORDER_STATUS_DATA_API, "GET", data);
//createPurchaseOrderStatusAPI
export const createPurchaseOrderStatusAPI = (data) =>
  FetchAPI(url.CREATE_PURCHASE_ORDER_STATUS_API, "POST", data);
//updatePurchaseOrderStatusAPI
export const updatePurchaseOrderStatusAPI = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_ORDER_STATUS_API, "PUT", data);
//deletePurchaseOrderStatusAPI
export const deletePurchaseOrderStatusAPI = (data) =>
  FetchAPI(url.DELETE_PURCHASE_ORDER_STATUS_API, "DELETE", data);
//getPurchaseOrderPdfAPI
export const getPurchaseOrderPdfAPI = (data) =>
  FetchAPI(url.GET_PURCHASE_ORDER_PDF_API, "POST", data);

// ****************************************************
//getMasterPaymentProvider
//getMasterPaymentProviderListApi
export const getMasterPaymentProviderListApi = () =>
  FetchAPI(url.GET_MASTER_PAYMENT_PROVIDER_LIST_API, "GET");
//getMasterPaymentProviderDataApi
export const getMasterPaymentProviderDataApi = (data) =>
  FetchAPI(url.GET_MASTER_PAYMENT_PROVIDER_DATA_API, "GET", data);
//createMasterPaymentProviderApi
export const createMasterPaymentProviderApi = (data) =>
  FetchAPI(url.CREATE_MASTER_PAYMENT_PROVIDER_API, "POST", data);
//updateMasterPaymentProviderApi
export const updateMasterPaymentProviderApi = (data) =>
  FetchAPI(url.UPDATE_MASTER_PAYMENT_PROVIDER_API, "PUT", data);
//deleteMasterPaymentProviderApi
export const deleteMasterPaymentProviderApi = (data) =>
  FetchAPI(url.DELETE_MASTER_PAYMENT_PROVIDER_API, "DELETE", data);

//getPurchaseOrderListAPI
export const getPurchaseOrderListAPI = () =>
  FetchAPI(url.GET_PURCHASE_ORDER_LIST_API, "GET");
//getPurchaseOrderSearchAPI
export const getPurchaseOrderSearchAPI = (data) =>
  FetchAPI(url.GET_PURCHASE_ORDER_SEARCH_API, "POST", data);
//getPurchaseOrderDataAPI
export const getPurchaseOrderDataAPI = (data) =>
  FetchAPI(url.GET_PURCHASE_ORDER_DATA_API, "GET", data);
//createPurchaseOrderAPI
export const createPurchaseOrderAPI = (data) =>
  FetchAPI(url.CREATE_PURCHASE_ORDER_API, "POST", data);
//updatePurchaseOrderAPI
export const updatePurchaseOrderAPI = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_ORDER_API, "PUT", data);
//voidPurchaseOrderAPI
export const voidPurchaseOrderAPI = (data) =>
  FetchAPI(url.VOID_PURCHASE_ORDER_API, "POST", data);
//markCompletePurchaseOrderAPI
export const markCompletePurchaseOrderAPI = (data) =>
  FetchAPI(url.MARK_COMPLETE_PURCHASE_ORDER_API, "POST", data);
//getPurchaseOrderStatusListAPI
export const getPurchaseOrderStatusListAPI = () =>
  FetchAPI(url.GET_PURCHASE_ORDER_STATUS_LIST_API, "GET");

//**************************************************************
//Shift Reports
//apiGetFoodShiftReportList
export const apiGetFoodShiftReportList = () =>
  FetchAPI(url.API_GET_FOOD_SHIFT_REPORT_LIST, "GET");
//apiSearchFoodShiftReport
export const apiSearchFoodShiftReport = (data) =>
  FetchAPI(url.API_SEARCH_FOOD_SHIFT_REPORT, "POST", data);
//Chat CRMit
//chatbotInteractApi
export const chatbotInteractApi = (data) =>
  FetchAPI(url.CHATBOT_INTERACT_API, "POST", data);
//chatbotVoiceToTextApi
export const chatbotVoiceToTextApi = (data) =>
  FetchAPI(url.CHATBOT_VOICE_TO_TEXT_API, "POST", data);
//CRMit AI Assistant (agentic)
//assistantChatApi — { ConversationKey?, Message }
export const assistantChatApi = (data) =>
  FetchAPI(url.ASSISTANT_CHAT_API, "POST", data);
//assistantConfirmApi — { ConversationKey, PendingActionId, Decision: "allow"|"deny" }
export const assistantConfirmApi = (data) =>
  FetchAPI(url.ASSISTANT_CONFIRM_API, "POST", data);
//assistantGeneralApi — { ConversationKey?, Message } — general ChatGPT mode, no CRM tools
export const assistantGeneralApi = (data) =>
  FetchAPI(url.ASSISTANT_GENERAL_API, "POST", data);
//assistantConversationsApi — list the current user's conversations (both modes)
export const assistantConversationsApi = () =>
  FetchAPI(url.ASSISTANT_CONVERSATIONS_API, "GET");
//assistantConversationApi — load one conversation's transcript by key
export const assistantConversationApi = (key) =>
  FetchAPI(url.ASSISTANT_CONVERSATION_API, "GET", { id: key });

//**************************************************************
//Book A Table
//getFoodTableWidgetRenderDataRequest
export const getFoodTableWidgetRenderDataRequest = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_WIDGET_RENDER_DATA_REQUEST, "GET", data);
//postFoodTableWidgetCheckAvailabilityRequest
export const postFoodTableWidgetCheckAvailabilityRequest = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_REQUEST, "POST", data);
//postFoodTableWidgetBookRequest
export const postFoodTableWidgetBookRequest = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_WIDGET_BOOK_REQUEST, "POST", data);
//getFoodTableWidgetListRequest
export const getFoodTableWidgetListRequest = () =>
  FetchAPI(url.GET_FOOD_TABLE_WIDGET_LIST_REQUEST, "GET");
//getFoodTableWidgetDataRequest
export const getFoodTableWidgetDataRequest = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_WIDGET_DATA_REQUEST, "GET", data);
//postFoodTableWidgetCreateRequest
export const postFoodTableWidgetCreateRequest = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_WIDGET_CREATE_REQUEST, "POST", data);
//putFoodTableWidgetUpdateRequest
export const putFoodTableWidgetUpdateRequest = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_WIDGET_UPDATE_REQUEST, "PUT", data);
//deleteFoodTableWidgetDeleteRequest
export const deleteFoodTableWidgetDeleteRequest = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_WIDGET_DELETE_REQUEST, "DELETE", data);
//getFoodTableReservationTableAssignmentActivityLogSearchRequest
export const getFoodTableReservationTableAssignmentActivityLogSearchRequest = (
  data
) =>
  FetchAPI(
    url.GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_REQUEST,
    "POST",
    data
  );
//postFoodTableReservationTableAssignmentLockRequest
export const postFoodTableReservationTableAssignmentLockRequest = (data) =>
  FetchAPI(
    url.POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_REQUEST,
    "POST",
    data
  );
//postFoodTableReservationTableAssignmentUnlockRequest
export const postFoodTableReservationTableAssignmentUnlockRequest = (data) =>
  FetchAPI(
    url.POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_REQUEST,
    "POST",
    data
  );
//getFoodTableWidgetSearchRequest
export const getFoodTableWidgetSearchRequest = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_WIDGET_SEARCH_REQUEST, "POST", data);
//getPaymentRequestPublicDataRequest
export const getPaymentRequestPublicDataRequest = (data) =>
  FetchAPI(url.GET_PAYMENT_REQUEST_PUBLIC_DATA_REQUEST, "POST", data);
//getFoodTableReservationPublicRenderDataRequest
export const getFoodTableReservationPublicRenderDataRequest = (data) =>
  FetchAPI(
    url.GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_REQUEST,
    "GET",
    data
  );
//postFoodTableReservationPublicCancelRequest
export const postFoodTableReservationPublicCancelRequest = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_REQUEST, "GET", data);
//FOOD TABLE
//getFoodTableReservationList
export const getFoodTableReservationList = () =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_LIST, "GET");
//getFoodTableReservationListToday
export const getFoodTableReservationListToday = () =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_LIST_TODAY, "GET");
//getFoodTableReservationListTomorrow
export const getFoodTableReservationListTomorrow = () =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_LIST_TOMORROW, "GET");
//getFoodTableReservationListFuture
export const getFoodTableReservationListFuture = () =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_LIST_FUTURE, "GET");
//getFoodTableReservationData
export const getFoodTableReservationData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_DATA, "GET", data);
//postFoodTableReservationCreate
export const postFoodTableReservationCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_RESERVATION_CREATE, "POST", data);
//postFoodTableReservationImport
export const postFoodTableReservationImport = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_RESERVATION_IMPORT, "POST", data);
//putFoodTableReservationUpdate
export const putFoodTableReservationUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_RESERVATION_UPDATE, "PUT", data);
//deleteFoodTableReservationDelete
export const deleteFoodTableReservationDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_RESERVATION_DELETE, "DELETE", data);
//getFoodTableAreaList
export const getFoodTableAreaList = () =>
  FetchAPI(url.GET_FOOD_TABLE_AREA_LIST, "GET");
//getFoodTableAreaData
export const getFoodTableAreaData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_AREA_DATA, "GET", data);
//postFoodTableAreaCreate
export const postFoodTableAreaCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_AREA_CREATE, "POST", data);
//putFoodTableAreaUpdate
export const putFoodTableAreaUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_AREA_UPDATE, "PUT", data);
//deleteFoodTableAreaDelete
export const deleteFoodTableAreaDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_AREA_DELETE, "DELETE", data);
//putFoodTableAreaReorder (drag-sort areas)
export const putFoodTableAreaReorder = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_AREA_REORDER, "PUT", data);
//FoodTableReservationDurationRule (booking duration rules)
export const getFoodTableReservationDurationRuleData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_DURATION_RULE_DATA, "GET", data);
export const postFoodTableReservationDurationRuleCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_RESERVATION_DURATION_RULE_CREATE, "POST", data);
export const putFoodTableReservationDurationRuleUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_RESERVATION_DURATION_RULE_UPDATE, "PUT", data);
export const deleteFoodTableReservationDurationRuleDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_RESERVATION_DURATION_RULE_DELETE, "DELETE", data);
export const postFoodTableReservationDurationRuleSearch = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_RESERVATION_DURATION_RULE_SEARCH, "POST", data);
//getFoodTableList
export const getFoodTableList = () => FetchAPI(url.GET_FOOD_TABLE_LIST, "GET");
//getFoodTableData
export const getFoodTableData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_DATA, "GET", data);
//postFoodTableCreate
export const postFoodTableCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_CREATE, "POST", data);
//putFoodTableUpdate
export const putFoodTableUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_UPDATE, "PUT", data);
//deleteFoodTableDelete
export const deleteFoodTableDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_DELETE, "DELETE", data);
//getFoodTableReservationSearch
export const getFoodTableReservationSearch = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_SEARCH, "POST", data);
//putFoodTableDiaryBlockUpdate
export const putFoodTableDiaryBlockUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_DIARY_BLOCK_UPDATE, "PUT", data);
//getFoodTableBlockList
export const getFoodTableBlockList = () =>
  FetchAPI(url.GET_FOOD_TABLE_BLOCK_LIST, "GET");
//getFoodTableBlockData
export const getFoodTableBlockData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_BLOCK_DATA, "GET", data);
//postFoodTableBlockCreate
export const postFoodTableBlockCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_BLOCK_CREATE, "POST", data);
//deleteFoodTableBlockDelete
export const deleteFoodTableBlockDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_BLOCK_DELETE, "DELETE", data);
//putFoodTableReservationTableAssignmentUpdate
export const putFoodTableReservationTableAssignmentUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE, "PUT", data);
//putFoodTableReservationTableAssignmentCancel
export const putFoodTableReservationTableAssignmentCancel = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL, "PUT", data);
// Task 24607 - Unallocated tray. Both take a top-level array, so neither trips
// FetchAPI's "payload has an id -> append it to the URL" behaviour.
export const postFoodTableReservationTableAssignmentUnassign = (data) =>
  FetchAPI(
    url.POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
    "POST",
    data
  );
export const postFoodTableReservationTableAssignmentAssign = (data) =>
  FetchAPI(
    url.POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
    "POST",
    data
  );
// Task 24278 - request-to-book approve / decline (id goes in the URL path)
export const putFoodTableReservationRequestApprove = (data) =>
  FetchAPI(
    url.PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE + "/" + data?.id,
    "PUT"
  );
export const getFoodTableReservationRequestDeclinePreview = (data) =>
  FetchAPI(
    url.GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW + "/" + data?.id,
    "GET"
  );
export const putFoodTableReservationRequestDecline = (data) =>
  FetchAPI(
    url.PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE + "/" + data?.id,
    "PUT",
    {
      Subject: data?.Subject,
      BodyHtml: data?.BodyHtml,
      Reason: data?.Reason,
      To: data?.To,
    }
  );
//getFoodTableDiaryRuleList
export const getFoodTableDiaryRuleList = () =>
  FetchAPI(url.GET_FOOD_TABLE_DIARY_RULE_LIST, "GET");
//getFoodTableDiaryRuleData
export const getFoodTableDiaryRuleData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_DIARY_RULE_DATA, "GET", data);
//postFoodTableDiaryRuleCreate
export const postFoodTableDiaryRuleCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_DIARY_RULE_CREATE, "POST", data);
//putFoodTableDiaryRuleUpdate
export const putFoodTableDiaryRuleUpdate = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_DIARY_RULE_UPDATE, "PUT", data);
//deleteFoodTableDiaryRuleDelete
export const deleteFoodTableDiaryRuleDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_DIARY_RULE_DELETE, "DELETE", data);
//postFoodTableDiaryRuleReorder
export const postFoodTableDiaryRuleReorder = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_DIARY_RULE_REORDER, "POST", data);
//getFoodTableDiaryRuleSearch
export const getFoodTableDiaryRuleSearch = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_DIARY_RULE_SEARCH, "POST", data);
//getFoodTableDiaryRuleSearchByTimeslot
export const getFoodTableDiaryRuleSearchByTimeslot = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT, "POST", data);
// TABLE PLANNER (Task 24625)
export const putFoodTableFloorPlanAPI = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_FLOORPLAN_API, "PUT", data);
// BOOKING ENGINE TABLE ORDER (Task 24634)
export const putFoodTableReorderAPI = (data) =>
  FetchAPI(url.PUT_FOOD_TABLE_REORDER_API, "PUT", data);
//getFoodTableSearchAPI
export const getFoodTableSearchAPI = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_SEARCH_API, "POST", data);
//getFoodTableAreaSearchAPI
export const getFoodTableAreaSearchAPI = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_AREA_SEARCH_API, "POST", data);
//getFoodTableRuleSearchAPI
export const getFoodTableRuleSearchAPI = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RULE_SEARCH_API, "POST", data);
//getFoodTableReservationTableAssignmentPdfRunningOrder
export const getFoodTableReservationTableAssignmentPdfRunningOrder = (data) =>
  FetchAPI(
    url.GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
    "POST",
    data
  );
//getFoodTableReservationCheckAvailability
export const getFoodTableReservationCheckAvailability = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY, "POST", data);
//getFoodTableReservationSearchSingleCustomer
export const getFoodTableReservationSearchSingleCustomer = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER, "POST", data);
//getFoodTableJoinList
export const getFoodTableJoinList = () =>
  FetchAPI(url.GET_FOOD_TABLE_JOIN_LIST, "GET");
//getFoodTableJoinData
export const getFoodTableJoinData = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_JOIN_DATA, "GET", data);
//postFoodTableJoinCreate
export const postFoodTableJoinCreate = (data) =>
  FetchAPI(url.POST_FOOD_TABLE_JOIN_CREATE, "POST", data);
//deleteFoodTableJoinDelete
export const deleteFoodTableJoinDelete = (data) =>
  FetchAPI(url.DELETE_FOOD_TABLE_JOIN_DELETE, "DELETE", data);
//getFoodTableJoinSearch
export const getFoodTableJoinSearch = (data) =>
  FetchAPI(url.GET_FOOD_TABLE_JOIN_SEARCH, "POST", data);
//getFoodPreorderSiteLocationFloorPlanObjectList
export const getFoodPreorderSiteLocationFloorPlanObjectList = (data) =>
  FetchAPI(url.GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST, "GET");
//getFoodPreorderSiteLocationFloorPlanObjectData
export const getFoodPreorderSiteLocationFloorPlanObjectData = (data) =>
  FetchAPI(
    url.GET_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
    "GET",
    data
  );
//postFoodPreorderSiteLocationFloorPlanObjectCreate
export const postFoodPreorderSiteLocationFloorPlanObjectCreate = (data) =>
  FetchAPI(
    url.POST_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
    "POST",
    data
  );
//putFoodPreorderSiteLocationFloorPlanObjectUpdate
export const putFoodPreorderSiteLocationFloorPlanObjectUpdate = (data) =>
  FetchAPI(
    url.PUT_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
    "PUT",
    data
  );
//deleteFoodPreorderSiteLocationFloorPlanObjectDelete
export const deleteFoodPreorderSiteLocationFloorPlanObjectDelete = (data) =>
  FetchAPI(
    url.DELETE_FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
    "DELETE",
    data
  );
//getMessagingConversationListApi
export const getMessagingConversationListApi = () =>
  FetchAPI(url.GET_MESSAGING_CONVERSATION_LIST_API, "GET");
//searchMessagingConversationMessageListApi
export const searchMessagingConversationMessageListApi = (data) =>
  FetchAPI(url.SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_API, "POST", data);
//sendMessagingConversationMessageApi
export const sendMessagingConversationMessageApi = (data) =>
  FetchAPI(url.SEND_MESSAGING_CONVERSATION_MESSAGE_API, "POST", data);
//updateMessagingConversationApi
export const updateMessagingConversationApi = (data) =>
  FetchAPI(url.UPDATE_MESSAGING_CONVERSATION_API, "PUT", data);
//createMessagingConversationApi
export const createMessagingConversationApi = (data) =>
  FetchAPI(url.CREATE_MESSAGING_CONVERSATION_API, "POST", data);
//getMessagingChannelListApi
export const getMessagingChannelListApi = () =>
  FetchAPI(url.GET_MESSAGING_CHANNEL_LIST_API, "GET");
//startMessagingConversationMessageApi
export const startMessagingConversationMessageApi = (data) =>
  FetchAPI(url.START_MESSAGING_CONVERSATION_MESSAGE_API, "POST", data);
//searchMessagingConversationTemplateApi
export const searchMessagingConversationTemplateApi = (data) =>
  FetchAPI(url.SEARCH_MESSAGING_CONVERSATION_TEMPLATE_API, "POST", data);
//removeMessagingConversationParticipantApi
export const removeMessagingConversationParticipantApi = (data) =>
  FetchAPI(url.REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_API, "POST", data);
//markMessagingConversationReadApi
export const markMessagingConversationReadApi = (data) =>
  FetchAPI(url.MARK_MESSAGING_CONVERSATION_READ_API, "POST", data);
//markMessagingConversationUnreadApi
export const markMessagingConversationUnreadApi = (data) =>
  FetchAPI(url.MARK_MESSAGING_CONVERSATION_UNREAD_API, "POST", data);
//markMessagingConversationMessageReadApi
export const markMessagingConversationMessageReadApi = (data) =>
  FetchAPI(url.MARK_MESSAGING_CONVERSATION_MESSAGE_READ_API, "POST", data);
//markMessagingConversationMessageUnreadApi
export const markMessagingConversationMessageUnreadApi = (data) =>
  FetchAPI(url.MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_API, "POST", data);
//getMessagingConversationDataApi
export const getMessagingConversationDataApi = (data) =>
  FetchAPI(url.GET_MESSAGING_CONVERSATION_DATA_API, "GET", data);
//closeMessagingConversationApi
export const closeMessagingConversationApi = (data) =>
  FetchAPI(url.CLOSE_MESSAGING_CONVERSATION_API, "POST", data);
//BOM
//getBomComponentSupplierProductListApi
export const getBomComponentSupplierProductListApi = () =>
  FetchAPI(url.GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_API, "GET");
//getBomComponentSupplierProductDataApi
export const getBomComponentSupplierProductDataApi = (data) =>
  FetchAPI(url.GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_API, "GET", data);
//searchBomComponentSupplierProductApi
export const searchBomComponentSupplierProductApi = (data) =>
  FetchAPI(url.SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_API, "POST", data);
//createBomComponentSupplierProductApi
export const createBomComponentSupplierProductApi = (data) =>
  FetchAPI(url.CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API, "POST", data);
//updateBomComponentSupplierProductApi
export const updateBomComponentSupplierProductApi = (data) =>
  FetchAPI(url.UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_API, "PUT", data);
//deleteBomComponentSupplierProductApi
export const deleteBomComponentSupplierProductApi = (data) =>
  FetchAPI(url.DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_API, "DELETE", data);
//getBomComponentListApi
export const getBomComponentListApi = () =>
  FetchAPI(url.GET_BOM_COMPONENT_LIST_API, "GET");
//getBomComponentDataApi
export const getBomComponentDataApi = (data) =>
  FetchAPI(url.GET_BOM_COMPONENT_DATA_API, "GET", data);
//searchBomComponentApi
export const searchBomComponentApi = (data) =>
  FetchAPI(url.SEARCH_BOM_COMPONENT_API, "POST", data);
//createBomComponentApi
export const createBomComponentApi = (data) =>
  FetchAPI(url.CREATE_BOM_COMPONENT_API, "POST", data);
//updateBomComponentApi
export const updateBomComponentApi = (data) =>
  FetchAPI(url.UPDATE_BOM_COMPONENT_API, "PUT", data);
//deleteBomComponentApi
export const deleteBomComponentApi = (data) =>
  FetchAPI(url.DELETE_BOM_COMPONENT_API, "DELETE", data);
//getSalesOrderBillOfMaterialsApi — aggregated BOM for a whole sales order (id appended by FetchAPI)
export const getSalesOrderBillOfMaterialsApi = (data) =>
  FetchAPI(url.GET_SALES_ORDER_BILL_OF_MATERIALS_API, "GET", data);
//getBomListApi
export const getBomListApi = () => FetchAPI(url.GET_BOM_LIST_API, "GET");
//getBomDataApi
export const getBomDataApi = (data) =>
  FetchAPI(url.GET_BOM_DATA_API, "GET", data);
//searchBomApi
export const searchBomApi = (data) =>
  FetchAPI(url.SEARCH_BOM_API, "POST", data);
//createBomApi
export const createBomApi = (data) =>
  FetchAPI(url.CREATE_BOM_API, "POST", data);
//updateBomApi
export const updateBomApi = (data) => FetchAPI(url.UPDATE_BOM_API, "PUT", data);
//deleteBomApi
export const deleteBomApi = (data) =>
  FetchAPI(url.DELETE_BOM_API, "DELETE", data);
//createBomVersionApi
export const createBomVersionApi = (data) =>
  FetchAPI(url.CREATE_BOM_VERSION_API, "POST", data);
//cloneBomApi
export const cloneBomApi = (data) => FetchAPI(url.CLONE_BOM_API, "POST", data);
//searchProductToBomApi
export const searchProductToBomApi = (data) =>
  FetchAPI(url.SEARCH_PRODUCT_TO_BOM_API, "POST", data);
//searchProductBomToProductRuleApi — mapped products for a BOM (lookup mapping)
export const searchProductBomToProductRuleApi = (data) =>
  FetchAPI(url.SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_API, "POST", data);
//Public Payment API
//getPaymentRequestDataApi
export const getPaymentRequestDataApi = (data) =>
  FetchAPI(url.GET_PAYMENT_REQUEST_DATA_API, "GET", data);
//getPaymentCompleteDataApi
export const getPaymentCompleteDataApi = (data) =>
  FetchAPI(url.GET_PAYMENT_COMPLETE_DATA_API, "POST", data);
//createPublicManualPaymentIntentApi
export const createPublicManualPaymentIntentApi = (data) =>
  FetchAPI(url.CREATE_PUBLIC_MANUAL_PAYMENT_INTENT_API, "POST", data);
//getReportSchemaApi
export const getReportSchemaApi = () =>
  FetchAPI(url.GET_REPORT_SCHEMA_API, "POST");
//runReportApi
export const runReportApi = (data) =>
  FetchAPI(url.RUN_REPORT_API, "POST", data);
//savedReports
export const getSavedReportsApi = () =>
  FetchAPI(url.REPORT_SAVED_LIST_API, "POST");
export const createSavedReportApi = (data) =>
  FetchAPI(url.REPORT_SAVED_CREATE_API, "POST", data);
export const updateSavedReportApi = (data) =>
  FetchAPI(url.REPORT_SAVED_UPDATE_API, "POST", data);
export const deleteSavedReportApi = (data) =>
  FetchAPI(url.REPORT_SAVED_DELETE_API, "POST", data);
//PurchaseDraft
//getPurchaseDraftListApi
export const getPurchaseDraftListApi = () =>
  FetchAPI(url.GET_PURCHASE_DRAFT_LIST_API, "GET");
//getPurchaseDraftSearchApi
export const getPurchaseDraftSearchApi = (data) =>
  FetchAPI(url.GET_PURCHASE_DRAFT_SEARCH_API, "POST", data);
//getPurchaseDraftDataApi
export const getPurchaseDraftDataApi = (data) =>
  FetchAPI(url.GET_PURCHASE_DRAFT_DATA_API, "GET", data);
//createPurchaseDraftApi
export const createPurchaseDraftApi = (data) =>
  FetchAPI(url.CREATE_PURCHASE_DRAFT_API, "POST", data);
//updatePurchaseDraftApi
export const updatePurchaseDraftApi = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_DRAFT_API, "PUT", data);
//deletePurchaseDraftApi
export const deletePurchaseDraftApi = (data) =>
  FetchAPI(url.DELETE_PURCHASE_DRAFT_API, "DELETE", data);
//convertToPurchaseApi
export const convertToPurchaseApi = (data) =>
  FetchAPI(url.CONVERT_TO_PURCHASE_API, "POST", data);
//payment request
//getPaymentRequestList
export const getPaymentRequestList = () =>
  FetchAPI(url.GET_PAYMENT_REQUEST_LIST, "GET");
//getPaymentRequestPreview
export const getPaymentRequestPreview = () =>
  FetchAPI(url.GET_PAYMENT_REQUEST_PREVIEW, "GET");
//getPaymentRequestPredicted
export const getPaymentRequestPredicted = () =>
  FetchAPI(url.GET_PAYMENT_REQUEST_PREDICTED, "GET");
//getPaymentRequestUncollectable
export const getPaymentRequestUncollectable = () =>
  FetchAPI(url.GET_PAYMENT_REQUEST_UNCOLLECTABLE, "GET");
//getPaymentRequestData
export const getPaymentRequestData = (data) =>
  FetchAPI(url.GET_PAYMENT_REQUEST_DATA, "GET", data);
//createPaymentRequest
export const createPaymentRequest = (data) =>
  FetchAPI(url.CREATE_PAYMENT_REQUEST, "POST", data);
//searchPaymentRequest
export const searchPaymentRequest = (data) =>
  FetchAPI(url.SEARCH_PAYMENT_REQUEST, "POST", data);
//voidPaymentRequest
export const voidPaymentRequest = (data) =>
  FetchAPI(url.VOID_PAYMENT_REQUEST, "POST", data);
//getPurchaseDraftStatusListApi
export const getPurchaseDraftStatusListApi = () =>
  FetchAPI(url.GET_PURCHASE_DRAFT_STATUS_LIST_API, "GET");
//getPurchaseDraftStatusDataApi
export const getPurchaseDraftStatusDataApi = (data) =>
  FetchAPI(url.GET_PURCHASE_DRAFT_STATUS_DATA_API, "GET", data);
//createPurchaseDraftStatusApi
export const createPurchaseDraftStatusApi = (data) =>
  FetchAPI(url.CREATE_PURCHASE_DRAFT_STATUS_API, "POST", data);
//updatePurchaseDraftStatusApi
export const updatePurchaseDraftStatusApi = (data) =>
  FetchAPI(url.UPDATE_PURCHASE_DRAFT_STATUS_API, "PUT", data);
//deletePurchaseDraftStatusApi
export const deletePurchaseDraftStatusApi = (data) =>
  FetchAPI(url.DELETE_PURCHASE_DRAFT_STATUS_API, "DELETE", data);
//HMRC
//hmrcUrlAuthApi
export const hmrcUrlAuthApi = () => FetchAPI(url.HMRC_URL_AUTH_API, "GET");
//hmrcGenerateAccessTokenApi
export const hmrcGenerateAccessTokenApi = (data) =>
  FetchAPI(url.HMRC_GENERATE_ACCESS_TOKEN_API, "POST", data);
//importOpportunityApiCall
export const importOpportunityApiCall = (data) =>
  FetchAPI(url.IMPORT_OPPORTUNITY_API, "POST", data);
//callDataImportSchemaApi (POST, no body)
export const callDataImportSchemaApi = () =>
  FetchAPI(url.IMPORT_DATA_SCHEMA_API, "POST");
//callDataImportApi (POST import job)
export const callDataImportApi = (data) =>
  FetchAPI(url.IMPORT_DATA_API, "POST", data);
//callDataImportReshapeApi (POST — AI reshape a messy grid into a flat table)
export const callDataImportReshapeApi = (data) =>
  FetchAPI(url.IMPORT_DATA_RESHAPE_API, "POST", data);
//ResDiary migration importers (Task 24417)
//callImportResDiaryTablesApi — saved ResDiary table-plan HTML
export const callImportResDiaryTablesApi = (data) =>
  FetchAPI(url.IMPORT_RESDIARY_TABLES_API, "POST", data);
//callImportResDiaryBookingsHtmlApi — saved bookings report HTML (fallback)
export const callImportResDiaryBookingsHtmlApi = (data) =>
  FetchAPI(url.IMPORT_RESDIARY_BOOKINGS_HTML_API, "POST", data);
//callImportResDiaryBookingsCsvApi — bookings CSV export (primary path)
export const callImportResDiaryBookingsCsvApi = (data) =>
  FetchAPI(url.IMPORT_RESDIARY_BOOKINGS_CSV_API, "POST", data);
//callImportResDiaryClosuresApi — closures CSV -> reservation diary rules
export const callImportResDiaryClosuresApi = (data) =>
  FetchAPI(url.IMPORT_RESDIARY_CLOSURES_API, "POST", data);
//getSupplierProductList
export const getSupplierProductList = () =>
  FetchAPI(url.GET_SUPPLIER_PRODUCT_LIST, "GET");
//getSupplierProductData
export const getSupplierProductData = (data) =>
  FetchAPI(url.GET_SUPPLIER_PRODUCT_DATA, "GET", data);
//getSupplierProductSearch
export const getSupplierProductSearch = (data) =>
  FetchAPI(url.GET_SUPPLIER_PRODUCT_SEARCH, "POST", data);
//createSupplierProduct
export const createSupplierProduct = (data) =>
  FetchAPI(url.CREATE_SUPPLIER_PRODUCT, "POST", data);
//updateSupplierProduct
export const updateSupplierProduct = (data) =>
  FetchAPI(url.UPDATE_SUPPLIER_PRODUCT, "PUT", data);
//deleteSupplierProduct
export const deleteSupplierProduct = (data) =>
  FetchAPI(url.DELETE_SUPPLIER_PRODUCT, "DELETE", data);

//getInvoiceDraftList
export const getInvoiceDraftList = () =>
  FetchAPI(url.GET_INVOICE_DRAFT_LIST, "GET");
//searchInvoiceDraft
export const searchInvoiceDraft = (data) =>
  FetchAPI(url.SEARCH_INVOICE_DRAFT, "POST", data);
//createInvoiceDraft
export const createInvoiceDraft = (data) =>
  FetchAPI(url.CREATE_INVOICE_DRAFT, "POST", data);
//updateInvoiceDraft
export const updateInvoiceDraft = (data) =>
  FetchAPI(url.UPDATE_INVOICE_DRAFT, "PUT", data);
//voidInvoiceDraft
export const voidInvoiceDraft = (data) =>
  FetchAPI(url.VOID_INVOICE_DRAFT, "POST", data);
//getInvoiceDraftPdf
export const getInvoiceDraftPdf = (data) =>
  FetchAPI(url.GET_INVOICE_DRAFT_PDF, "POST", data);
//getInvoiceDraftDailyBalance
export const getInvoiceDraftDailyBalance = (data) =>
  FetchAPI(url.GET_INVOICE_DRAFT_DAILY_BALANCE, "POST", data);
//getInvoiceDraftStatusList
export const getInvoiceDraftStatusList = () =>
  FetchAPI(url.GET_INVOICE_DRAFT_STATUS_LIST, "GET");
//getInvoiceDraftStatusData
export const getInvoiceDraftStatusData = (data) =>
  FetchAPI(url.GET_INVOICE_DRAFT_STATUS_DATA, "GET", data);
//createInvoiceDraftStatus
export const createInvoiceDraftStatus = (data) =>
  FetchAPI(url.CREATE_INVOICE_DRAFT_STATUS, "POST", data);
//updateInvoiceDraftStatus
export const updateInvoiceDraftStatus = (data) =>
  FetchAPI(url.UPDATE_INVOICE_DRAFT_STATUS, "PUT", data);
//deleteInvoiceDraftStatus
export const deleteInvoiceDraftStatus = (data) =>
  FetchAPI(url.DELETE_INVOICE_DRAFT_STATUS, "DELETE", data);
//getInvoiceDraftData
export const getInvoiceDraftData = (data) =>
  FetchAPI(url.GET_INVOICE_DRAFT_DATA, "GET", data);
//searchInvoiceDraftActivityLog
export const searchInvoiceDraftActivityLog = (data) =>
  FetchAPI(url.SEARCH_INVOICE_DRAFT_ACTIVITY_LOG, "POST", data);
//convertToInvoice
export const convertToInvoice = (data) =>
  FetchAPI(url.CONVERT_TO_INVOICE, "POST", data);

//Ecommerce
//createSalesOrderApi
export const createSalesOrderApi = (data) =>
  FetchAPI(url.CREATE_SALES_ORDER_API, "POST", data);
//postcodeLookupApi
export const postcodeLookupApi = (data) =>
  FetchAPI(url.POSTCODE_LOOKUP_API, "POST", data);
//getRenderEcommerceStoreApi
export const getRenderEcommerceStoreApi = (data) =>
  FetchAPI(url.GET_RENDER_ECOMMERCE_STORE_API, "GET", data);
//getProductCategoriesApi
export const getProductCategoriesApi = (data) =>
  FetchAPI(url.GET_PRODUCT_CATEGORIES_API, "GET", data);
//searchProductsByCategoryApi
export const searchProductsByCategoryApi = (data) =>
  FetchAPI(url.SEARCH_PRODUCTS_BY_CATEGORY_API, "POST", data);
//calculateShippingApi
export const calculateShippingApi = (data, urlExtension) =>
  FetchAPI(url.CALCULATE_SHIPPING_API, "POST", data, null, null, urlExtension);
//calculateOrderTotalApi
export const calculateOrderTotalApi = (data, urlExtension) =>
  FetchAPI(
    url.CALCULATE_ORDER_TOTAL_API,
    "POST",
    data,
    null,
    null,
    urlExtension
  );
//executeEcommerceStoreApi
export const executeEcommerceStoreApi = (data, urlExtension) =>
  FetchAPI(
    url.EXECUTE_ECOMMERCE_STORE_API,
    "POST",
    data,
    null,
    null,
    urlExtension
  );
//getEcommerceDeliverySlotsApi
export const getEcommerceDeliverySlotsApi = (data) =>
  FetchAPI(url.GET_ECOMMERCE_DELIVERY_SLOTS_API, "GET", data);
// Cron Schedules
//fetchMasterCronScheduleListOverdue
export const fetchMasterCronScheduleListOverdue = () =>
  FetchAPI(url.FETCH_MASTER_CRON_SCHEDULE_LIST_OVERDUE, "GET");
//fetchMasterCronScheduleList
export const fetchMasterCronScheduleList = () =>
  FetchAPI(url.FETCH_MASTER_CRON_SCHEDULE_LIST, "GET");
//fetchMasterCronScheduleRequestRun
export const fetchMasterCronScheduleRequestRun = (data) =>
  FetchAPI(url.FETCH_MASTER_CRON_SCHEDULE_REQUEST_RUN, "GET", data);
//fetchSmmPostChannelStatusListApi
export const fetchSmmPostChannelStatusListApi = () =>
  FetchAPI(url.FETCH_SMM_POST_CHANNEL_STATUS_LIST_API, "GET");
//fetchSmmPostChannelStatusDataApi
export const fetchSmmPostChannelStatusDataApi = (data) =>
  FetchAPI(url.FETCH_SMM_POST_CHANNEL_STATUS_DATA_API, "GET", data);
//createSmmPostChannelStatusApi
export const createSmmPostChannelStatusApi = (data) =>
  FetchAPI(url.CREATE_SMM_POST_CHANNEL_STATUS_API, "POST", data);
//updateSmmPostChannelStatusApi
export const updateSmmPostChannelStatusApi = (data) =>
  FetchAPI(url.UPDATE_SMM_POST_CHANNEL_STATUS_API, "PUT", data);
//deleteSmmPostChannelStatusApi
export const deleteSmmPostChannelStatusApi = (data) =>
  FetchAPI(url.DELETE_SMM_POST_CHANNEL_STATUS_API, "DELETE", data);
//fetchSmmPostListApi
export const fetchSmmPostListApi = () =>
  FetchAPI(url.FETCH_SMM_POST_LIST_API, "GET");
//fetchSmmPostDataApi
export const fetchSmmPostDataApi = (data) =>
  FetchAPI(url.FETCH_SMM_POST_DATA_API, "GET", data);
//createSmmPostApi
export const createSmmPostApi = (data) =>
  FetchAPI(url.CREATE_SMM_POST_API, "POST", data);
//updateSmmPostApi
export const updateSmmPostApi = (data) =>
  FetchAPI(url.UPDATE_SMM_POST_API, "PUT", data);
//deleteSmmPostApi
export const deleteSmmPostApi = (data) =>
  FetchAPI(url.DELETE_SMM_POST_API, "DELETE", data);
//getListMasterSocialMediaProviderApi
export const getListMasterSocialMediaProviderApi = () =>
  FetchAPI(url.GET_LIST_MASTER_SOCIAL_MEDIA_PROVIDER_API, "GET");
//getDataMasterSocialMediaProviderApi
export const getDataMasterSocialMediaProviderApi = (data) =>
  FetchAPI(url.GET_DATA_MASTER_SOCIAL_MEDIA_PROVIDER_API, "GET", data);
//createMasterSocialMediaProviderApi
export const createMasterSocialMediaProviderApi = (data) =>
  FetchAPI(url.CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_API, "POST", data);
//updateMasterSocialMediaProviderApi
export const updateMasterSocialMediaProviderApi = (data) =>
  FetchAPI(url.UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_API, "PUT", data);
//deleteMasterSocialMediaProviderApi
export const deleteMasterSocialMediaProviderApi = (data) =>
  FetchAPI(url.DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_API, "DELETE", data);
//getListMasterSocialMediaProfileApi
export const getListMasterSocialMediaProfileApi = () =>
  FetchAPI(url.GET_LIST_MASTER_SOCIAL_MEDIA_PROFILE_API, "GET");
//getDataMasterSocialMediaProfileApi
export const getDataMasterSocialMediaProfileApi = (data) =>
  FetchAPI(url.GET_DATA_MASTER_SOCIAL_MEDIA_PROFILE_API, "GET", data);
//createMasterSocialMediaProfileApi
export const createMasterSocialMediaProfileApi = (data) =>
  FetchAPI(url.CREATE_MASTER_SOCIAL_MEDIA_PROFILE_API, "POST", data);
//updateMasterSocialMediaProfileApi
export const updateMasterSocialMediaProfileApi = (data) =>
  FetchAPI(url.UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_API, "PUT", data);
//deleteMasterSocialMediaProfileApi
export const deleteMasterSocialMediaProfileApi = (data) =>
  FetchAPI(url.DELETE_MASTER_SOCIAL_MEDIA_PROFILE_API, "DELETE", data);
// Task 24873 - social channel connection
export const socialMediaConnectStartApi = (profileId) =>
  FetchAPI(`${url.SOCIAL_MEDIA_CONNECT_START_API}/${profileId}`, "GET");
export const socialMediaConnectCompleteApi = (data) =>
  FetchAPI(url.SOCIAL_MEDIA_CONNECT_COMPLETE_API, "POST", data);
export const socialMediaConnectAssignApi = (data) =>
  FetchAPI(url.SOCIAL_MEDIA_CONNECT_ASSIGN_API, "POST", data);
export const socialMediaConnectDisconnectApi = (data) =>
  FetchAPI(url.SOCIAL_MEDIA_CONNECT_DISCONNECT_API, "POST", data);
//generateSmmPostContentApi
export const generateSmmPostContentApi = (data) =>
  FetchAPI(url.GENERATE_SMM_POST_CONTENT_API, "POST", data);
//generateSmmPostImageApi
export const generateSmmPostImageApi = (data) =>
  FetchAPI(url.GENERATE_SMM_POST_IMAGE_API, "POST", data);
// Staff Planner
//fetchStaffPlannerList
export const fetchStaffPlannerList = () =>
  FetchAPI(url.FETCH_STAFF_PLANNER_LIST, "GET");
//fetchStaffPlannerData
export const fetchStaffPlannerData = (data) =>
  FetchAPI(url.FETCH_STAFF_PLANNER_DATA, "GET", data);
//createStaffPlanner
export const createStaffPlanner = (data) =>
  FetchAPI(url.CREATE_STAFF_PLANNER, "POST", data);
//updateStaffPlanner
export const updateStaffPlanner = (data) =>
  FetchAPI(url.UPDATE_STAFF_PLANNER, "PUT", data);
//deleteStaffPlanner
export const deleteStaffPlanner = (data) =>
  FetchAPI(url.DELETE_STAFF_PLANNER, "DELETE", data);
//searchStaffPlanner
export const searchStaffPlanner = (data) =>
  FetchAPI(url.SEARCH_STAFF_PLANNER, "POST", data);
//completeStaffPlanner
export const completeStaffPlanner = (data) =>
  FetchAPI(url.COMPLETE_STAFF_PLANNER, "POST", data);
//mergeJobApiCall
export const mergeJobApiCall = (data) => FetchAPI(url.MERGE_JOB, "POST", data);

export const uninvoicedStaffPlanner = (data) =>
  FetchAPI(url.UNINVOICED_STAFF_PLANNER, "POST", data);
//convertToInvoiceStaffPlanner
export const convertToInvoiceStaffPlanner = (data) =>
  FetchAPI(url.CONVERT_TO_INVOICE_STAFF_PLANNER, "POST", data);
//generateRecurrenceStaffPlanner
export const generateRecurrenceStaffPlanner = (data) =>
  FetchAPI(url.GENERATE_RECURRENCE_STAFF_PLANNER, "POST", data);
//fetchStaffPlannerStatusList
export const fetchStaffPlannerStatusList = () =>
  FetchAPI(url.FETCH_STAFF_PLANNER_STATUS_LIST, "GET");
//fetchStaffPlannerRecentActivity
export const fetchStaffPlannerRecentActivity = (data) =>
  FetchAPI(url.FETCH_STAFF_PLANNER_RECENT_ACTIVITY, "GET", data);
//fetchStaffPlannerAssignmentList
export const fetchStaffPlannerAssignmentList = () =>
  FetchAPI(url.FETCH_STAFF_PLANNER_ASSIGNMENT_LIST, "GET");
//fetchStaffPlannerAssignmentData
export const fetchStaffPlannerAssignmentData = (data) =>
  FetchAPI(url.FETCH_STAFF_PLANNER_ASSIGNMENT_DATA, "GET", data);
//createStaffPlannerAssignment
export const createStaffPlannerAssignment = (data) =>
  FetchAPI(url.CREATE_STAFF_PLANNER_ASSIGNMENT, "POST", data);
//updateStaffPlannerAssignment
export const updateStaffPlannerAssignment = (data) =>
  FetchAPI(url.UPDATE_STAFF_PLANNER_ASSIGNMENT, "PUT", data);
//deleteStaffPlannerAssignment
export const deleteStaffPlannerAssignment = (data) =>
  FetchAPI(url.DELETE_STAFF_PLANNER_ASSIGNMENT, "DELETE", data);
//assignStaffPlannerAssignment
export const assignStaffPlannerAssignment = (data) =>
  FetchAPI(url.ASSIGN_STAFF_PLANNER_ASSIGNMENT, "POST", data);
//unassignStaffPlannerAssignment
export const unassignStaffPlannerAssignment = (data) =>
  FetchAPI(url.UNASSIGN_STAFF_PLANNER_ASSIGNMENT, "POST", data);
//Leads
//callLeadTypeListApi
export const callLeadTypeListApi = () =>
  FetchAPI(url.CALL_LEAD_TYPE_LIST_API, "GET");
//callLeadTypeDataApi
export const callLeadTypeDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_TYPE_DATA_API, "GET", data);
//callLeadTypeCreateApi
export const callLeadTypeCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_TYPE_CREATE_API, "POST", data);
//callLeadTypeUpdateApi
export const callLeadTypeUpdateApi = (data) =>
  FetchAPI(url.CALL_LEAD_TYPE_UPDATE_API, "PUT", data);
//callLeadTypeDeleteApi
export const callLeadTypeDeleteApi = (data) =>
  FetchAPI(url.CALL_LEAD_TYPE_DELETE_API, "DELETE", data);
//callLeadStatusListApi
export const callLeadStatusListApi = () =>
  FetchAPI(url.CALL_LEAD_STATUS_LIST_API, "GET");
//callLeadStatusDataApi
export const callLeadStatusDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_STATUS_DATA_API, "GET", data);
//callLeadStatusCreateApi
export const callLeadStatusCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_STATUS_CREATE_API, "POST", data);
//callLeadStatusUpdateApi
export const callLeadStatusUpdateApi = (data) =>
  FetchAPI(url.CALL_LEAD_STATUS_UPDATE_API, "PUT", data);
//callLeadStatusDeleteApi
export const callLeadStatusDeleteApi = (data) =>
  FetchAPI(url.CALL_LEAD_STATUS_DELETE_API, "DELETE", data);
//callLeadPriorityListApi
export const callLeadPriorityListApi = () =>
  FetchAPI(url.CALL_LEAD_PRIORITY_LIST_API, "GET");
//callLeadPriorityDataApi
export const callLeadPriorityDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_PRIORITY_DATA_API, "GET", data);
//callLeadPriorityCreateApi
export const callLeadPriorityCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_PRIORITY_CREATE_API, "POST", data);
//callLeadPriorityUpdateApi
export const callLeadPriorityUpdateApi = (data) =>
  FetchAPI(url.CALL_LEAD_PRIORITY_UPDATE_API, "PUT", data);
//callLeadPriorityDeleteApi
export const callLeadPriorityDeleteApi = (data) =>
  FetchAPI(url.CALL_LEAD_PRIORITY_DELETE_API, "DELETE", data);
//callLeadNoteListApi
export const callLeadNoteListApi = (data) =>
  FetchAPI(url.CALL_LEAD_NOTE_LIST_API, "GET", data);
//callLeadNoteSearchApi
export const callLeadNoteSearchApi = (data) =>
  FetchAPI(url.CALL_LEAD_NOTE_SEARCH_API, "POST", data);
//callLeadNoteDataApi
export const callLeadNoteDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_NOTE_DATA_API, "GET", data);
//callLeadNoteCreateApi
export const callLeadNoteCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_NOTE_CREATE_API, "POST", data);
//callLeadListApi
export const callLeadListApi = () => FetchAPI(url.CALL_LEAD_LIST_API, "GET");
//callLeadListUninvoicedApi
export const callLeadListUninvoicedApi = () =>
  FetchAPI(url.CALL_LEAD_LIST_UNINVOICED_API, "GET");
//callLeadOverviewFunnelApi
export const callLeadOverviewFunnelApi = () =>
  FetchAPI(url.CALL_LEAD_OVERVIEW_FUNNEL_API, "GET");
//callLeadDataApi
export const callLeadDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_DATA_API, "GET", data);
//callLeadCreateApi
export const callLeadCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_CREATE_API, "POST", data);
//  callLeadUpdateApi
export const callLeadUpdateApi = (data) =>
  FetchAPI(url.CALL_LEAD_UPDATE_API, "PUT", data);
//callLeadDeleteApi
export const callLeadDeleteApi = (data) =>
  FetchAPI(url.CALL_LEAD_DELETE_API, "DELETE", data);
//callLeadSearchApi
export const callLeadSearchApi = (data) =>
  FetchAPI(url.CALL_LEAD_SEARCH_API, "POST", data);
//callLeadTaskSearchApi
export const callLeadTaskSearchApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_SEARCH_API, "POST", data);
//callLeadTaskCreateApi
export const callLeadTaskCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_CREATE_API, "POST", data);
// callLeadTaskTypeListApi,
export const callLeadTaskTypeListApi = () =>
  FetchAPI(url.CALL_LEAD_TASK_TYPE_LIST_API, "GET");
//   callLeadTaskTypeDataApi,
export const callLeadTaskTypeDataApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_TYPE_DATA_API, "GET", data);
//   callLeadTaskTypeCreateApi,
export const callLeadTaskTypeCreateApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_TYPE_CREATE_API, "POST", data);
//   callLeadTaskTypeUpdateApi,
export const callLeadTaskTypeUpdateApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_TYPE_UPDATE_API, "PUT", data);
//   callLeadTaskTypeDeleteApi,
export const callLeadTaskTypeDeleteApi = (data) =>
  FetchAPI(url.CALL_LEAD_TASK_TYPE_DELETE_API, "DELETE", data);
//callLeadRecentActivityListApi
export const callLeadRecentActivityListApi = (data) =>
  FetchAPI(url.CALL_LEAD_RECENT_ACTIVITY_LIST_API, "GET", data);
//Modules
//getSystemModuleListApiCall
export const getSystemModuleListApiCall = () =>
  FetchAPI(url.GET_SYSTEM_MODULE_LIST_API_CALL, "GET");
//getSystemModuleDataApiCall
export const getSystemModuleDataApiCall = (data) =>
  FetchAPI(url.GET_SYSTEM_MODULE_DATA_API_CALL, "GET", data);
//activateSystemModuleApiCall
export const activateSystemModuleApiCall = (data) =>
  FetchAPI(url.GET_ACTIVATE_MODULE_DATA_API_CALL, "GET", data);
//deactivateSystemModuleApiCall
export const deactivateSystemModuleApiCall = (data) =>
  FetchAPI(url.GET_DEACTIVATE_MODULE_DATA_API_CALL, "GET", data);
//createSystemModuleApiCall
export const createSystemModuleApiCall = (data) =>
  FetchAPI(url.CREATE_MODULE_API_CALL, "POST", data);
//updateSystemModuleApiCall
export const updateSystemModuleApiCall = (data) =>
  FetchAPI(url.UPDATE_MODULE_API_CALL, "PUT", data);
//deleteSystemModuleApiCall
export const deleteSystemModuleApiCall = (data) =>
  FetchAPI(url.DELETE_MODULE_API_CALL, "DELETE", data);

//POS SYSTEM
//getPosSystemRenderDataAPI
export const getPosSystemRenderDataAPI = (data) =>
  FetchAPI(url.GET_POS_SYSTEM_RENDER_DATA_API, "GET", data);
//getPosSystemListAPI
export const getPosSystemListAPI = () =>
  FetchAPI(url.GET_POS_SYSTEM_LIST_API, "GET");
//getPosSystemDataAPI
export const getPosSystemDataAPI = (data) =>
  FetchAPI(url.GET_POS_SYSTEM_DATA_API, "GET", data);
//createPosSystemAPI
export const createPosSystemAPI = (data) =>
  FetchAPI(url.CREATE_POS_SYSTEM_API, "POST", data);
//updatePosSystemAPI
export const updatePosSystemAPI = (data) =>
  FetchAPI(url.UPDATE_POS_SYSTEM_API, "PUT", data);
//deletePosSystemAPI
export const deletePosSystemAPI = (data) =>
  FetchAPI(url.DELETE_POS_SYSTEM_API, "DELETE", data);

// --- SystemDevice hardware (real POS devices: terminals, printers, card readers) ---
//getSystemDeviceHardwareListAPI
export const getSystemDeviceHardwareListAPI = () =>
  FetchAPI(url.SYSTEM_DEVICE_HW_LIST_API, "GET");
//getSystemDeviceHardwareDataAPI -> /systemdevice/data/{id}
export const getSystemDeviceHardwareDataAPI = (data) =>
  FetchAPI(url.SYSTEM_DEVICE_HW_DATA_API, "GET", data);
//getSystemDeviceReaderStatusAPI -> /systemdevice/readerstatus/{id}
export const getSystemDeviceReaderStatusAPI = (data) =>
  FetchAPI(url.SYSTEM_DEVICE_READER_STATUS_API, "GET", data);
//testSystemDeviceReaderAPI -> /systemdevice/testreader/{id}
export const testSystemDeviceReaderAPI = (data) =>
  FetchAPI(url.SYSTEM_DEVICE_TEST_READER_API, "POST", data);
//getPosSystemToUserListAPI
export const getPosSystemToUserListAPI = (data) =>
  FetchAPI(url.GET_POS_SYSTEM_TO_USER_LIST_API, "GET", data);
//getPosSystemToUserDataAPI
export const getPosSystemToUserDataAPI = (data) =>
  FetchAPI(url.GET_POS_SYSTEM_TO_USER_DATA_API, "GET", data);
//createPosSystemToUserAPI
export const createPosSystemToUserAPI = (data) =>
  FetchAPI(url.CREATE_POS_SYSTEM_TO_USER_API, "POST", data);
//updatePosSystemToUserAPI
export const updatePosSystemToUserAPI = (data) =>
  FetchAPI(url.UPDATE_POS_SYSTEM_TO_USER_API, "PUT", data);
//deletePosSystemToUserAPI
export const deletePosSystemToUserAPI = (data) =>
  FetchAPI(url.DELETE_POS_SYSTEM_TO_USER_API, "DELETE", data);
//POS ORDER
//getPosOrderListAPI
export const getPosOrderListAPI = () =>
  FetchAPI(url.GET_POS_ORDER_LIST_API, "GET");
//posOrderSearchAPI
export const posOrderSearchAPI = (data) =>
  FetchAPI(url.POS_ORDER_SEARCH_API, "POST", data);
//getPosOrderDataAPI
export const getPosOrderDataAPI = (data) =>
  FetchAPI(url.GET_POS_ORDER_DATA_API, "GET", data);
//createPosOrderAPI
export const createPosOrderAPI = (data) =>
  FetchAPI(url.CREATE_POS_ORDER_API, "POST", data);
//updatePosOrderAPI
export const updatePosOrderAPI = (data) =>
  FetchAPI(url.UPDATE_POS_ORDER_API, "PUT", data);
//deletePosOrderAPI
export const deletePosOrderAPI = (data) =>
  FetchAPI(url.DELETE_POS_ORDER_API, "DELETE", data);
//createPosOrderPaymentRequestAPI
export const createPosOrderPaymentRequestAPI = (data) =>
  FetchAPI(url.CREATE_POS_ORDER_PAYMENT_REQUEST_API, "POST", data);
//getPosSystemOverviewAPI
export const getPosSystemOverviewAPI = (data) =>
  FetchAPI(url.GET_POS_SYSTEM_OVERVIEW_API, "POST", data);
//voidPosOrderPaymentRequestAPI
export const voidPosOrderPaymentRequestAPI = (data) =>
  FetchAPI(url.VOID_POS_ORDER_PAYMENT_REQUEST_API, "POST", data);
//printPosOrderReceiptAPI
export const printPosOrderReceiptAPI = (data) =>
  FetchAPI(url.PRINT_POS_ORDER_RECEIPT_API, "POST", data);
//emailPosOrderReceiptAPI
export const emailPosOrderReceiptAPI = (data) =>
  FetchAPI(url.EMAIL_POS_ORDER_RECEIPT_API, "POST", data);
//refundPosOrderAPI
export const refundPosOrderAPI = (data) =>
  FetchAPI(url.REFUND_POS_ORDER_API, "POST", data);
// POS BILLING (Task 24246) - discounts, tenders, cash-up.
// GET list endpoints take filters as a query string (FetchAPI only auto-appends
// /{id}), so we build the query here; data/xreport/zreport pass { id } to append.
export const posOrderTenderAPI = (data) =>
  FetchAPI(url.POS_ORDER_TENDER_API, "POST", data);
export const getPosDiscountReasonListAPI = (posSystemId) =>
  FetchAPI(
    url.GET_POS_DISCOUNT_REASON_LIST_API +
      (posSystemId ? `?PosSystem_Id=${posSystemId}` : ""),
    "GET"
  );
export const createPosOrderDiscountAPI = (data) =>
  FetchAPI(url.CREATE_POS_ORDER_DISCOUNT_API, "POST", data);
export const getPosOrderDiscountListAPI = (posOrderId) =>
  FetchAPI(
    url.GET_POS_ORDER_DISCOUNT_LIST_API +
      (posOrderId ? `?PosOrder_Id=${posOrderId}` : ""),
    "GET"
  );
export const deletePosOrderDiscountAPI = (data) =>
  FetchAPI(url.DELETE_POS_ORDER_DISCOUNT_API, "DELETE", data);
export const openPosCashSessionAPI = (data) =>
  FetchAPI(url.OPEN_POS_CASH_SESSION_API, "POST", data);
export const closePosCashSessionAPI = (data) =>
  FetchAPI(url.CLOSE_POS_CASH_SESSION_API, "PUT", data);
export const getPosCashSessionListAPI = (params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return FetchAPI(url.GET_POS_CASH_SESSION_LIST_API + (q ? `?${q}` : ""), "GET");
};
export const getPosCashSessionDataAPI = (id) =>
  FetchAPI(url.GET_POS_CASH_SESSION_DATA_API, "GET", { id });
export const getPosCashSessionXReportAPI = (id) =>
  FetchAPI(url.GET_POS_CASH_SESSION_XREPORT_API, "GET", { id });
export const getPosCashSessionZReportAPI = (id) =>
  FetchAPI(url.GET_POS_CASH_SESSION_ZREPORT_API, "GET", { id });
export const createPosCashMovementAPI = (data) =>
  FetchAPI(url.CREATE_POS_CASH_MOVEMENT_API, "POST", data);
export const getPosCashMovementListAPI = (posCashSessionId) =>
  FetchAPI(
    url.GET_POS_CASH_MOVEMENT_LIST_API +
      (posCashSessionId ? `?PosCashSession_Id=${posCashSessionId}` : ""),
    "GET"
  );
// POS TABLE SERVICE + KDS (Task 24247)
export const getPosFloorPlanListAPI = (posSystemId) =>
  FetchAPI(
    url.GET_POS_FLOOR_PLAN_LIST_API +
      (posSystemId ? `?PosSystem_Id=${posSystemId}` : ""),
    "GET"
  );
export const createPosFloorPlanAPI = (data) =>
  FetchAPI(url.CREATE_POS_FLOOR_PLAN_API, "POST", data);
export const updatePosFloorPlanAPI = (data) =>
  FetchAPI(url.UPDATE_POS_FLOOR_PLAN_API, "PUT", data);
export const deletePosFloorPlanAPI = (data) =>
  FetchAPI(url.DELETE_POS_FLOOR_PLAN_API, "DELETE", data);
export const getPosFloorPlanTableListAPI = (posFloorPlanId) =>
  FetchAPI(
    url.GET_POS_FLOOR_PLAN_TABLE_LIST_API +
      (posFloorPlanId ? `?PosFloorPlan_Id=${posFloorPlanId}` : ""),
    "GET"
  );
export const createPosFloorPlanTableAPI = (data) =>
  FetchAPI(url.CREATE_POS_FLOOR_PLAN_TABLE_API, "POST", data);
export const updatePosFloorPlanTableAPI = (data) =>
  FetchAPI(url.UPDATE_POS_FLOOR_PLAN_TABLE_API, "PUT", data);
export const deletePosFloorPlanTableAPI = (data) =>
  FetchAPI(url.DELETE_POS_FLOOR_PLAN_TABLE_API, "DELETE", data);
export const posTableSeatAPI = (data) =>
  FetchAPI(url.POS_TABLE_SEAT_API, "POST", data);
export const posTableTransferAPI = (data) =>
  FetchAPI(url.POS_TABLE_TRANSFER_API, "POST", data);
export const posTableMergeAPI = (data) =>
  FetchAPI(url.POS_TABLE_MERGE_API, "POST", data);
export const posTableSplitAPI = (data) =>
  FetchAPI(url.POS_TABLE_SPLIT_API, "POST", data);
export const posTableClearAPI = (data) =>
  FetchAPI(url.POS_TABLE_CLEAR_API, "POST", data);
export const getPosCourseListAPI = (posSystemId) =>
  FetchAPI(
    url.GET_POS_COURSE_LIST_API +
      (posSystemId ? `?PosSystem_Id=${posSystemId}` : ""),
    "GET"
  );
export const posOrderFireAPI = (data) =>
  FetchAPI(url.POS_ORDER_FIRE_API, "POST", data);
export const getKdsTicketsAPI = (params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return FetchAPI(url.GET_KDS_TICKETS_API + (q ? `?${q}` : ""), "GET");
};
export const kdsTicketBumpAPI = (posOrderItemId) =>
  FetchAPI(`${url.KDS_TICKET_BUMP_API}/${posOrderItemId}/bump`, "POST", []);
export const kdsTicketRecallAPI = (posOrderItemId) =>
  FetchAPI(`${url.KDS_TICKET_RECALL_API}/${posOrderItemId}/recall`, "POST", []);
// POS OFFLINE SYNC (Task 24248)
export const posOrderSyncAPI = (data) =>
  FetchAPI(url.POS_ORDER_SYNC_API, "POST", data);
// POS CUSTOMER IDENTITY + HOUSE ACCOUNTS (Task 24249)
export const posCustomerContextAPI = (customerId) =>
  FetchAPI(url.POS_CUSTOMER_CONTEXT_API, "GET", { id: customerId });
export const posCustomerSetAPI = (data) =>
  FetchAPI(url.POS_CUSTOMER_SET_API, "POST", data);
export const posCustomerListAPI = () =>
  FetchAPI(url.POS_CUSTOMER_LIST_API, "GET");
// CUSTOMER LIVE LOOKUP (Task 24630). The term goes in the path, so it is
// encoded here - a postcode with a space or an email with a + would
// otherwise break the route.
export const getCustomerLookupAPI = (searchTerm, limit = 50) =>
  FetchAPI(
    `${url.GET_CUSTOMER_LOOKUP_API}/${encodeURIComponent(searchTerm)}?limit=${limit}`,
    "GET"
  );
// POS MENU INTELLIGENCE + PRICING + AI (Task 24250)
export const posAnalyticsMenuEngineeringAPI = (data) =>
  FetchAPI(url.POS_ANALYTICS_MENU_ENGINEERING_API, "POST", data);
export const posAnalyticsProfitAndLossAPI = (data) =>
  FetchAPI(url.POS_ANALYTICS_PL_API, "POST", data);
export const posMenuAiGenerateAPI = (data) =>
  FetchAPI(url.POS_MENU_AI_GENERATE_API, "POST", data);
export const posPriceRuleListAPI = (posSystemId) =>
  FetchAPI(
    url.POS_PRICE_RULE_LIST_API +
      (posSystemId ? `?PosSystem_Id=${posSystemId}` : ""),
    "GET"
  );
export const posPriceRuleCreateAPI = (data) =>
  FetchAPI(url.POS_PRICE_RULE_CREATE_API, "POST", data);
export const posPriceRuleUpdateAPI = (data) =>
  FetchAPI(url.POS_PRICE_RULE_UPDATE_API, "PUT", data);
export const posPriceRuleDeleteAPI = (data) =>
  FetchAPI(url.POS_PRICE_RULE_DELETE_API, "DELETE", data);
export const posPriceRuleResolveAPI = (data) =>
  FetchAPI(url.POS_PRICE_RULE_RESOLVE_API, "POST", data);
//Master
//getMasterHardwareCatalogList
export const getMasterHardwareCatalogList = () =>
  FetchAPI(url.GET_MASTER_HARDWARE_CATALOG_LIST, "GET");
//createMasterHardwareCatalog
export const createMasterHardwareCatalog = (data) =>
  FetchAPI(url.CREATE_MASTER_HARDWARE_CATALOG, "POST", data);
//updateMasterHardwareCatalog
export const updateMasterHardwareCatalog = (data) =>
  FetchAPI(url.UPDATE_MASTER_HARDWARE_CATALOG, "PUT", data);
//deleteMasterHardwareCatalog
export const deleteMasterHardwareCatalog = (data) =>
  FetchAPI(url.DELETE_MASTER_HARDWARE_CATALOG, "DELETE", data);
//Master Third Party Pricing
//getMasterThirdPartyPricingList
export const getMasterThirdPartyPricingList = () =>
  FetchAPI(url.GET_MASTER_THIRD_PARTY_PRICING_LIST, "GET");
//createMasterThirdPartyPricing
export const createMasterThirdPartyPricing = (data) =>
  FetchAPI(url.CREATE_MASTER_THIRD_PARTY_PRICING, "POST", data);
//updateMasterThirdPartyPricing
export const updateMasterThirdPartyPricing = (data) =>
  FetchAPI(url.UPDATE_MASTER_THIRD_PARTY_PRICING, "PUT", data);
//deleteMasterThirdPartyPricing
export const deleteMasterThirdPartyPricing = (data) =>
  FetchAPI(url.DELETE_MASTER_THIRD_PARTY_PRICING, "DELETE", data);
//Master SIM (emnify) management
export const getMasterSimList = () => FetchAPI(url.GET_MASTER_SIM_LIST, "GET");
export const getMasterSimData = (id) =>
  FetchAPI(`${url.GET_MASTER_SIM_DATA}/${id}`, "GET");
export const getMasterSimCompanies = () =>
  FetchAPI(url.GET_MASTER_SIM_COMPANIES, "GET");
export const getMasterSimStaff = (companyId) =>
  FetchAPI(`${url.GET_MASTER_SIM_STAFF}/${companyId}`, "GET");
// Change #100416 - emnify device pickers, and activate + device + link in one go
export const getMasterSimDeviceOptions = () =>
  FetchAPI(url.GET_MASTER_SIM_DEVICE_OPTIONS, "GET");
export const postMasterSimMakeLive = (data) =>
  FetchAPI(url.POST_MASTER_SIM_MAKE_LIVE, "POST", data);
// Change #100664 - eSIM activation code (drawn as a QR) and emailing it
export const getMasterSimEsimCode = (simId) =>
  FetchAPI(`${url.GET_MASTER_SIM_ESIM_CODE}/${simId}`, "GET");
export const postMasterSimEsimEmail = (data) =>
  FetchAPI(url.POST_MASTER_SIM_ESIM_EMAIL, "POST", data);
// Change #100665 / #100667 - refresh one SIM from emnify (live connectivity + usage)
export const getMasterSimLive = (simId) =>
  FetchAPI(`${url.GET_MASTER_SIM_LIVE}/${simId}`, "GET");
// Change #100666 - a company's own SIMs (read-only)
export const getCompanySimList = () => FetchAPI(url.GET_COMPANY_SIM_LIST, "GET");
export const getCompanySimLive = (simId) =>
  FetchAPI(`${url.GET_COMPANY_SIM_LIVE}/${simId}`, "GET");
export const getCompanySimStaff = () => FetchAPI(url.GET_COMPANY_SIM_STAFF, "GET");
export const postCompanySimAllocate = (data) =>
  FetchAPI(url.POST_COMPANY_SIM_ALLOCATE, "POST", data);
// Change #100668 - one user's sign-ins to this company
export const getUserSignInLogList = (userId) =>
  FetchAPI(`${url.GET_USER_SIGN_IN_LOG_LIST}/${userId}`, "GET");
export const createMasterSim = (data) =>
  FetchAPI(url.CREATE_MASTER_SIM, "POST", data);
export const updateMasterSim = (data) =>
  FetchAPI(url.UPDATE_MASTER_SIM, "PUT", data);
export const deleteMasterSim = (data) =>
  FetchAPI(url.DELETE_MASTER_SIM, "DELETE", data);
export const syncMasterSim = () => FetchAPI(url.SYNC_MASTER_SIM, "POST");
export const registerMasterSim = (data) =>
  FetchAPI(url.REGISTER_MASTER_SIM, "POST", data);
export const activateMasterSim = (data) =>
  FetchAPI(url.ACTIVATE_MASTER_SIM, "POST", data);
export const suspendMasterSim = (data) =>
  FetchAPI(url.SUSPEND_MASTER_SIM, "POST", data);
export const assignMasterSim = (data) =>
  FetchAPI(url.ASSIGN_MASTER_SIM, "POST", data);
export const unassignMasterSim = (data) =>
  FetchAPI(url.UNASSIGN_MASTER_SIM, "POST", data);
//Master System Server
//getMasterSystemServerList
export const getMasterSystemServerList = () =>
  FetchAPI(url.GET_MASTER_SYSTEM_SERVER_LIST, "GET");
//deployMasterSystemServer (data = { id } -> POST /mastersystemserver/deploy/:id)
export const deployMasterSystemServer = (data) =>
  FetchAPI(url.DEPLOY_MASTER_SYSTEM_SERVER, "POST", data);
//deployStatusMasterSystemServer (data = { id } -> GET /mastersystemserver/deploystatus/:id)
export const deployStatusMasterSystemServer = (data) =>
  FetchAPI(url.DEPLOY_STATUS_MASTER_SYSTEM_SERVER, "GET", data);
//envListMasterSystemServer (data = { id } -> GET /mastersystemserver/envlist/:id)
export const envListMasterSystemServer = (data) =>
  FetchAPI(url.ENV_LIST_MASTER_SYSTEM_SERVER, "GET", data);
//envSetMasterSystemServer (data = { Servers, Key, Value, Scope, Type }; no top-level id)
export const envSetMasterSystemServer = (data) =>
  FetchAPI(url.ENV_SET_MASTER_SYSTEM_SERVER, "POST", data);
//envDeleteMasterSystemServer (data = { Servers, Key })
export const envDeleteMasterSystemServer = (data) =>
  FetchAPI(url.ENV_DELETE_MASTER_SYSTEM_SERVER, "POST", data);
//envPreviewMasterSystemServer (data = { id } -> GET /mastersystemserver/envpreview/:id)
export const envPreviewMasterSystemServer = (data) =>
  FetchAPI(url.ENV_PREVIEW_MASTER_SYSTEM_SERVER, "GET", data);
//envPushMasterSystemServer (data = { Servers, Secrets, RemoveKeys }; no top-level id)
export const envPushMasterSystemServer = (data) =>
  FetchAPI(url.ENV_PUSH_MASTER_SYSTEM_SERVER, "POST", data);
//envImportMasterSystemServer (data = { id } -> POST /mastersystemserver/envimport/:id)
export const envImportMasterSystemServer = (data) =>
  FetchAPI(url.ENV_IMPORT_MASTER_SYSTEM_SERVER, "POST", data);
//MasterEnvVar table (Change #100749)
export const getMasterEnvVarList = () => FetchAPI(url.GET_MASTER_ENV_VAR_LIST, "GET");
export const createMasterEnvVar = (data) =>
  FetchAPI(url.CREATE_MASTER_ENV_VAR, "POST", data);
export const updateMasterEnvVar = (data) =>
  FetchAPI(url.UPDATE_MASTER_ENV_VAR, "PUT", data);
export const deleteMasterEnvVar = (data) =>
  FetchAPI(url.DELETE_MASTER_ENV_VAR, "DELETE", data);
export const createMasterEnvVarValue = (data) =>
  FetchAPI(url.CREATE_MASTER_ENV_VAR_VALUE, "POST", data);
export const updateMasterEnvVarValue = (data) =>
  FetchAPI(url.UPDATE_MASTER_ENV_VAR_VALUE, "PUT", data);
export const deleteMasterEnvVarValue = (data) =>
  FetchAPI(url.DELETE_MASTER_ENV_VAR_VALUE, "DELETE", data);

// ===================== Automation Engine =====================
// For id-in-path routes we interpolate the id into the URL (FetchAPI only
// auto-appends ids for GET/POST). Update payloads carry their own Id and are
// also sent as the body. GET-by-id / DELETE / POST-action calls send no body.

//scenarios
export const callAutomationScenarioListApi = () =>
  FetchAPI(url.CALL_AUTOMATION_SCENARIO_LIST_API, "GET");
export const callAutomationScenarioCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_SCENARIO_CREATE_API, "POST", data);
export const callAutomationScenarioUpdateApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_SCENARIO_UPDATE_API}/${data.Id}`,
    "PUT",
    data
  );
export const callAutomationScenarioDeleteApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_SCENARIO_DELETE_API}/${data.Id ?? data}`,
    "DELETE"
  );
export const callAutomationScenarioPublishApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_SCENARIO_PUBLISH_API}/${data.Id ?? data}`,
    "POST"
  );
export const callAutomationScenarioDuplicateApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_SCENARIO_DUPLICATE_API}/${data.Id ?? data}`,
    "POST"
  );
export const callAutomationScenarioDisableApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_SCENARIO_DISABLE_API}/${data.Id ?? data}`,
    "POST"
  );
export const callAutomationScenarioStatusListApi = () =>
  FetchAPI(url.CALL_AUTOMATION_SCENARIO_STATUS_LIST_API, "GET");

//canvas
export const callAutomationCanvasApi = (data) =>
  FetchAPI(`${url.CALL_AUTOMATION_CANVAS_API}/${data.Id ?? data}`, "GET");

//nodes
export const callAutomationNodeCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_NODE_DATA_API, "POST", data);
export const callAutomationNodeUpdateApi = (data) =>
  FetchAPI(`${url.CALL_AUTOMATION_NODE_DATA_API}/${data.Id}`, "PUT", data);
export const callAutomationNodeDeleteApi = (data) =>
  FetchAPI(`${url.CALL_AUTOMATION_NODE_DATA_API}/${data.Id ?? data}`, "DELETE");

//links
export const callAutomationLinkCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_LINK_DATA_API, "POST", data);
export const callAutomationLinkDeleteApi = (data) =>
  FetchAPI(`${url.CALL_AUTOMATION_LINK_DATA_API}/${data.Id ?? data}`, "DELETE");

//block config fields
export const callAutomationBlockConfigFieldsApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_BLOCK_API}/${data.Id ?? data}/configfields`,
    "GET"
  );

//node config
export const callAutomationNodeConfigSaveApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_NODE_CONFIG_DATA_API, "POST", data);
export const callAutomationNodeConfigDeleteApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_NODE_CONFIG_DATA_API}/${data.Id ?? data}`,
    "DELETE"
  );

//delay config
export const callAutomationDelayCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_DELAY_CONFIG_DATA_API, "POST", data);
export const callAutomationDelayUpdateApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_DELAY_CONFIG_DATA_API}/${data.Id}`,
    "PUT",
    data
  );

//condition groups
export const callAutomationConditionGroupCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_CONDITION_GROUP_DATA_API, "POST", data);
export const callAutomationConditionGroupUpdateApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_CONDITION_GROUP_DATA_API}/${data.Id}`,
    "PUT",
    data
  );
export const callAutomationConditionGroupDeleteApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_CONDITION_GROUP_DATA_API}/${data.Id ?? data}`,
    "DELETE"
  );

//condition rules
export const callAutomationConditionRuleCreateApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_CONDITION_RULE_DATA_API, "POST", data);
export const callAutomationConditionRuleUpdateApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_CONDITION_RULE_DATA_API}/${data.Id}`,
    "PUT",
    data
  );
export const callAutomationConditionRuleDeleteApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_CONDITION_RULE_DATA_API}/${data.Id ?? data}`,
    "DELETE"
  );

//executions
export const callAutomationExecutionListApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_EXECUTION_DATA_API}?scenario_id=${
      data.scenarioId ?? data
    }`,
    "GET"
  );
export const callAutomationExecutionDataApi = (data) =>
  FetchAPI(
    `${url.CALL_AUTOMATION_EXECUTION_DATA_API}/${data.Id ?? data}`,
    "GET"
  );
export const callAutomationExecutionTriggerApi = (data) =>
  FetchAPI(url.CALL_AUTOMATION_EXECUTION_DATA_API, "POST", data);
export const callAutomationExecutionStatusListApi = () =>
  FetchAPI(url.CALL_AUTOMATION_EXECUTION_STATUS_LIST_API, "GET");

//********************************************
//Reviews Centre
//Reviews
//getReviewListApi (newest first)
export const getReviewListApi = () => FetchAPI(url.REVIEW_LIST_API, "GET");
//getReviewDataApi (GET -> /review/data/{id}); pass { id }
export const getReviewDataApi = (data) =>
  FetchAPI(url.REVIEW_DATA_API, "GET", data);
//createReviewApi (array of objects)
export const createReviewApi = (data) =>
  FetchAPI(url.REVIEW_CREATE_API, "POST", data);
//updateReviewApi (array of objects)
export const updateReviewApi = (data) =>
  FetchAPI(url.REVIEW_UPDATE_API, "PUT", data);
//deleteReviewApi (array of IDs)
export const deleteReviewApi = (data) =>
  FetchAPI(url.REVIEW_DELETE_API, "DELETE", data);
//assignReviewToCustomerApi (array of objects; Customer_Id may be null to unassign)
export const assignReviewToCustomerApi = (data) =>
  FetchAPI(url.REVIEW_ASSIGN_CUSTOMER_API, "PUT", data);
//setReviewStatusApi (set status / assignee; array of objects)
export const setReviewStatusApi = (data) =>
  FetchAPI(url.REVIEW_STATUS_API, "PUT", data);
//replyReviewApi (array of objects)
export const replyReviewApi = (data) =>
  FetchAPI(url.REVIEW_REPLY_API, "PUT", data);
//Review Providers
//getReviewProvidersApi
export const getReviewProvidersApi = () =>
  FetchAPI(url.REVIEW_PROVIDERS_API, "GET");
//updateReviewProviderApi (array of objects)
export const updateReviewProviderApi = (data) =>
  FetchAPI(url.REVIEW_PROVIDER_UPDATE_API, "PUT", data);
//syncReviewGoogleApi (POST, no body -> { inserted, updated })
export const syncReviewGoogleApi = () =>
  FetchAPI(url.REVIEW_SYNC_GOOGLE_API, "POST");
//Review Status lanes
//getReviewStatusListApi
export const getReviewStatusListApi = () =>
  FetchAPI(url.REVIEW_STATUS_LIST_API, "GET");
//getReviewStatusDataApi (GET -> /reviewstatus/data/{id}); pass { id }
export const getReviewStatusDataApi = (data) =>
  FetchAPI(url.REVIEW_STATUS_DATA_API, "GET", data);
//createReviewStatusApi (array of objects)
export const createReviewStatusApi = (data) =>
  FetchAPI(url.REVIEW_STATUS_CREATE_API, "POST", data);
//updateReviewStatusApi (array of objects)
export const updateReviewStatusApi = (data) =>
  FetchAPI(url.REVIEW_STATUS_UPDATE_API, "PUT", data);
//deleteReviewStatusApi (array of IDs)
export const deleteReviewStatusApi = (data) =>
  FetchAPI(url.REVIEW_STATUS_DELETE_API, "DELETE", data);

/************************************************/
// Payroll Module API Calls
// List runs (optional TaxYear filter)
export const getPayrollRunListApiCall = (TaxYear) =>
  FetchAPI(
    TaxYear
      ? `${url.PAYROLL_LIST_API}?TaxYear=${TaxYear}`
      : url.PAYROLL_LIST_API,
    "GET"
  );

// Run detail by PayrollRun_Id
export const getPayrollRunDataApiCall = (PayrollRun_Id) =>
  FetchAPI(`${url.PAYROLL_DATA_API}/${PayrollRun_Id}`, "GET");

// Preview a run (no writes) — body is the envelope { PaymentDate, Notes, Items[] }
export const postPayrollCreatePreviewApiCall = (data) =>
  FetchAPI(url.PAYROLL_CREATE_PREVIEW_API, "POST", data);

// Preview the first item as a payslip PDF — same envelope
export const postPayrollCreatePreviewPdfApiCall = (data) =>
  FetchAPI(url.PAYROLL_CREATE_PREVIEW_PDF_API, "POST", data);

// Commit a run — identical envelope to preview; persists + queues HMRC
export const postPayrollCreateApiCall = (data) =>
  FetchAPI(url.PAYROLL_CREATE_API, "POST", data);

// Update a run (status / notes / payment date)
export const putPayrollUpdateApiCall = (data) =>
  FetchAPI(url.PAYROLL_UPDATE_API, "PUT", data);

// Soft-delete a run — body { PayrollRun_Id }
export const deletePayrollApiCall = (data) =>
  FetchAPI(url.PAYROLL_DELETE_API, "DELETE", data);

// Single payslip data by PayrollRunItem_Id
export const getPayrollPayslipDataApiCall = (PayrollRunItem_Id) =>
  FetchAPI(`${url.PAYROLL_PAYSLIP_DATA_API}/${PayrollRunItem_Id}`, "GET");

// Single payslip PDF by PayrollRunItem_Id
export const getPayrollPayslipPdfApiCall = (PayrollRunItem_Id) =>
  FetchAPI(`${url.PAYROLL_PAYSLIP_PDF_API}/${PayrollRunItem_Id}`, "GET");

// HMRC submission history for a run
export const getPayrollHmrcListApiCall = (PayrollRun_Id) =>
  FetchAPI(`${url.PAYROLL_HMRC_LIST_API}/${PayrollRun_Id}`, "GET");

// HMRC retry/submit — body { PayrollHmrcSubmission_Id }
export const postPayrollHmrcSubmitApiCall = (data) =>
  FetchAPI(url.PAYROLL_HMRC_SUBMIT_API, "POST", data);

// HMRC employer settings — save (only sent keys are saved)
export const postPayrollHmrcSettingsApiCall = (data) =>
  FetchAPI(url.PAYROLL_HMRC_SETTINGS_API, "POST", data);

// HMRC employer settings + allowance position — read (optional TaxYear)
export const getPayrollHmrcSettingsDataApiCall = (TaxYear) =>
  FetchAPI(
    TaxYear
      ? `${url.PAYROLL_HMRC_SETTINGS_DATA_API}?TaxYear=${TaxYear}`
      : url.PAYROLL_HMRC_SETTINGS_DATA_API,
    "GET"
  );

/************************************************/
// System Wallet (Master DB) Admin API Calls
// Wallets
export const getSystemWalletListApiCall = () =>
  FetchAPI(url.SYSTEM_WALLET_LIST_API, "GET");

export const getSystemWalletDataApiCall = (Company_Id) =>
  FetchAPI(`${url.SYSTEM_WALLET_DATA_API}/${Company_Id}`, "GET");

// PUT update — array of records keyed by Id (BalanceLocal/Company_Id stripped server-side)
export const updateSystemWalletApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_UPDATE_API, "PUT", data);

// Manual top-up now — { Company_Id, Amount, MasterPaymentCard_Id? }
export const topUpSystemWalletApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_TOPUP_API, "POST", data);

export const getSystemWalletTransactionsApiCall = (Company_Id) =>
  FetchAPI(`${url.SYSTEM_WALLET_TRANSACTIONS_API}/${Company_Id}`, "GET");

// Manual credit — { Company_Id, Amount, MasterSystemWalletTransactionType_Id, Description }
export const adjustSystemWalletApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_ADJUST_API, "POST", data);

// Customer-facing wallet (own company only — Company_Id resolved from the token)
export const getMyWalletApiCall = () =>
  FetchAPI(url.SYSTEM_WALLET_MY_DATA_API, "GET");
export const getMyWalletTransactionsApiCall = () =>
  FetchAPI(url.SYSTEM_WALLET_MY_TRANSACTIONS_API, "GET");
// Top-up own wallet — { Amount, MasterPaymentCard_Id? }
export const topUpMyWalletApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_MY_TOPUP_API, "POST", data);
// Update own wallet settings — flat object of editable settings (no top-level `id`)
export const updateMyWalletApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_MY_UPDATE_API, "PUT", data);

// Service types (CRUD)
export const getSystemWalletServiceTypeListApiCall = () =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_TYPE_LIST_API, "GET");
export const getSystemWalletServiceTypeDataApiCall = (id) =>
  FetchAPI(`${url.SYSTEM_WALLET_SERVICE_TYPE_DATA_API}/${id}`, "GET");
export const createSystemWalletServiceTypeApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_TYPE_CREATE_API, "POST", data);
export const updateSystemWalletServiceTypeApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_TYPE_UPDATE_API, "PUT", data);
export const deleteSystemWalletServiceTypeApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_TYPE_DELETE_API, "DELETE", data);

// Service rates (CRUD)
export const getSystemWalletServiceRateListApiCall = () =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_RATE_LIST_API, "GET");
export const getSystemWalletServiceRateDataApiCall = (id) =>
  FetchAPI(`${url.SYSTEM_WALLET_SERVICE_RATE_DATA_API}/${id}`, "GET");
export const createSystemWalletServiceRateApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_RATE_CREATE_API, "POST", data);
export const updateSystemWalletServiceRateApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_RATE_UPDATE_API, "PUT", data);
export const deleteSystemWalletServiceRateApiCall = (data) =>
  FetchAPI(url.SYSTEM_WALLET_SERVICE_RATE_DELETE_API, "DELETE", data);

// =====================================================================
// Wi-Fi Access / Guest Portal (R&D)
// =====================================================================
// --- wifiaccesspoint ---
export const getWifiAccessPointList = () =>
  FetchAPI(url.GET_WIFI_ACCESS_POINT_LIST, "GET");
export const getWifiAccessPointData = (data) =>
  FetchAPI(url.GET_WIFI_ACCESS_POINT_DATA, "GET", data);
export const postWifiAccessPointCreate = (data) =>
  FetchAPI(url.POST_WIFI_ACCESS_POINT_CREATE, "POST", data);
export const putWifiAccessPointUpdate = (data) =>
  FetchAPI(url.PUT_WIFI_ACCESS_POINT_UPDATE, "PUT", data);
export const deleteWifiAccessPointDelete = (data) =>
  FetchAPI(url.DELETE_WIFI_ACCESS_POINT_DELETE, "DELETE", data);

// --- wifiportalguestprofile ---
export const getWifiPortalGuestProfileList = () =>
  FetchAPI(url.GET_WIFI_PORTAL_GUEST_PROFILE_LIST, "GET");
export const getWifiPortalGuestProfileData = (data) =>
  FetchAPI(url.GET_WIFI_PORTAL_GUEST_PROFILE_DATA, "GET", data);
export const postWifiPortalGuestProfileCreate = (data) =>
  FetchAPI(url.POST_WIFI_PORTAL_GUEST_PROFILE_CREATE, "POST", data);
export const putWifiPortalGuestProfileUpdate = (data) =>
  FetchAPI(url.PUT_WIFI_PORTAL_GUEST_PROFILE_UPDATE, "PUT", data);
export const deleteWifiPortalGuestProfileDelete = (data) =>
  FetchAPI(url.DELETE_WIFI_PORTAL_GUEST_PROFILE_DELETE, "DELETE", data);

// --- wifisitelocation ---
export const getWifiSiteLocationList = () =>
  FetchAPI(url.GET_WIFI_SITE_LOCATION_LIST, "GET");
export const getWifiSiteLocationData = (data) =>
  FetchAPI(url.GET_WIFI_SITE_LOCATION_DATA, "GET", data);
export const postWifiSiteLocationCreate = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_CREATE, "POST", data);
export const putWifiSiteLocationUpdate = (data) =>
  FetchAPI(url.PUT_WIFI_SITE_LOCATION_UPDATE, "PUT", data);
export const deleteWifiSiteLocationDelete = (data) =>
  FetchAPI(url.DELETE_WIFI_SITE_LOCATION_DELETE, "DELETE", data);
export const postWifiSiteLocationUnifiTestConnection = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_UNIFI_TEST_CONNECTION, "POST", data);
export const postWifiSiteLocationUnifiSyncAps = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_UNIFI_SYNC_APS, "POST", data);
export const postWifiSiteLocationComoTestConnection = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_COMO_TEST_CONNECTION, "POST", data);

// --- wifiguestregistration (read + search) ---
export const getWifiGuestRegistrationList = () =>
  FetchAPI(url.GET_WIFI_GUEST_REGISTRATION_LIST, "GET");
export const getWifiGuestRegistrationData = (data) =>
  FetchAPI(url.GET_WIFI_GUEST_REGISTRATION_DATA, "GET", data);
export const postWifiGuestRegistrationSearch = (data) =>
  FetchAPI(url.POST_WIFI_GUEST_REGISTRATION_SEARCH, "POST", data);

// --- wifiportalerrorlog (read + search) ---
export const getWifiPortalErrorLogList = () =>
  FetchAPI(url.GET_WIFI_PORTAL_ERROR_LOG_LIST, "GET");
export const getWifiPortalErrorLogData = (data) =>
  FetchAPI(url.GET_WIFI_PORTAL_ERROR_LOG_DATA, "GET", data);
export const postWifiPortalErrorLogSearch = (data) =>
  FetchAPI(url.POST_WIFI_PORTAL_ERROR_LOG_SEARCH, "POST", data);

// --- wifisitelocationtowifiaccesspoint (link) ---
// list takes a ?WifiSiteLocation_Id= query param (endpoint still R&D/placeholder)
export const getWifiSiteLocationToApList = (data) =>
  FetchAPI(
    url.GET_WIFI_SITE_LOCATION_TO_AP_LIST +
      (data?.WifiSiteLocation_Id
        ? `?WifiSiteLocation_Id=${data.WifiSiteLocation_Id}`
        : ""),
    "GET"
  );
export const postWifiSiteLocationToApCreate = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_TO_AP_CREATE, "POST", data);
export const deleteWifiSiteLocationToApDelete = (data) =>
  FetchAPI(url.DELETE_WIFI_SITE_LOCATION_TO_AP_DELETE, "DELETE", data);

// =====================================================================
// SERP Rank Tracking
// =====================================================================
const serpQuery = (base, params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

// --- serpreport ---
export const getSerpReportList = () =>
  FetchAPI(url.GET_SERP_REPORT_LIST, "GET");
export const getSerpReportData = (data) =>
  FetchAPI(url.GET_SERP_REPORT_DATA, "GET", data); // data = { id }
export const createSerpReport = (data) =>
  FetchAPI(url.POST_SERP_REPORT_CREATE, "POST", data);
export const updateSerpReport = (data) =>
  FetchAPI(url.PUT_SERP_REPORT_UPDATE, "PUT", data);
export const deleteSerpReport = (data) =>
  FetchAPI(url.DELETE_SERP_REPORT_DELETE, "DELETE", data);
export const runSerpReport = (id) =>
  FetchAPI(`${url.POST_SERP_REPORT_RUN}/${id}`, "POST");
export const getSerpReportPdf = (data) =>
  FetchAPI(url.GET_SERP_REPORT_PDF, "GET", data); // data = { id }
export const getSerpReportSnapshotPdf = (id) =>
  FetchAPI(`${url.GET_SERP_REPORT_SNAPSHOT_PDF}/${id}`, "GET");
export const emailSerpReport = (data) =>
  FetchAPI(url.POST_SERP_REPORT_EMAIL, "POST", data);

// --- serpreportsearchitem (keywords) ---
export const getSerpItemList = (data) =>
  FetchAPI(
    serpQuery(url.GET_SERP_ITEM_LIST, { SerpReport_Id: data?.SerpReport_Id }),
    "GET"
  );
export const getSerpItemData = (data) =>
  FetchAPI(url.GET_SERP_ITEM_DATA, "GET", data);
export const createSerpItem = (data) =>
  FetchAPI(url.POST_SERP_ITEM_CREATE, "POST", data);
export const updateSerpItem = (data) =>
  FetchAPI(url.PUT_SERP_ITEM_UPDATE, "PUT", data);
export const deleteSerpItem = (data) =>
  FetchAPI(url.DELETE_SERP_ITEM_DELETE, "DELETE", data);

// --- serpreportsnapshot (runs) ---
export const getSerpSnapshotList = (data) =>
  FetchAPI(
    serpQuery(url.GET_SERP_SNAPSHOT_LIST, {
      SerpReport_Id: data?.SerpReport_Id,
    }),
    "GET"
  );
export const getSerpSnapshotData = (data) =>
  FetchAPI(url.GET_SERP_SNAPSHOT_DATA, "GET", data);
export const deleteSerpSnapshot = (data) =>
  FetchAPI(url.DELETE_SERP_SNAPSHOT_DELETE, "DELETE", data);

// --- serpreportsearchitemresult (positions) ---
export const getSerpResultBySnapshot = (data) =>
  FetchAPI(
    serpQuery(url.GET_SERP_RESULT_LIST, {
      SerpReportSnapshot_Id: data?.SerpReportSnapshot_Id,
    }),
    "GET"
  );
export const getSerpResultByItem = (data) =>
  FetchAPI(
    serpQuery(url.GET_SERP_RESULT_LIST, {
      SerpReportSearchItem_Id: data?.SerpReportSearchItem_Id,
    }),
    "GET"
  );
export const getSerpResultData = (data) =>
  FetchAPI(url.GET_SERP_RESULT_DATA, "GET", data);
export const getSerpResultOrganic = (id) =>
  FetchAPI(`${url.GET_SERP_RESULT_ORGANIC}/${id}`, "GET");

// ---------- callinbound (Twilio inbound calls) ----------
export const getCallInboundList = () =>
  FetchAPI(url.GET_CALL_INBOUND_LIST, "GET");
export const getCallInboundListByCustomer = (data) =>
  FetchAPI(url.GET_CALL_INBOUND_LIST_BY_CUSTOMER, "GET", data); // data = { id: customerId }
export const getCallInboundData = (data) =>
  FetchAPI(url.GET_CALL_INBOUND_DATA, "GET", data); // data = { id }
export const createCallInbound = (data) =>
  FetchAPI(url.POST_CALL_INBOUND_CREATE, "POST", data);
export const updateCallInbound = (data) =>
  FetchAPI(url.PUT_CALL_INBOUND_UPDATE, "PUT", data);
export const deleteCallInbound = (data) =>
  FetchAPI(url.DELETE_CALL_INBOUND_DELETE, "DELETE", data);

// =====================================================================
// Meeting AI (Notetaker)
// =====================================================================
// --- meetingrecording ---
export const getMeetingRecordingList = () =>
  FetchAPI(url.GET_MEETING_RECORDING_LIST, "GET");
export const getMeetingRecordingData = (data) =>
  FetchAPI(url.GET_MEETING_RECORDING_DATA, "GET", data); // data = { id }
// Single object payload. Safe past FetchAPI's POST id-append, which only fires
// on a lowercase `id` key — this payload has Customer_Id / Appointment_Id.
export const dispatchMeetingRecording = (data) =>
  FetchAPI(url.POST_MEETING_RECORDING_DISPATCH, "POST", data);
export const updateMeetingRecording = (data) =>
  FetchAPI(url.PUT_MEETING_RECORDING_UPDATE, "PUT", data); // data = [{ Id, ... }]
export const deleteMeetingRecording = (data) =>
  FetchAPI(url.DELETE_MEETING_RECORDING_DELETE, "DELETE", data); // data = [1, 2]
export const retrySummaryMeetingRecording = (id) =>
  FetchAPI(`${url.POST_MEETING_RECORDING_RETRY_SUMMARY}/${id}`, "POST", {});
export const syncMeetingRecording = (id) =>
  FetchAPI(`${url.POST_MEETING_RECORDING_SYNC}/${id}`, "POST", {});

// --- meetingrecording/settings ---
export const getMeetingRecordingSettings = () =>
  FetchAPI(url.GET_MEETING_RECORDING_SETTINGS, "GET");
export const updateMeetingRecordingSettings = (data) =>
  FetchAPI(url.PUT_MEETING_RECORDING_SETTINGS, "PUT", data);

// --- Staff Qualifications & Certifications --------------------------------

// Qualification catalog
export const getQualificationDefinitionListApi = () =>
  FetchAPI(url.GET_QUALIFICATION_DEFINITION_LIST, "GET");
export const getQualificationDefinitionDataApi = (data) =>
  FetchAPI(url.GET_QUALIFICATION_DEFINITION_DATA, "GET", data);
export const createQualificationDefinitionApi = (data) =>
  FetchAPI(url.CREATE_QUALIFICATION_DEFINITION, "POST", data);
export const updateQualificationDefinitionApi = (data) =>
  FetchAPI(url.UPDATE_QUALIFICATION_DEFINITION, "PUT", data);
export const deleteQualificationDefinitionApi = (data) =>
  FetchAPI(url.DELETE_QUALIFICATION_DEFINITION, "DELETE", data);

// Certification catalog
export const getCertificationDefinitionListApi = () =>
  FetchAPI(url.GET_CERTIFICATION_DEFINITION_LIST, "GET");
export const getCertificationDefinitionDataApi = (data) =>
  FetchAPI(url.GET_CERTIFICATION_DEFINITION_DATA, "GET", data);
export const createCertificationDefinitionApi = (data) =>
  FetchAPI(url.CREATE_CERTIFICATION_DEFINITION, "POST", data);
export const updateCertificationDefinitionApi = (data) =>
  FetchAPI(url.UPDATE_CERTIFICATION_DEFINITION, "PUT", data);
export const deleteCertificationDefinitionApi = (data) =>
  FetchAPI(url.DELETE_CERTIFICATION_DEFINITION, "DELETE", data);

// Staff qualifications ({ id } appends /{Staff_Id} on GET)
export const getStaffQualificationListApi = (data) =>
  FetchAPI(url.GET_STAFF_QUALIFICATION_LIST, "GET", data);
export const getStaffQualificationListAllApi = () =>
  FetchAPI(url.GET_STAFF_QUALIFICATION_LIST_ALL, "GET");
export const getStaffQualificationMatrixApi = () =>
  FetchAPI(url.GET_STAFF_QUALIFICATION_MATRIX, "GET");
export const getStaffQualificationDataApi = (data) =>
  FetchAPI(url.GET_STAFF_QUALIFICATION_DATA, "GET", data);
export const createStaffQualificationApi = (data) =>
  FetchAPI(url.CREATE_STAFF_QUALIFICATION, "POST", data);
export const updateStaffQualificationApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_QUALIFICATION, "PUT", data);
export const deleteStaffQualificationApi = (data) =>
  FetchAPI(url.DELETE_STAFF_QUALIFICATION, "DELETE", data);
export const attachStaffQualificationApi = (data) =>
  FetchAPI(url.ATTACH_STAFF_QUALIFICATION, "POST", data);
export const getStaffQualificationAttachmentsApi = (data) =>
  FetchAPI(url.GET_STAFF_QUALIFICATION_ATTACHMENTS, "GET", data);
export const detachStaffQualificationApi = (data) =>
  FetchAPI(url.DETACH_STAFF_QUALIFICATION, "DELETE", data);

// Staff certifications ({ id } appends /{Staff_Id} on GET)
export const getStaffCertificationListApi = (data) =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_LIST, "GET", data);
export const getStaffCertificationListAllApi = () =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_LIST_ALL, "GET");
export const getStaffCertificationMatrixApi = () =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_MATRIX, "GET");
export const getStaffCertificationDataApi = (data) =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_DATA, "GET", data);
export const createStaffCertificationApi = (data) =>
  FetchAPI(url.CREATE_STAFF_CERTIFICATION, "POST", data);
export const updateStaffCertificationApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_CERTIFICATION, "PUT", data);
export const deleteStaffCertificationApi = (data) =>
  FetchAPI(url.DELETE_STAFF_CERTIFICATION, "DELETE", data);
export const attachStaffCertificationApi = (data) =>
  FetchAPI(url.ATTACH_STAFF_CERTIFICATION, "POST", data);
export const getStaffCertificationAttachmentsApi = (data) =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_ATTACHMENTS, "GET", data);
export const detachStaffCertificationApi = (data) =>
  FetchAPI(url.DETACH_STAFF_CERTIFICATION, "DELETE", data);

// Staff certification logs ({ id } appends /{StaffCertification_Id} on GET)
export const getStaffCertificationLogListApi = (data) =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_LOG_LIST, "GET", data);
export const getStaffCertificationLogDataApi = (data) =>
  FetchAPI(url.GET_STAFF_CERTIFICATION_LOG_DATA, "GET", data);
export const createStaffCertificationLogApi = (data) =>
  FetchAPI(url.CREATE_STAFF_CERTIFICATION_LOG, "POST", data);
export const updateStaffCertificationLogApi = (data) =>
  FetchAPI(url.UPDATE_STAFF_CERTIFICATION_LOG, "PUT", data);
export const deleteStaffCertificationLogApi = (data) =>
  FetchAPI(url.DELETE_STAFF_CERTIFICATION_LOG, "DELETE", data);

// =====================================================================
// Customer Assets (Task 24274)
// =====================================================================

// Customer asset status (master)
export const getCustomerAssetStatusListApi = () =>
  FetchAPI(url.CUSTOMER_ASSET_STATUS_LIST_API, "GET");
export const createCustomerAssetStatusApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_STATUS_CREATE_API, "POST", data);
export const updateCustomerAssetStatusApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_STATUS_UPDATE_API, "PUT", data);
export const deleteCustomerAssetStatusApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_STATUS_DELETE_API, "DELETE", data);

// Asset attribute types (master) - Task 24313
export const getAssetAttributeTypeListApi = () =>
  FetchAPI(url.ASSET_ATTRIBUTE_TYPE_LIST_API, "GET");
export const createAssetAttributeTypeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_TYPE_CREATE_API, "POST", data);
export const updateAssetAttributeTypeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_TYPE_UPDATE_API, "PUT", data);
export const deleteAssetAttributeTypeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_TYPE_DELETE_API, "DELETE", data);

// Asset attributes (search filters by { assetattribute_data: {...} })
export const searchAssetAttributeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_SEARCH_API, "POST", data);
export const createAssetAttributeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_CREATE_API, "POST", data);
export const updateAssetAttributeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_UPDATE_API, "PUT", data);
export const deleteAssetAttributeApi = (data) =>
  FetchAPI(url.ASSET_ATTRIBUTE_DELETE_API, "DELETE", data);

// Customer asset attribute types (master)
export const getCustomerAssetAttributeTypeListApi = () =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_TYPE_LIST_API, "GET");
export const createCustomerAssetAttributeTypeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_TYPE_CREATE_API, "POST", data);
export const updateCustomerAssetAttributeTypeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_TYPE_UPDATE_API, "PUT", data);
export const deleteCustomerAssetAttributeTypeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_TYPE_DELETE_API, "DELETE", data);

// Customer assets (search filters by { customerasset_data: { Customer_Id } })
export const searchCustomerAssetApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_SEARCH_API, "POST", data);
export const getCustomerAssetDataApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_DATA_API, "GET", data);
export const createCustomerAssetApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_CREATE_API, "POST", data);
export const updateCustomerAssetApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_UPDATE_API, "PUT", data);
export const deleteCustomerAssetApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_DELETE_API, "DELETE", data);

// Customer asset attributes (search filters by { customerassetattribute_data: {...} })
export const searchCustomerAssetAttributeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_SEARCH_API, "POST", data);
export const createCustomerAssetAttributeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_CREATE_API, "POST", data);
export const updateCustomerAssetAttributeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_UPDATE_API, "PUT", data);
export const deleteCustomerAssetAttributeApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_ATTRIBUTE_DELETE_API, "DELETE", data);

// Customer asset notes (Task 24274)
export const searchCustomerAssetNoteApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_NOTE_SEARCH_API, "POST", data);
export const createCustomerAssetNoteApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_NOTE_CREATE_API, "POST", data);
export const updateCustomerAssetNoteApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_NOTE_UPDATE_API, "PUT", data);
export const deleteCustomerAssetNoteApi = (data) =>
  FetchAPI(url.CUSTOMER_ASSET_NOTE_DELETE_API, "DELETE", data);

// Staff leave notes (Task 24594)
export const searchStaffLeaveNoteApi = (data) =>
  FetchAPI(url.STAFF_LEAVE_NOTE_SEARCH_API, "POST", data);
export const createStaffLeaveNoteApi = (data) =>
  FetchAPI(url.STAFF_LEAVE_NOTE_CREATE_API, "POST", data);
export const updateStaffLeaveNoteApi = (data) =>
  FetchAPI(url.STAFF_LEAVE_NOTE_UPDATE_API, "PUT", data);
export const deleteStaffLeaveNoteApi = (data) =>
  FetchAPI(url.STAFF_LEAVE_NOTE_DELETE_API, "DELETE", data);

// Staff job roles (Task 24600)
export const searchStaffJobRoleApi = (data) =>
  FetchAPI(url.STAFF_JOB_ROLE_SEARCH_API, "POST", data);
export const createStaffJobRoleApi = (data) =>
  FetchAPI(url.STAFF_JOB_ROLE_CREATE_API, "POST", data);
export const updateStaffJobRoleApi = (data) =>
  FetchAPI(url.STAFF_JOB_ROLE_UPDATE_API, "PUT", data);
export const deleteStaffJobRoleApi = (data) =>
  FetchAPI(url.STAFF_JOB_ROLE_DELETE_API, "DELETE", data);

//******************** Gift Voucher (CRMit Task 24310)
export const giftVoucherListApi = () =>
  FetchAPI(url.GIFT_VOUCHER_LIST_API, "GET");
export const giftVoucherDataApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_DATA_API, "GET", data);
export const giftVoucherCreateApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_CREATE_API, "POST", data);
export const giftVoucherUpdateApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_UPDATE_API, "PUT", data);
export const giftVoucherDeleteApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_DELETE_API, "DELETE", data);
export const giftVoucherSearchApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_SEARCH_API, "POST", data);
export const giftVoucherRedeemApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_REDEEM_API, "POST", data);
export const giftVoucherVoidApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_VOID_API, "POST", data);
export const giftVoucherResendEmailApi = (data) =>
  FetchAPI(url.GIFT_VOUCHER_RESEND_EMAIL_API, "POST", data);

// Database Delta Manager (Super Admin). `execute` sends `Id` (capital I) so
// FetchAPI's lowercase-`id` URL-append never fires - the delta id belongs in the
// body, not the path.
export const masterDatabaseDeltaListApiCall = () =>
  FetchAPI(url.MASTER_DATABASE_DELTA_LIST_API, "GET");
export const masterDatabaseDeltaDataApiCall = (id) =>
  FetchAPI(`${url.MASTER_DATABASE_DELTA_DATA_API}/${id}`, "GET");
export const masterDatabaseDeltaRunListApiCall = (id) =>
  FetchAPI(`${url.MASTER_DATABASE_DELTA_RUN_LIST_API}/${id}`, "GET");
export const masterDatabaseDeltaCreateApiCall = (data) =>
  FetchAPI(url.MASTER_DATABASE_DELTA_CREATE_API, "POST", data);
export const masterDatabaseDeltaUpdateApiCall = (data) =>
  FetchAPI(url.MASTER_DATABASE_DELTA_UPDATE_API, "PUT", data);
export const masterDatabaseDeltaArchiveApiCall = (data) =>
  FetchAPI(url.MASTER_DATABASE_DELTA_ARCHIVE_API, "PUT", data);
export const masterDatabaseDeltaDeleteApiCall = (data) =>
  FetchAPI(url.MASTER_DATABASE_DELTA_DELETE_API, "DELETE", data);
export const masterDatabaseDeltaExecuteApiCall = (data) =>
  FetchAPI(url.MASTER_DATABASE_DELTA_EXECUTE_API, "POST", data);

// Server Errors (Super Admin, Task 24900). Bodies carry `Id` (capital I) so
// FetchAPI never appends it to the URL.
export const serverErrorLogListApiCall = () =>
  FetchAPI(url.SERVER_ERROR_LOG_LIST_API, "GET");
export const serverErrorLogDataApiCall = (id) =>
  FetchAPI(`${url.SERVER_ERROR_LOG_DATA_API}/${id}`, "GET");
export const serverErrorLogSearchApiCall = (data) =>
  FetchAPI(url.SERVER_ERROR_LOG_SEARCH_API, "POST", data);
export const serverErrorLogResolveApiCall = (data) =>
  FetchAPI(url.SERVER_ERROR_LOG_RESOLVE_API, "PUT", data);
export const serverErrorLogCreateTaskApiCall = (data) =>
  FetchAPI(url.SERVER_ERROR_LOG_CREATE_TASK_API, "POST", data);
// Task 24905 - archive, and restore with FlagArchived: 0.
export const serverErrorLogArchiveApiCall = (data) =>
  FetchAPI(url.SERVER_ERROR_LOG_ARCHIVE_API, "PUT", data);

// Auth Failures (Super Admin, Change #100539).
export const authFailureLogSummaryApiCall = (data) =>
  FetchAPI(url.AUTH_FAILURE_LOG_SUMMARY_API, "POST", data);
export const authFailureLogDataApiCall = (groupKey) =>
  FetchAPI(`${url.AUTH_FAILURE_LOG_DATA_API}/${groupKey}`, "GET");

// System Changes (Super Admin, Task 24912). Bodies carry `Id` (capital I) so
// FetchAPI never appends it to the URL.
export const systemChangeListApiCall = () =>
  FetchAPI(url.SYSTEM_CHANGE_LIST_API, "GET");
export const systemChangeDataApiCall = (id) =>
  FetchAPI(`${url.SYSTEM_CHANGE_DATA_API}/${id}`, "GET");
export const systemChangeSearchApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_SEARCH_API, "POST", data);
export const systemChangeCreateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_CREATE_API, "POST", data);
export const systemChangeUpdateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_UPDATE_API, "PUT", data);
export const systemChangeDeleteApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_DELETE_API, "DELETE", data);
export const systemChangeAssignBundleApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_ASSIGN_BUNDLE_API, "PUT", data);
export const systemChangeSyncApiCall = () =>
  FetchAPI(url.SYSTEM_CHANGE_SYNC_API, "POST", []);
export const systemChangeNoteCreateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_NOTE_CREATE_API, "POST", data);
export const systemChangeNoteDeleteApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_NOTE_DELETE_API, "DELETE", data);
// Change #100029 - connect a Stripe account's feeds to a bank account.
export const bankAccountFeedConnectStripeApiCall = (data) =>
  FetchAPI(url.BANK_ACCOUNT_FEED_CONNECT_STRIPE_API, "POST", data);
// Change #100040 - re-read a purchase draft's document with AI.
export const purchaseDraftReprocessApiCall = (data) =>
  FetchAPI(url.PURCHASE_DRAFT_REPROCESS_API, "POST", data);
// Change #100031 - run a feed's sync now.
export const bankAccountFeedSyncNowApiCall = (data) =>
  FetchAPI(url.BANK_ACCOUNT_FEED_SYNC_NOW_API, "POST", data);
// Change #100028 - companies / users a change affects.
export const systemChangeAffectedCreateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_AFFECTED_CREATE_API, "POST", data);
export const systemChangeAffectedUpdateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_AFFECTED_UPDATE_API, "PUT", data);
export const systemChangeAffectedDeleteApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_AFFECTED_DELETE_API, "DELETE", data);
export const systemChangeAffectedLookupApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_AFFECTED_LOOKUP_API, "POST", data);
export const systemChangeAttachmentPreauthApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_ATTACHMENT_PREAUTH_API, "POST", data);
export const systemChangeAttachmentDeleteApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_ATTACHMENT_DELETE_API, "DELETE", data);
export const systemChangeBundleListApiCall = () =>
  FetchAPI(url.SYSTEM_CHANGE_BUNDLE_LIST_API, "GET");
export const systemChangeBundleDataApiCall = (id) =>
  FetchAPI(`${url.SYSTEM_CHANGE_BUNDLE_DATA_API}/${id}`, "GET");
export const systemChangeBundleCreateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_BUNDLE_CREATE_API, "POST", data);
export const systemChangeBundleUpdateApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_BUNDLE_UPDATE_API, "PUT", data);
export const systemChangeBundleDeleteApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_BUNDLE_DELETE_API, "DELETE", data);
export const systemChangeBundleReleaseApiCall = (data) =>
  FetchAPI(url.SYSTEM_CHANGE_BUNDLE_RELEASE_API, "PUT", data);
// kind: "status" | "type" | "priority"
export const systemChangeLookupApiCall = (kind, action, data) =>
  FetchAPI(
    url.SYSTEM_CHANGE_LOOKUP_API(kind, action),
    { list: "GET", create: "POST", update: "PUT", delete: "DELETE" }[action],
    data
  );

// Developer access (Super Admin > Users & Access > Developers, Task 24434).
// `update` sends User_Id, never a lowercase `id`, so FetchAPI's id-to-URL
// append never fires - the target user belongs in the body.
export const developerAccessListApiCall = () =>
  FetchAPI(url.DEVELOPER_ACCESS_LIST_API, "GET");
export const developerAccessSearchApiCall = (data) =>
  FetchAPI(url.DEVELOPER_ACCESS_SEARCH_API, "POST", data);
export const developerAccessUpdateApiCall = (data) =>
  FetchAPI(url.DEVELOPER_ACCESS_UPDATE_API, "PUT", data);

// ===== Product Category (Task 24745) =====
// list = flat, each row carrying ZPath / ZDepth / ZProductCount (what a picker
// wants); tree = the same rows nested (what the management screen wants).
export const getProductCategoryListApiCall = () =>
  FetchAPI(url.GET_PRODUCT_CATEGORY_LIST_API, "GET");
export const getProductCategoryTreeApiCall = () =>
  FetchAPI(url.GET_PRODUCT_CATEGORY_TREE_API, "GET");
export const createProductCategoryApiCall = (data) =>
  FetchAPI(url.CREATE_PRODUCT_CATEGORY_API, "POST", data);
export const updateProductCategoryApiCall = (data) =>
  FetchAPI(url.UPDATE_PRODUCT_CATEGORY_API, "PUT", data);
export const deleteProductCategoryApiCall = (data) =>
  FetchAPI(url.DELETE_PRODUCT_CATEGORY_API, "DELETE", data);
// Bulk re-categorise: { ProductCategory_Id, Product_Id: [...] }. A null or ""
// category clears it on those products.
export const assignProductsToCategoryApiCall = (data) =>
  FetchAPI(url.ASSIGN_PRODUCTS_TO_CATEGORY_API, "PUT", data);

// Customer known names (Task 24758) - alternative names a customer is known
// by, which the global search also matches on.
export const searchCustomerKnownNameApiCall = (data) =>
  FetchAPI(url.SEARCH_CUSTOMER_KNOWN_NAME_API, "POST", data);
export const createCustomerKnownNameApiCall = (data) =>
  FetchAPI(url.CREATE_CUSTOMER_KNOWN_NAME_API, "POST", data);
export const updateCustomerKnownNameApiCall = (data) =>
  FetchAPI(url.UPDATE_CUSTOMER_KNOWN_NAME_API, "PUT", data);
export const deleteCustomerKnownNameApiCall = (data) =>
  FetchAPI(url.DELETE_CUSTOMER_KNOWN_NAME_API, "DELETE", data);

// Task 24754 - StaffAvailability rows for given staff over a date range.
// Body: [{ staffavailability_data: { Staff_Id, StartDateTime, EndDateTime,
// FlagAvailable } }]. Staff_Id takes one id or an array.
export const searchStaffAvailabilityRowsApiCall = (data) =>
  FetchAPI(url.SEARCH_STAFF_AVAILABILITY_ROWS, "POST", data);

// Task 24769 - StaffIncomeStatus list.
export const getStaffIncomeStatusListApiCall = () =>
  FetchAPI(url.GET_STAFF_INCOME_STATUS_LIST_API, "GET");
// Change #100129 - copy a Wi-Fi site location
export const wifiSiteCloneApiCall = (data) =>
  FetchAPI(url.POST_WIFI_SITE_LOCATION_CLONE, "POST", data);
// Change #100136 - guest portal profile preview (returns { html })
export const wifiProfilePreviewApiCall = (data) =>
  FetchAPI(url.POST_WIFI_PORTAL_GUEST_PROFILE_PREVIEW, "POST", data);

// Change #100130 - Staff Attendance
export const staffAttendanceReportApiCall = (data) =>
  FetchAPI(url.STAFF_ATTENDANCE_REPORT_API, "POST", data);
export const getStaffAttendanceSettingsApiCall = () =>
  FetchAPI(url.STAFF_ATTENDANCE_SETTINGS_API, "GET");
export const saveStaffAttendanceSettingsApiCall = (data) =>
  FetchAPI(url.STAFF_ATTENDANCE_SETTINGS_API, "PUT", data);
// Change #100130 - fix a clock record (manager of the staff member or Administrator only)
export const staffClockRecordCreateApiCall = (data) =>
  FetchAPI(url.STAFF_CLOCK_RECORD_CREATE_API, "POST", data);
export const staffClockRecordUpdateApiCall = (data) =>
  FetchAPI(url.STAFF_CLOCK_RECORD_UPDATE_API, "PUT", data);
// FetchAPI never appends an id to a DELETE, so it goes in the path here; the
// body carries the optional CorrectionReason.
export const staffClockRecordDeleteApiCall = (staffClockRecordId, data) =>
  FetchAPI(`${url.STAFF_CLOCK_RECORD_DELETE_API}/${staffClockRecordId}`, "DELETE", data);
// Change #100162 - staff notes
export const staffNoteListApiCall = (staffId) =>
  FetchAPI(`${url.STAFF_NOTE_LIST_API}/${staffId}`, "GET", null);
export const staffNoteCreateApiCall = (data) =>
  FetchAPI(url.STAFF_NOTE_CREATE_API, "POST", data);
export const staffNoteUpdateApiCall = (data) =>
  FetchAPI(url.STAFF_NOTE_UPDATE_API, "PUT", data);
export const staffNoteDeleteApiCall = (data) =>
  FetchAPI(url.STAFF_NOTE_DELETE_API, "DELETE", data);
// Change #100165 - ignore / un-ignore one staff member's attendance day
export const staffAttendanceExcuseApiCall = (data) =>
  FetchAPI(url.STAFF_ATTENDANCE_EXCUSE_API, "POST", data);
export const staffAttendanceUnexcuseApiCall = (data) =>
  FetchAPI(url.STAFF_ATTENDANCE_UNEXCUSE_API, "POST", data);
// Change #100167 - product forms
export const listProductToFormApi = (Product_Id) =>
  FetchAPI(`${url.PRODUCT_TO_FORM_LIST_API}/${Product_Id}`, "GET", null);
// Change #100715 - the products a form is on
export const listFormProductsApi = (Form_Id) =>
  FetchAPI(`${url.PRODUCT_TO_FORM_FORM_LIST_API}/${Form_Id}`, "GET", null);
export const createProductToFormApi = (data) =>
  FetchAPI(url.PRODUCT_TO_FORM_CREATE_API, "POST", data);
export const updateProductToFormApi = (data) =>
  FetchAPI(url.PRODUCT_TO_FORM_UPDATE_API, "PUT", data);
export const deleteProductToFormApi = (data) =>
  FetchAPI(url.PRODUCT_TO_FORM_DELETE_API, "DELETE", data);
// Change #100550 - product staff skill sets
export const listProductToStaffSkillsetApi = (Product_Id) =>
  FetchAPI(`${url.PRODUCT_TO_STAFF_SKILLSET_LIST_API}/${Product_Id}`, "GET", null);
export const createProductToStaffSkillsetApi = (data) =>
  FetchAPI(url.PRODUCT_TO_STAFF_SKILLSET_CREATE_API, "POST", data);
export const updateProductToStaffSkillsetApi = (data) =>
  FetchAPI(url.PRODUCT_TO_STAFF_SKILLSET_UPDATE_API, "PUT", data);
export const deleteProductToStaffSkillsetApi = (data) =>
  FetchAPI(url.PRODUCT_TO_STAFF_SKILLSET_DELETE_API, "DELETE", data);
// Change #100198
export const diarySlotByProductApi = (productId) =>
  FetchAPI(`${url.DIARY_SLOT_BY_PRODUCT_API}/${productId}`, "GET", null);
// Change #100206
export const jobInvoiceItemAiGenerateApiCall = (data) =>
  FetchAPI(url.JOB_INVOICE_ITEM_AI_GENERATE_API, "POST", data);
// Change #100422 - AI title / description for an invoice line, from its job
export const invoiceItemAiGenerateApiCall = (data) =>
  FetchAPI(url.INVOICE_ITEM_AI_GENERATE_API, "POST", data);
// Change #100450 - one-off schedule changes (overtime / time off)
export const staffScheduleAdjustmentListApi = (staffId, dateFrom) =>
  FetchAPI(
    `${url.STAFF_WORKING_SCHEDULE_ADJUSTMENT_LIST_API}?Staff_Id=${encodeURIComponent(staffId)}${
      dateFrom ? `&DateFrom=${encodeURIComponent(dateFrom)}` : ""
    }`,
    "GET",
    null
  );
export const staffScheduleAdjustmentCreateApi = (data) =>
  FetchAPI(url.STAFF_WORKING_SCHEDULE_ADJUSTMENT_CREATE_API, "POST", data);
export const staffScheduleAdjustmentUpdateApi = (data) =>
  FetchAPI(url.STAFF_WORKING_SCHEDULE_ADJUSTMENT_UPDATE_API, "PUT", data);
export const staffScheduleAdjustmentDeleteApi = (data) =>
  FetchAPI(url.STAFF_WORKING_SCHEDULE_ADJUSTMENT_DELETE_API, "DELETE", data);
// Change #100461 - which diary actions the signed-in user may take
export const diarySlotPermissionsApi = () =>
  FetchAPI(url.DIARY_SLOT_PERMISSIONS_API, "GET", null);
// Change #100462 - Enterprise billing
export const subscriptionLicenceBillingApi = () =>
  FetchAPI(url.SUBSCRIPTION_LICENCE_BILLING_API, "GET", null);
// Change #100463 - Enterprise seat for an existing member; every licence the company has had
export const subscriptionLicenceSeatCompanyApi = (data) =>
  FetchAPI(url.SUBSCRIPTION_LICENCE_SEAT_COMPANY_API, "POST", data);
export const subscriptionLicenceAssignBulkApi = (data) =>
  FetchAPI(url.SUBSCRIPTION_LICENCE_ASSIGN_BULK_API, "POST", data);
export const subscriptionLicenceBoltonsApi = () =>
  FetchAPI(url.SUBSCRIPTION_LICENCE_BOLTONS_API, "GET", null);
export const subscriptionLicenceListCompanyAllApi = () =>
  FetchAPI(url.SUBSCRIPTION_LICENCE_LIST_COMPANY_ALL_API, "GET", null);
export const enterprisePlanAdminListApi = () =>
  FetchAPI(url.ENTERPRISE_PLAN_ADMIN_LIST_API, "GET", null);
export const enterprisePlanAdminUpdateApi = (data) =>
  FetchAPI(url.ENTERPRISE_PLAN_ADMIN_UPDATE_API, "PUT", data);
export const enterprisePlanAdminSetModeApi = (data) =>
  FetchAPI(url.ENTERPRISE_PLAN_ADMIN_SETMODE_API, "PUT", data);
export const enterprisePlanAdminCompanyApi = (companyId) =>
  FetchAPI(url.ENTERPRISE_PLAN_ADMIN_COMPANY_API + companyId, "GET", null);
export const licenceEnforcementAdminListApi = () =>
  FetchAPI(url.LICENCE_ENFORCEMENT_ADMIN_LIST_API, "GET", null);
export const licenceEnforcementAdminUpdateApi = (data) =>
  FetchAPI(url.LICENCE_ENFORCEMENT_ADMIN_UPDATE_API, "PUT", data);
